// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file smg_service.proto (package qb.smg, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_api_annotations } from "./google/api/annotations_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file smg_service.proto.
 */
export const file_smg_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_api_annotations]);

/**
 * *
 * Represents a bet placed by a player in a tournament.
 *
 * @generated from message qb.smg.TournamentPlayerBet
 */
export type TournamentPlayerBet = Message<"qb.smg.TournamentPlayerBet"> & {
  /**
   * Unique identifier for the bet
   *
   * @generated from field: int32 bet_id = 1;
   */
  betId: number;

  /**
   * Current state of the tournament bet
   *
   * @generated from field: qb.smg.TournamentPlayerBet.State state = 2;
   */
  state: TournamentPlayerBet_State;

  /**
   * Whether the bet has been resolved (win/loss determined)
   *
   * @generated from field: bool resolved = 3;
   */
  resolved: boolean;

  /**
   * Wallet stake on this overlay shot (smg_bet.amount). Mint writes 0;
   * AcceptBet copies the pin and charges this amount. Unplayed rows stay 0.
   *
   * @generated from field: int64 amount = 4;
   */
  amount: bigint;

  /**
   * Multiplier from smg_bet
   *
   * @generated from field: int64 multiplier = 5;
   */
  multiplier: bigint;

  /**
   * Outcome from smg_bet (empty until resolved)
   *
   * @generated from field: string outcome = 6;
   */
  outcome: string;

  /**
   * smg_bet.created_on as unix seconds
   *
   * @generated from field: int64 created_on = 7;
   */
  createdOn: bigint;

  /**
   * Station that played this bet; 0 when unset
   *
   * @generated from field: int64 station_id = 8;
   */
  stationId: bigint;
};

/**
 * Describes the message qb.smg.TournamentPlayerBet.
 * Use `create(TournamentPlayerBetSchema)` to create a new message.
 */
export const TournamentPlayerBetSchema: GenMessage<TournamentPlayerBet> = /*@__PURE__*/
  messageDesc(file_smg_service, 0);

/**
 * *
 * Possible states of a tournament bet.
 *
 * @generated from enum qb.smg.TournamentPlayerBet.State
 */
export enum TournamentPlayerBet_State {
  /**
   * Bet is pending and not yet active
   *
   * @generated from enum value: PENDING = 0;
   */
  PENDING = 0,

  /**
   * Bet is currently active and being played
   *
   * @generated from enum value: PLAYING = 1;
   */
  PLAYING = 1,

  /**
   * Bet has been completed
   *
   * @generated from enum value: FINISHED = 2;
   */
  FINISHED = 2,

  /**
   * Bet was cancelled (voided tournament refund)
   *
   * @generated from enum value: CANCELLED = 3;
   */
  CANCELLED = 3,
}

/**
 * Describes the enum qb.smg.TournamentPlayerBet.State.
 */
export const TournamentPlayerBet_StateSchema: GenEnum<TournamentPlayerBet_State> = /*@__PURE__*/
  enumDesc(file_smg_service, 0, 0);

/**
 * *
 * Contains detailed information about a player's participation in a tournament.
 *
 * @generated from message qb.smg.TournamentPlayerDetails
 */
export type TournamentPlayerDetails = Message<"qb.smg.TournamentPlayerDetails"> & {
  /**
   * Unique identifier for the player
   *
   * @generated from field: int32 player_id = 1;
   */
  playerId: number;

  /**
   * Display name of the player
   *
   * @generated from field: string player_name = 2;
   */
  playerName: string;

  /**
   * First name of the player
   *
   * @generated from field: string player_first_name = 10;
   */
  playerFirstName: string;

  /**
   * Last name of the player
   *
   * @generated from field: string player_last_name = 11;
   */
  playerLastName: string;

  /**
   * List of bets placed by the player in this tournament
   *
   * @generated from field: repeated qb.smg.TournamentPlayerBet bets = 3;
   */
  bets: TournamentPlayerBet[];

  /**
   * Current state of the player in the tournament
   *
   * @generated from field: qb.smg.TournamentPlayerDetails.State state = 4;
   */
  state: TournamentPlayerDetails_State;

  /**
   * Whether the player won a prize in the tournament
   *
   * @generated from field: bool won = 5;
   */
  won: boolean;

  /**
   * Player's score in the tournament
   *
   * @generated from field: int32 score = 6;
   */
  score: number;

  /**
   * Amount of prize won by the player
   *
   * @generated from field: int32 prize = 7;
   */
  prize: number;

  /**
   * Entry fee paid by the player
   *
   * @generated from field: int32 betEntreeFee = 8;
   */
  betEntreeFee: number;

  /**
   * Player's ranking in the tournament
   *
   * @generated from field: int32 rank = 9;
   */
  rank: number;

  /**
   * Player's email address
   *
   * @generated from field: string email = 12;
   */
  email: string;

  /**
   * Station ID from first shot
   *
   * @generated from field: int32 station_id = 13;
   */
  stationId: number;

  /**
   * Player's contest fees total
   *
   * @generated from field: int32 total_contest_fees = 14;
   */
  totalContestFees: number;

  /**
   * @generated from field: qb.smg.TournamentPrizeDistributionItem prize_distributionItem = 15;
   */
  prizeDistributionItem?: TournamentPrizeDistributionItem;

  /**
   * Resolved overlay shots (taken), excluding CANCELLED. Allocated shots
   * not yet played are bets_allocated, not this field. Set by the backoffice
   * details standings path without loading per-bet payloads.
   *
   * @generated from field: int32 bets_placed = 16;
   */
  betsPlaced: number;

  /**
   * Overlay bet rows including CANCELLED. Used for entry-fee stats without bets[].
   *
   * @generated from field: int32 bets_allocated = 17;
   */
  betsAllocated: number;

  /**
   * Sum of smg_bet.amount on overlay shots. Unplayed mint rows are 0.
   *
   * @generated from field: int64 wagered = 18;
   */
  wagered: bigint;
};

/**
 * Describes the message qb.smg.TournamentPlayerDetails.
 * Use `create(TournamentPlayerDetailsSchema)` to create a new message.
 */
export const TournamentPlayerDetailsSchema: GenMessage<TournamentPlayerDetails> = /*@__PURE__*/
  messageDesc(file_smg_service, 1);

/**
 * *
 * Possible states of a player's participation in a tournament.
 *
 * @generated from enum qb.smg.TournamentPlayerDetails.State
 */
export enum TournamentPlayerDetails_State {
  /**
   * Player has joined but not started playing
   *
   * @generated from enum value: PENDING = 0;
   */
  PENDING = 0,

  /**
   * Player is actively participating
   *
   * @generated from enum value: PLAYING = 1;
   */
  PLAYING = 1,

  /**
   * Player has completed all their shots/bets
   *
   * @generated from enum value: FINISHED = 2;
   */
  FINISHED = 2,
}

/**
 * Describes the enum qb.smg.TournamentPlayerDetails.State.
 */
export const TournamentPlayerDetails_StateSchema: GenEnum<TournamentPlayerDetails_State> = /*@__PURE__*/
  enumDesc(file_smg_service, 1, 0);

/**
 * *
 * Contains information about the creator/owner of a tournament.
 *
 * @generated from message qb.smg.TournamentOwner
 */
export type TournamentOwner = Message<"qb.smg.TournamentOwner"> & {
  /**
   * Unique identifier for the tournament owner
   *
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * Username of the tournament owner
   *
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * First name of the tournament owner
   *
   * @generated from field: string firstName = 3;
   */
  firstName: string;

  /**
   * Last name of the tournament owner
   *
   * @generated from field: string lastName = 4;
   */
  lastName: string;
};

/**
 * Describes the message qb.smg.TournamentOwner.
 * Use `create(TournamentOwnerSchema)` to create a new message.
 */
export const TournamentOwnerSchema: GenMessage<TournamentOwner> = /*@__PURE__*/
  messageDesc(file_smg_service, 2);

/**
 * *
 * Comprehensive information about a tournament.
 *
 * @generated from message qb.smg.Tournament
 */
export type Tournament = Message<"qb.smg.Tournament"> & {
  /**
   * Unique identifier for the tournament
   *
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * Name/title of the tournament
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Whether this is a private tournament
   *
   * @generated from field: bool isPrivate = 3;
   */
  isPrivate: boolean;

  /**
   * States/regions where the tournament is available
   *
   * @generated from field: string criteriaStates = 4;
   */
  criteriaStates: string;

  /**
   * Cities where the tournament is available
   *
   * @generated from field: string criteriaCities = 5;
   */
  criteriaCities: string;

  /**
   * Venues where the tournament is available
   *
   * @generated from field: string criteriaVenues = 6;
   */
  criteriaVenues: string;

  /**
   * Timestamp when registration opens
   *
   * @generated from field: int64 entryBeginDate = 7;
   */
  entryBeginDate: bigint;

  /**
   * Timestamp when registration closes
   *
   * @generated from field: int64 entryEndDate = 8;
   */
  entryEndDate: bigint;

  /**
   * Timestamp when the tournament begins
   *
   * @generated from field: int64 startDate = 23;
   */
  startDate: bigint;

  /**
   * Timestamp when the tournament ends
   *
   * @generated from field: int64 finishDate = 21;
   */
  finishDate: bigint;

  /**
   * Minimum guaranteed prize pool amount
   *
   * @generated from field: int32 minimumGuaranteedPricePool = 9;
   */
  minimumGuaranteedPricePool: number;

  /**
   * Fee to enter the tournament
   *
   * @generated from field: int32 entryFee = 10;
   */
  entryFee: number;

  /**
   * House rake percentage
   *
   * @generated from field: int32 rake = 11;
   */
  rake: number;

  /**
   * Distribution of prizes for different rankings
   *
   * @generated from field: repeated int32 prizePool = 12;
   */
  prizePool: number[];

  /**
   * Details of the current player in this tournament
   *
   * @generated from field: qb.smg.TournamentPlayerDetails currentPlayerDetails = 13;
   */
  currentPlayerDetails?: TournamentPlayerDetails;

  /**
   * Details of all players in the tournament
   *
   * @generated from field: repeated qb.smg.TournamentPlayerDetails playerDetails = 14;
   */
  playerDetails: TournamentPlayerDetails[];

  /**
   * Current state of the tournament
   *
   * @generated from field: qb.smg.TournamentState state = 15;
   */
  state: TournamentState;

  /**
   * Maximum number of participants allowed
   *
   * @generated from field: int32 maxParticipants = 16;
   */
  maxParticipants: number;

  /**
   * Total number of shots each player gets
   *
   * @generated from field: int32 totalShots = 17;
   */
  totalShots: number;

  /**
   * Information about the tournament creator
   *
   * @generated from field: qb.smg.TournamentOwner owner = 18;
   */
  owner?: TournamentOwner;

  /**
   * Timestamp when tournament data expires
   *
   * @generated from field: int64 expirationDate = 19;
   */
  expirationDate: bigint;

  /**
   * URL to the sponsor's logo
   *
   * @generated from field: string sponsorLogo = 20;
   */
  sponsorLogo: string;

  /**
   * Unique code for private tournaments
   *
   * @generated from field: string tournament_code = 22;
   */
  tournamentCode: string;

  /**
   * Survey questions for tournament participants
   *
   * @generated from field: repeated qb.smg.TournamentSurveyQuestion questions = 24;
   */
  questions: TournamentSurveyQuestion[];

  /**
   * Whether physical prizes are awarded
   *
   * @generated from field: bool physical_prizing = 25;
   */
  physicalPrizing: boolean;

  /**
   * ID of the venue hosting the tournament
   *
   * @generated from field: int32 venue_id = 26;
   */
  venueId: number;

  /**
   * URL to the sponsor's landscape-oriented logo
   *
   * @generated from field: string sponsor_landscape_logo = 27;
   */
  sponsorLandscapeLogo: string;

  /**
   * @generated from field: bool is_featured = 28;
   */
  isFeatured: boolean;

  /**
   * @generated from field: qb.smg.TournamentJoinOptions join_options = 29;
   */
  joinOptions: TournamentJoinOptions;

  /**
   * @generated from field: int32 series_id = 30;
   */
  seriesId: number;

  /**
   * @generated from field: int32 min_participants = 31;
   */
  minParticipants: number;

  /**
   * Current enrolled player count. Set by internal list API without loading player_details.
   *
   * @generated from field: int32 participant_count = 32;
   */
  participantCount: number;
};

/**
 * Describes the message qb.smg.Tournament.
 * Use `create(TournamentSchema)` to create a new message.
 */
export const TournamentSchema: GenMessage<Tournament> = /*@__PURE__*/
  messageDesc(file_smg_service, 3);

/**
 * @generated from message qb.smg.LevelTournamentBasicDetails
 */
export type LevelTournamentBasicDetails = Message<"qb.smg.LevelTournamentBasicDetails"> & {
  /**
   * Unique identifier for the tournament
   *
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * Name/title of the tournament
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int32 entry_fee = 10;
   */
  entryFee: number;

  /**
   * Timestamp when registration opens
   *
   * @generated from field: int64 entry_begin_date = 7;
   */
  entryBeginDate: bigint;

  /**
   * Timestamp when registration closes
   *
   * @generated from field: int64 entry_end_date = 8;
   */
  entryEndDate: bigint;

  /**
   * @generated from field: qb.smg.LevelTournamentBasicDetails.State current_player_state = 12;
   */
  currentPlayerState: LevelTournamentBasicDetails_State;

  /**
   * @generated from field: bool current_player_joined = 13;
   */
  currentPlayerJoined: boolean;

  /**
   * @generated from field: int32 number_of_participants = 14;
   */
  numberOfParticipants: number;

  /**
   * @generated from field: int32 max_participants = 15;
   */
  maxParticipants: number;

  /**
   * @generated from field: qb.smg.TournamentPrizeDistributionItem first_place_award = 9;
   */
  firstPlaceAward?: TournamentPrizeDistributionItem;
};

/**
 * Describes the message qb.smg.LevelTournamentBasicDetails.
 * Use `create(LevelTournamentBasicDetailsSchema)` to create a new message.
 */
export const LevelTournamentBasicDetailsSchema: GenMessage<LevelTournamentBasicDetails> = /*@__PURE__*/
  messageDesc(file_smg_service, 4);

/**
 * @generated from enum qb.smg.LevelTournamentBasicDetails.State
 */
export enum LevelTournamentBasicDetails_State {
  /**
   * Bet is pending and not yet active
   *
   * @generated from enum value: PENDING = 0;
   */
  PENDING = 0,

  /**
   * Bet is currently active and being played
   *
   * @generated from enum value: PLAYING = 1;
   */
  PLAYING = 1,

  /**
   * Bet has been completed
   *
   * @generated from enum value: FINISHED = 2;
   */
  FINISHED = 2,
}

/**
 * Describes the enum qb.smg.LevelTournamentBasicDetails.State.
 */
export const LevelTournamentBasicDetails_StateSchema: GenEnum<LevelTournamentBasicDetails_State> = /*@__PURE__*/
  enumDesc(file_smg_service, 4, 0);

/**
 * @generated from message qb.smg.LevelTournamentList
 */
export type LevelTournamentList = Message<"qb.smg.LevelTournamentList"> & {
  /**
   * @generated from field: int32 level = 1;
   */
  level: number;

  /**
   * @generated from field: repeated qb.smg.LevelTournamentBasicDetails tournaments = 2;
   */
  tournaments: LevelTournamentBasicDetails[];
};

/**
 * Describes the message qb.smg.LevelTournamentList.
 * Use `create(LevelTournamentListSchema)` to create a new message.
 */
export const LevelTournamentListSchema: GenMessage<LevelTournamentList> = /*@__PURE__*/
  messageDesc(file_smg_service, 5);

/**
 * @generated from message qb.smg.TournamentPrizeDistributionItem
 */
export type TournamentPrizeDistributionItem = Message<"qb.smg.TournamentPrizeDistributionItem"> & {
  /**
   * rank
   *
   * @generated from field: int32 place = 1;
   */
  place: number;

  /**
   * @generated from field: qb.smg.TournamentPrizeDistributionItem.AwardKind kind = 2;
   */
  kind: TournamentPrizeDistributionItem_AwardKind;

  /**
   * STATIC kind
   *
   * @generated from field: int32 static_award_prize = 3;
   */
  staticAwardPrize: number;

  /**
   * PERCENTAGE_OF_POOL
   *
   * @generated from field: int32 percentage_of_pool = 4;
   */
  percentageOfPool: number;

  /**
   * PERCENTAGE_OF_POOL from percentage of pool
   *
   * @generated from field: int32 calculated_award_prize = 5;
   */
  calculatedAwardPrize: number;

  /**
   * Ticket + Cash Prize; Physical Prizing + Cash Prize
   *
   * @generated from field: int32 additional_cash_prize = 6;
   */
  additionalCashPrize: number;
};

/**
 * Describes the message qb.smg.TournamentPrizeDistributionItem.
 * Use `create(TournamentPrizeDistributionItemSchema)` to create a new message.
 */
export const TournamentPrizeDistributionItemSchema: GenMessage<TournamentPrizeDistributionItem> = /*@__PURE__*/
  messageDesc(file_smg_service, 6);

/**
 * @generated from enum qb.smg.TournamentPrizeDistributionItem.AwardKind
 */
export enum TournamentPrizeDistributionItem_AwardKind {
  /**
   * @generated from enum value: STATIC = 0;
   */
  STATIC = 0,

  /**
   * @generated from enum value: TICKET = 1;
   */
  TICKET = 1,

  /**
   * @generated from enum value: PERCENTAGE_OF_POOL = 2;
   */
  PERCENTAGE_OF_POOL = 2,

  /**
   * @generated from enum value: PHYSICAL_PRIZE = 3;
   */
  PHYSICAL_PRIZE = 3,
}

/**
 * Describes the enum qb.smg.TournamentPrizeDistributionItem.AwardKind.
 */
export const TournamentPrizeDistributionItem_AwardKindSchema: GenEnum<TournamentPrizeDistributionItem_AwardKind> = /*@__PURE__*/
  enumDesc(file_smg_service, 6, 0);

/**
 * @generated from message qb.smg.TournamentPrizeDistribution
 */
export type TournamentPrizeDistribution = Message<"qb.smg.TournamentPrizeDistribution"> & {
  /**
   * @generated from field: repeated qb.smg.TournamentPrizeDistributionItem items = 1;
   */
  items: TournamentPrizeDistributionItem[];
};

/**
 * Describes the message qb.smg.TournamentPrizeDistribution.
 * Use `create(TournamentPrizeDistributionSchema)` to create a new message.
 */
export const TournamentPrizeDistributionSchema: GenMessage<TournamentPrizeDistribution> = /*@__PURE__*/
  messageDesc(file_smg_service, 7);

/**
 * @generated from message qb.smg.ListTournamentRequest
 */
export type ListTournamentRequest = Message<"qb.smg.ListTournamentRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: bool mineOnly = 4;
   */
  mineOnly: boolean;

  /**
   * @generated from field: bool showLastTwoDaysForPastTournaments = 6;
   */
  showLastTwoDaysForPastTournaments: boolean;

  /**
   * @generated from field: repeated qb.smg.ListTournamentRequest.TournamentAccess tournamentAccess = 2;
   */
  tournamentAccess: ListTournamentRequest_TournamentAccess[];

  /**
   * @generated from field: repeated qb.smg.TournamentState states = 3;
   */
  states: TournamentState[];

  /**
   * @generated from field: qb.smg.ListTournamentRequest.Sort sort = 5;
   */
  sort: ListTournamentRequest_Sort;
};

/**
 * Describes the message qb.smg.ListTournamentRequest.
 * Use `create(ListTournamentRequestSchema)` to create a new message.
 */
export const ListTournamentRequestSchema: GenMessage<ListTournamentRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 8);

/**
 * @generated from enum qb.smg.ListTournamentRequest.TournamentAccess
 */
export enum ListTournamentRequest_TournamentAccess {
  /**
   * @generated from enum value: PUBLIC = 0;
   */
  PUBLIC = 0,

  /**
   * @generated from enum value: PRIVATE = 1;
   */
  PRIVATE = 1,

  /**
   * @generated from enum value: FRIENDS = 2;
   */
  FRIENDS = 2,
}

/**
 * Describes the enum qb.smg.ListTournamentRequest.TournamentAccess.
 */
export const ListTournamentRequest_TournamentAccessSchema: GenEnum<ListTournamentRequest_TournamentAccess> = /*@__PURE__*/
  enumDesc(file_smg_service, 8, 0);

/**
 * @generated from enum qb.smg.ListTournamentRequest.Sort
 */
export enum ListTournamentRequest_Sort {
  /**
   * @generated from enum value: DEFAULT = 0;
   */
  DEFAULT = 0,

  /**
   * @generated from enum value: ENTRY_BEGIN_DATE_SOONEST = 1;
   */
  ENTRY_BEGIN_DATE_SOONEST = 1,

  /**
   * @generated from enum value: ENTRY_BEGIN_DATE_LATEST = 2;
   */
  ENTRY_BEGIN_DATE_LATEST = 2,

  /**
   * @generated from enum value: ENTRY_END_DATE_SOONEST = 3;
   */
  ENTRY_END_DATE_SOONEST = 3,

  /**
   * @generated from enum value: ENTRY_END_DATE_LATEST = 4;
   */
  ENTRY_END_DATE_LATEST = 4,

  /**
   * @generated from enum value: FINISH_TIME = 5;
   */
  FINISH_TIME = 5,

  /**
   * @generated from enum value: START_TIME = 6;
   */
  START_TIME = 6,
}

/**
 * Describes the enum qb.smg.ListTournamentRequest.Sort.
 */
export const ListTournamentRequest_SortSchema: GenEnum<ListTournamentRequest_Sort> = /*@__PURE__*/
  enumDesc(file_smg_service, 8, 1);

/**
 * @generated from message qb.smg.ListTournamentReply
 */
export type ListTournamentReply = Message<"qb.smg.ListTournamentReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated qb.smg.Tournament tournaments = 3;
   */
  tournaments: Tournament[];
};

/**
 * Describes the message qb.smg.ListTournamentReply.
 * Use `create(ListTournamentReplySchema)` to create a new message.
 */
export const ListTournamentReplySchema: GenMessage<ListTournamentReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 9);

/**
 * @generated from message qb.smg.ListDefaultTournamentRequest
 */
export type ListDefaultTournamentRequest = Message<"qb.smg.ListDefaultTournamentRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message qb.smg.ListDefaultTournamentRequest.
 * Use `create(ListDefaultTournamentRequestSchema)` to create a new message.
 */
export const ListDefaultTournamentRequestSchema: GenMessage<ListDefaultTournamentRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 10);

/**
 * @generated from message qb.smg.ListDefaultTournamentReply
 */
export type ListDefaultTournamentReply = Message<"qb.smg.ListDefaultTournamentReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated qb.smg.Tournament tournaments = 3;
   */
  tournaments: Tournament[];
};

/**
 * Describes the message qb.smg.ListDefaultTournamentReply.
 * Use `create(ListDefaultTournamentReplySchema)` to create a new message.
 */
export const ListDefaultTournamentReplySchema: GenMessage<ListDefaultTournamentReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 11);

/**
 * @generated from message qb.smg.GetTournamentRequest
 */
export type GetTournamentRequest = Message<"qb.smg.GetTournamentRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int32 tournamentId = 2;
   */
  tournamentId: number;
};

/**
 * Describes the message qb.smg.GetTournamentRequest.
 * Use `create(GetTournamentRequestSchema)` to create a new message.
 */
export const GetTournamentRequestSchema: GenMessage<GetTournamentRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 12);

/**
 * @generated from message qb.smg.GetTournamentReply
 */
export type GetTournamentReply = Message<"qb.smg.GetTournamentReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: qb.smg.Tournament tournament = 3;
   */
  tournament?: Tournament;
};

/**
 * Describes the message qb.smg.GetTournamentReply.
 * Use `create(GetTournamentReplySchema)` to create a new message.
 */
export const GetTournamentReplySchema: GenMessage<GetTournamentReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 13);

/**
 * @generated from message qb.smg.GetTournamentMetadataRequest
 */
export type GetTournamentMetadataRequest = Message<"qb.smg.GetTournamentMetadataRequest"> & {
  /**
   * simulator app-token, message-field style
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int32 tournament_id = 2;
   */
  tournamentId: number;
};

/**
 * Describes the message qb.smg.GetTournamentMetadataRequest.
 * Use `create(GetTournamentMetadataRequestSchema)` to create a new message.
 */
export const GetTournamentMetadataRequestSchema: GenMessage<GetTournamentMetadataRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 14);

/**
 * @generated from message qb.smg.TournamentMetadata
 */
export type TournamentMetadata = Message<"qb.smg.TournamentMetadata"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: qb.smg.TournamentState state = 3;
   */
  state: TournamentState;

  /**
   * @generated from field: int32 shot_count = 4;
   */
  shotCount: number;

  /**
   * @generated from field: string sponsor_logo = 5;
   */
  sponsorLogo: string;

  /**
   * @generated from field: string sponsor_landscape_logo = 6;
   */
  sponsorLandscapeLogo: string;

  /**
   * unix seconds; 0 when unset
   *
   * @generated from field: int64 start_date = 7;
   */
  startDate: bigint;

  /**
   * unix seconds; 0 when unset
   *
   * @generated from field: int64 finish_date = 8;
   */
  finishDate: bigint;

  /**
   * unix seconds; 0 when unset
   *
   * @generated from field: int64 expiration_date = 9;
   */
  expirationDate: bigint;
};

/**
 * Describes the message qb.smg.TournamentMetadata.
 * Use `create(TournamentMetadataSchema)` to create a new message.
 */
export const TournamentMetadataSchema: GenMessage<TournamentMetadata> = /*@__PURE__*/
  messageDesc(file_smg_service, 15);

/**
 * @generated from message qb.smg.GetTournamentMetadataReply
 */
export type GetTournamentMetadataReply = Message<"qb.smg.GetTournamentMetadataReply"> & {
  /**
   * unset when the tournament is not found
   *
   * @generated from field: qb.smg.TournamentMetadata metadata = 1;
   */
  metadata?: TournamentMetadata;
};

/**
 * Describes the message qb.smg.GetTournamentMetadataReply.
 * Use `create(GetTournamentMetadataReplySchema)` to create a new message.
 */
export const GetTournamentMetadataReplySchema: GenMessage<GetTournamentMetadataReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 16);

/**
 * @generated from message qb.smg.CreatePrivateTournamentRequest
 */
export type CreatePrivateTournamentRequest = Message<"qb.smg.CreatePrivateTournamentRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int32 number_of_shots = 2;
   */
  numberOfShots: number;

  /**
   * @generated from field: int32 max_participants = 3;
   */
  maxParticipants: number;

  /**
   * @generated from field: int32 entree_fee = 4;
   */
  entreeFee: number;
};

/**
 * Describes the message qb.smg.CreatePrivateTournamentRequest.
 * Use `create(CreatePrivateTournamentRequestSchema)` to create a new message.
 */
export const CreatePrivateTournamentRequestSchema: GenMessage<CreatePrivateTournamentRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 17);

/**
 * @generated from message qb.smg.CreatePrivateTournamentReply
 */
export type CreatePrivateTournamentReply = Message<"qb.smg.CreatePrivateTournamentReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: string new_tournament_code = 3;
   */
  newTournamentCode: string;

  /**
   * @generated from field: qb.smg.Tournament tournament = 4;
   */
  tournament?: Tournament;
};

/**
 * Describes the message qb.smg.CreatePrivateTournamentReply.
 * Use `create(CreatePrivateTournamentReplySchema)` to create a new message.
 */
export const CreatePrivateTournamentReplySchema: GenMessage<CreatePrivateTournamentReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 18);

/**
 * @generated from message qb.smg.JoinPrivateTournamentRequest
 */
export type JoinPrivateTournamentRequest = Message<"qb.smg.JoinPrivateTournamentRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: int32 betEntreeFee = 3;
   */
  betEntreeFee: number;

  /**
   * @generated from field: repeated qb.smg.TournamentSurveyAnswer surveyAnswers = 4;
   */
  surveyAnswers: TournamentSurveyAnswer[];

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venueId = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.JoinPrivateTournamentRequest.
 * Use `create(JoinPrivateTournamentRequestSchema)` to create a new message.
 */
export const JoinPrivateTournamentRequestSchema: GenMessage<JoinPrivateTournamentRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 19);

/**
 * @generated from message qb.smg.JoinPrivateTournamentReply
 */
export type JoinPrivateTournamentReply = Message<"qb.smg.JoinPrivateTournamentReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: qb.smg.Tournament tournament = 3;
   */
  tournament?: Tournament;
};

/**
 * Describes the message qb.smg.JoinPrivateTournamentReply.
 * Use `create(JoinPrivateTournamentReplySchema)` to create a new message.
 */
export const JoinPrivateTournamentReplySchema: GenMessage<JoinPrivateTournamentReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 20);

/**
 * @generated from message qb.smg.VerifyPrivateTournamentCodeRequest
 */
export type VerifyPrivateTournamentCodeRequest = Message<"qb.smg.VerifyPrivateTournamentCodeRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venueId = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.VerifyPrivateTournamentCodeRequest.
 * Use `create(VerifyPrivateTournamentCodeRequestSchema)` to create a new message.
 */
export const VerifyPrivateTournamentCodeRequestSchema: GenMessage<VerifyPrivateTournamentCodeRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 21);

/**
 * @generated from message qb.smg.VerifyPrivateTournamentCodeReply
 */
export type VerifyPrivateTournamentCodeReply = Message<"qb.smg.VerifyPrivateTournamentCodeReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: qb.smg.Tournament tournament = 3;
   */
  tournament?: Tournament;
};

/**
 * Describes the message qb.smg.VerifyPrivateTournamentCodeReply.
 * Use `create(VerifyPrivateTournamentCodeReplySchema)` to create a new message.
 */
export const VerifyPrivateTournamentCodeReplySchema: GenMessage<VerifyPrivateTournamentCodeReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 22);

/**
 * @generated from message qb.smg.TournamentSurveyQuestion
 */
export type TournamentSurveyQuestion = Message<"qb.smg.TournamentSurveyQuestion"> & {
  /**
   * Unique ID for each question
   *
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * Text of the question
   *
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * Type of the question (e.g., "Text Entry", "Dropdown", "Multi-Choice")
   *
   * @generated from field: qb.smg.TournamentSurveyQuestionType type = 3;
   */
  type: TournamentSurveyQuestionType;

  /**
   * Options for Dropdown or Multi-Choice questions
   *
   * @generated from field: repeated string options = 4;
   */
  options: string[];
};

/**
 * Describes the message qb.smg.TournamentSurveyQuestion.
 * Use `create(TournamentSurveyQuestionSchema)` to create a new message.
 */
export const TournamentSurveyQuestionSchema: GenMessage<TournamentSurveyQuestion> = /*@__PURE__*/
  messageDesc(file_smg_service, 23);

/**
 * @generated from message qb.smg.TournamentSurveyAnswer
 */
export type TournamentSurveyAnswer = Message<"qb.smg.TournamentSurveyAnswer"> & {
  /**
   * ID of the question being answered
   *
   * @generated from field: int32 questionId = 1;
   */
  questionId: number;

  /**
   * Player’s response(s); allows multiple selections for Multi-Choice questions
   *
   * @generated from field: repeated string response = 2;
   */
  response: string[];
};

/**
 * Describes the message qb.smg.TournamentSurveyAnswer.
 * Use `create(TournamentSurveyAnswerSchema)` to create a new message.
 */
export const TournamentSurveyAnswerSchema: GenMessage<TournamentSurveyAnswer> = /*@__PURE__*/
  messageDesc(file_smg_service, 24);

/**
 * @generated from message qb.smg.JoinTournamentRequest
 */
export type JoinTournamentRequest = Message<"qb.smg.JoinTournamentRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int32 tournamentId = 2;
   */
  tournamentId: number;

  /**
   * @generated from field: int32 betEntreeFee = 3;
   */
  betEntreeFee: number;

  /**
   * @generated from field: repeated qb.smg.TournamentSurveyAnswer surveyAnswers = 4;
   */
  surveyAnswers: TournamentSurveyAnswer[];

  /**
   * @generated from field: bool enter_with_ticket = 5;
   */
  enterWithTicket: boolean;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venueId = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.JoinTournamentRequest.
 * Use `create(JoinTournamentRequestSchema)` to create a new message.
 */
export const JoinTournamentRequestSchema: GenMessage<JoinTournamentRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 25);

/**
 * @generated from message qb.smg.JoinTournamentReply
 */
export type JoinTournamentReply = Message<"qb.smg.JoinTournamentReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.JoinTournamentReply.
 * Use `create(JoinTournamentReplySchema)` to create a new message.
 */
export const JoinTournamentReplySchema: GenMessage<JoinTournamentReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 26);

/**
 * @generated from message qb.smg.LeaveTournamentRequest
 */
export type LeaveTournamentRequest = Message<"qb.smg.LeaveTournamentRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int32 tournamentId = 2;
   */
  tournamentId: number;
};

/**
 * Describes the message qb.smg.LeaveTournamentRequest.
 * Use `create(LeaveTournamentRequestSchema)` to create a new message.
 */
export const LeaveTournamentRequestSchema: GenMessage<LeaveTournamentRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 27);

/**
 * @generated from message qb.smg.LeaveTournamentReply
 */
export type LeaveTournamentReply = Message<"qb.smg.LeaveTournamentReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.LeaveTournamentReply.
 * Use `create(LeaveTournamentReplySchema)` to create a new message.
 */
export const LeaveTournamentReplySchema: GenMessage<LeaveTournamentReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 28);

/**
 * @generated from message qb.smg.GetTournamentLeaderBoardRequest
 */
export type GetTournamentLeaderBoardRequest = Message<"qb.smg.GetTournamentLeaderBoardRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 playerId = 2;
   */
  playerId: bigint;

  /**
   * @generated from field: int32 tournamentId = 3;
   */
  tournamentId: number;

  /**
   * @generated from field: int32 topN = 4;
   */
  topN: number;
};

/**
 * Describes the message qb.smg.GetTournamentLeaderBoardRequest.
 * Use `create(GetTournamentLeaderBoardRequestSchema)` to create a new message.
 */
export const GetTournamentLeaderBoardRequestSchema: GenMessage<GetTournamentLeaderBoardRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 29);

/**
 * @generated from message qb.smg.TournamentLeaderBoardEntry
 */
export type TournamentLeaderBoardEntry = Message<"qb.smg.TournamentLeaderBoardEntry"> & {
  /**
   * @generated from field: int32 rank = 1;
   */
  rank: number;

  /**
   * @generated from field: string playerUsername = 2;
   */
  playerUsername: string;

  /**
   * @generated from field: string playerFirstName = 3;
   */
  playerFirstName: string;

  /**
   * @generated from field: string playerLastName = 4;
   */
  playerLastName: string;

  /**
   * @generated from field: int32 score = 5;
   */
  score: number;

  /**
   * @generated from field: int32 shotsCompleted = 6;
   */
  shotsCompleted: number;

  /**
   * @generated from field: bool isCurrentUser = 7;
   */
  isCurrentUser: boolean;

  /**
   * @generated from field: string playerUsernameId = 8;
   */
  playerUsernameId: string;
};

/**
 * Describes the message qb.smg.TournamentLeaderBoardEntry.
 * Use `create(TournamentLeaderBoardEntrySchema)` to create a new message.
 */
export const TournamentLeaderBoardEntrySchema: GenMessage<TournamentLeaderBoardEntry> = /*@__PURE__*/
  messageDesc(file_smg_service, 30);

/**
 * @generated from message qb.smg.GetTournamentLeaderBoardReply
 */
export type GetTournamentLeaderBoardReply = Message<"qb.smg.GetTournamentLeaderBoardReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: bool hasActiveTournament = 3;
   */
  hasActiveTournament: boolean;

  /**
   * @generated from field: bool hasTournamentCompletedForUser = 4;
   */
  hasTournamentCompletedForUser: boolean;

  /**
   * @generated from field: repeated qb.smg.TournamentLeaderBoardEntry entries = 5;
   */
  entries: TournamentLeaderBoardEntry[];
};

/**
 * Describes the message qb.smg.GetTournamentLeaderBoardReply.
 * Use `create(GetTournamentLeaderBoardReplySchema)` to create a new message.
 */
export const GetTournamentLeaderBoardReplySchema: GenMessage<GetTournamentLeaderBoardReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 31);

/**
 * @generated from message qb.smg.GetTournamentPlayersRequest
 */
export type GetTournamentPlayersRequest = Message<"qb.smg.GetTournamentPlayersRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 playerId = 2;
   */
  playerId: bigint;

  /**
   * @generated from field: int32 tournamentId = 3;
   */
  tournamentId: number;
};

/**
 * Describes the message qb.smg.GetTournamentPlayersRequest.
 * Use `create(GetTournamentPlayersRequestSchema)` to create a new message.
 */
export const GetTournamentPlayersRequestSchema: GenMessage<GetTournamentPlayersRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 32);

/**
 * @generated from message qb.smg.GetTournamentPlayerEntry
 */
export type GetTournamentPlayerEntry = Message<"qb.smg.GetTournamentPlayerEntry"> & {
  /**
   * @generated from field: string playerUsername = 2;
   */
  playerUsername: string;

  /**
   * @generated from field: string playerFirstName = 3;
   */
  playerFirstName: string;

  /**
   * @generated from field: string playerLastName = 4;
   */
  playerLastName: string;
};

/**
 * Describes the message qb.smg.GetTournamentPlayerEntry.
 * Use `create(GetTournamentPlayerEntrySchema)` to create a new message.
 */
export const GetTournamentPlayerEntrySchema: GenMessage<GetTournamentPlayerEntry> = /*@__PURE__*/
  messageDesc(file_smg_service, 33);

/**
 * @generated from message qb.smg.GetTournamentPlayersReply
 */
export type GetTournamentPlayersReply = Message<"qb.smg.GetTournamentPlayersReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated qb.smg.GetTournamentPlayerEntry entries = 5;
   */
  entries: GetTournamentPlayerEntry[];
};

/**
 * Describes the message qb.smg.GetTournamentPlayersReply.
 * Use `create(GetTournamentPlayersReplySchema)` to create a new message.
 */
export const GetTournamentPlayersReplySchema: GenMessage<GetTournamentPlayersReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 34);

/**
 * @generated from message qb.smg.ResolveTournamentShotRequest
 */
export type ResolveTournamentShotRequest = Message<"qb.smg.ResolveTournamentShotRequest"> & {
  /**
   * simulator app token (same as the other tournament RPCs)
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 betId = 2;
   */
  betId: bigint;

  /**
   * @generated from field: int64 userId = 3;
   */
  userId: bigint;

  /**
   * "win" or "lose"
   *
   * @generated from field: string outcome = 4;
   */
  outcome: string;

  /**
   * @generated from field: int64 multiplier = 5;
   */
  multiplier: bigint;

  /**
   * @generated from field: bool holeInOne = 6;
   */
  holeInOne: boolean;
};

/**
 * Describes the message qb.smg.ResolveTournamentShotRequest.
 * Use `create(ResolveTournamentShotRequestSchema)` to create a new message.
 */
export const ResolveTournamentShotRequestSchema: GenMessage<ResolveTournamentShotRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 35);

/**
 * @generated from message qb.smg.ResolveTournamentShotReply
 */
export type ResolveTournamentShotReply = Message<"qb.smg.ResolveTournamentShotReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * true on idempotent replay (no-op)
   *
   * @generated from field: bool alreadyResolved = 3;
   */
  alreadyResolved: boolean;

  /**
   * the player's recomputed tournament score after this resolution
   *
   * @generated from field: int32 score = 4;
   */
  score: number;
};

/**
 * Describes the message qb.smg.ResolveTournamentShotReply.
 * Use `create(ResolveTournamentShotReplySchema)` to create a new message.
 */
export const ResolveTournamentShotReplySchema: GenMessage<ResolveTournamentShotReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 36);

/**
 * @generated from message qb.smg.GenerateS3SimulatorVideoUploadUrlRequest
 */
export type GenerateS3SimulatorVideoUploadUrlRequest = Message<"qb.smg.GenerateS3SimulatorVideoUploadUrlRequest"> & {
  /**
   * @generated from field: int64 stationId = 1;
   */
  stationId: bigint;

  /**
   * @generated from field: int64 betId = 2;
   */
  betId: bigint;

  /**
   * @generated from field: string token = 3;
   */
  token: string;
};

/**
 * Describes the message qb.smg.GenerateS3SimulatorVideoUploadUrlRequest.
 * Use `create(GenerateS3SimulatorVideoUploadUrlRequestSchema)` to create a new message.
 */
export const GenerateS3SimulatorVideoUploadUrlRequestSchema: GenMessage<GenerateS3SimulatorVideoUploadUrlRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 37);

/**
 * @generated from message qb.smg.GenerateS3SimulatorVideoUploadUrlResponse
 */
export type GenerateS3SimulatorVideoUploadUrlResponse = Message<"qb.smg.GenerateS3SimulatorVideoUploadUrlResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: string uploadUrl = 3;
   */
  uploadUrl: string;
};

/**
 * Describes the message qb.smg.GenerateS3SimulatorVideoUploadUrlResponse.
 * Use `create(GenerateS3SimulatorVideoUploadUrlResponseSchema)` to create a new message.
 */
export const GenerateS3SimulatorVideoUploadUrlResponseSchema: GenMessage<GenerateS3SimulatorVideoUploadUrlResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 38);

/**
 * @generated from message qb.smg.RequestChangeRequest
 */
export type RequestChangeRequest = Message<"qb.smg.RequestChangeRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: qb.smg.ChangeType change_type = 2;
   */
  changeType: ChangeType;
};

/**
 * Describes the message qb.smg.RequestChangeRequest.
 * Use `create(RequestChangeRequestSchema)` to create a new message.
 */
export const RequestChangeRequestSchema: GenMessage<RequestChangeRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 39);

/**
 * @generated from message qb.smg.RequestChangeResponse
 */
export type RequestChangeResponse = Message<"qb.smg.RequestChangeResponse"> & {
  /**
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.RequestChangeResponse.
 * Use `create(RequestChangeResponseSchema)` to create a new message.
 */
export const RequestChangeResponseSchema: GenMessage<RequestChangeResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 40);

/**
 * @generated from message qb.smg.UpdatePhoneNumberRequest
 */
export type UpdatePhoneNumberRequest = Message<"qb.smg.UpdatePhoneNumberRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string phone_number = 2;
   */
  phoneNumber: string;

  /**
   * @generated from field: string otp_code = 3;
   */
  otpCode: string;
};

/**
 * Describes the message qb.smg.UpdatePhoneNumberRequest.
 * Use `create(UpdatePhoneNumberRequestSchema)` to create a new message.
 */
export const UpdatePhoneNumberRequestSchema: GenMessage<UpdatePhoneNumberRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 41);

/**
 * @generated from message qb.smg.UpdatePhoneNumberResponse
 */
export type UpdatePhoneNumberResponse = Message<"qb.smg.UpdatePhoneNumberResponse"> & {
  /**
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.UpdatePhoneNumberResponse.
 * Use `create(UpdatePhoneNumberResponseSchema)` to create a new message.
 */
export const UpdatePhoneNumberResponseSchema: GenMessage<UpdatePhoneNumberResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 42);

/**
 * @generated from message qb.smg.RequestEmailChangeRequest
 */
export type RequestEmailChangeRequest = Message<"qb.smg.RequestEmailChangeRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string new_email = 2;
   */
  newEmail: string;
};

/**
 * Describes the message qb.smg.RequestEmailChangeRequest.
 * Use `create(RequestEmailChangeRequestSchema)` to create a new message.
 */
export const RequestEmailChangeRequestSchema: GenMessage<RequestEmailChangeRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 43);

/**
 * @generated from message qb.smg.RequestEmailChangeResponse
 */
export type RequestEmailChangeResponse = Message<"qb.smg.RequestEmailChangeResponse"> & {
  /**
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.RequestEmailChangeResponse.
 * Use `create(RequestEmailChangeResponseSchema)` to create a new message.
 */
export const RequestEmailChangeResponseSchema: GenMessage<RequestEmailChangeResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 44);

/**
 * @generated from message qb.smg.ConfirmEmailChangeRequest
 */
export type ConfirmEmailChangeRequest = Message<"qb.smg.ConfirmEmailChangeRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message qb.smg.ConfirmEmailChangeRequest.
 * Use `create(ConfirmEmailChangeRequestSchema)` to create a new message.
 */
export const ConfirmEmailChangeRequestSchema: GenMessage<ConfirmEmailChangeRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 45);

/**
 * @generated from message qb.smg.ConfirmEmailChangeResponse
 */
export type ConfirmEmailChangeResponse = Message<"qb.smg.ConfirmEmailChangeResponse"> & {
  /**
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.ConfirmEmailChangeResponse.
 * Use `create(ConfirmEmailChangeResponseSchema)` to create a new message.
 */
export const ConfirmEmailChangeResponseSchema: GenMessage<ConfirmEmailChangeResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 46);

/**
 * @generated from message qb.smg.DeactivateAccountRequest
 */
export type DeactivateAccountRequest = Message<"qb.smg.DeactivateAccountRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message qb.smg.DeactivateAccountRequest.
 * Use `create(DeactivateAccountRequestSchema)` to create a new message.
 */
export const DeactivateAccountRequestSchema: GenMessage<DeactivateAccountRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 47);

/**
 * @generated from message qb.smg.DeactivateAccountResponse
 */
export type DeactivateAccountResponse = Message<"qb.smg.DeactivateAccountResponse"> & {
  /**
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.DeactivateAccountResponse.
 * Use `create(DeactivateAccountResponseSchema)` to create a new message.
 */
export const DeactivateAccountResponseSchema: GenMessage<DeactivateAccountResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 48);

/**
 * @generated from message qb.smg.DisableUsersRequest
 */
export type DisableUsersRequest = Message<"qb.smg.DisableUsersRequest"> & {
  /**
   * @generated from field: repeated string user_ids = 1;
   */
  userIds: string[];

  /**
   * @generated from field: repeated string emails = 2;
   */
  emails: string[];

  /**
   * @generated from field: repeated string kycNames = 3;
   */
  kycNames: string[];

  /**
   * @generated from field: string wipe_key = 4;
   */
  wipeKey: string;

  /**
   * @generated from field: string reason = 5;
   */
  reason: string;
};

/**
 * Describes the message qb.smg.DisableUsersRequest.
 * Use `create(DisableUsersRequestSchema)` to create a new message.
 */
export const DisableUsersRequestSchema: GenMessage<DisableUsersRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 49);

/**
 * @generated from message qb.smg.DisableUsersResponse
 */
export type DisableUsersResponse = Message<"qb.smg.DisableUsersResponse"> & {
  /**
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.DisableUsersResponse.
 * Use `create(DisableUsersResponseSchema)` to create a new message.
 */
export const DisableUsersResponseSchema: GenMessage<DisableUsersResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 50);

/**
 * @generated from message qb.smg.SetFaceRequest
 */
export type SetFaceRequest = Message<"qb.smg.SetFaceRequest"> & {
  /**
   * @generated from field: string image_url = 1;
   */
  imageUrl: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * Describes the message qb.smg.SetFaceRequest.
 * Use `create(SetFaceRequestSchema)` to create a new message.
 */
export const SetFaceRequestSchema: GenMessage<SetFaceRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 51);

/**
 * @generated from message qb.smg.SetFaceResponse
 */
export type SetFaceResponse = Message<"qb.smg.SetFaceResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string err = 2;
   */
  err: string;
};

/**
 * Describes the message qb.smg.SetFaceResponse.
 * Use `create(SetFaceResponseSchema)` to create a new message.
 */
export const SetFaceResponseSchema: GenMessage<SetFaceResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 52);

/**
 * @generated from message qb.smg.RecognizeFaceRequest
 */
export type RecognizeFaceRequest = Message<"qb.smg.RecognizeFaceRequest"> & {
  /**
   * @generated from field: string image_url = 1;
   */
  imageUrl: string;
};

/**
 * Describes the message qb.smg.RecognizeFaceRequest.
 * Use `create(RecognizeFaceRequestSchema)` to create a new message.
 */
export const RecognizeFaceRequestSchema: GenMessage<RecognizeFaceRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 53);

/**
 * @generated from message qb.smg.RecognizeFaceResponse
 */
export type RecognizeFaceResponse = Message<"qb.smg.RecognizeFaceResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string err = 2;
   */
  err: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;
};

/**
 * Describes the message qb.smg.RecognizeFaceResponse.
 * Use `create(RecognizeFaceResponseSchema)` to create a new message.
 */
export const RecognizeFaceResponseSchema: GenMessage<RecognizeFaceResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 54);

/**
 * @generated from message qb.smg.CompareImagesRequest
 */
export type CompareImagesRequest = Message<"qb.smg.CompareImagesRequest"> & {
  /**
   * @generated from field: string first_image_url = 1;
   */
  firstImageUrl: string;

  /**
   * @generated from field: string second_image_url = 2;
   */
  secondImageUrl: string;
};

/**
 * Describes the message qb.smg.CompareImagesRequest.
 * Use `create(CompareImagesRequestSchema)` to create a new message.
 */
export const CompareImagesRequestSchema: GenMessage<CompareImagesRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 55);

/**
 * @generated from message qb.smg.CompareImagesResponse
 */
export type CompareImagesResponse = Message<"qb.smg.CompareImagesResponse"> & {
  /**
   * @generated from field: bool is_match = 1;
   */
  isMatch: boolean;

  /**
   * @generated from field: float match_probability = 2;
   */
  matchProbability: number;

  /**
   * @generated from field: float similiarity = 3;
   */
  similiarity: number;

  /**
   * @generated from field: string err = 4;
   */
  err: string;
};

/**
 * Describes the message qb.smg.CompareImagesResponse.
 * Use `create(CompareImagesResponseSchema)` to create a new message.
 */
export const CompareImagesResponseSchema: GenMessage<CompareImagesResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 56);

/**
 * @generated from message qb.smg.ListFacesRequest
 */
export type ListFacesRequest = Message<"qb.smg.ListFacesRequest"> & {
};

/**
 * Describes the message qb.smg.ListFacesRequest.
 * Use `create(ListFacesRequestSchema)` to create a new message.
 */
export const ListFacesRequestSchema: GenMessage<ListFacesRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 57);

/**
 * @generated from message qb.smg.ListFacesResponse
 */
export type ListFacesResponse = Message<"qb.smg.ListFacesResponse"> & {
  /**
   * @generated from field: repeated string user_ids = 1;
   */
  userIds: string[];
};

/**
 * Describes the message qb.smg.ListFacesResponse.
 * Use `create(ListFacesResponseSchema)` to create a new message.
 */
export const ListFacesResponseSchema: GenMessage<ListFacesResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 58);

/**
 * @generated from message qb.smg.InitialCommandConnectorRequest
 */
export type InitialCommandConnectorRequest = Message<"qb.smg.InitialCommandConnectorRequest"> & {
  /**
   * @generated from field: int64 venueId = 1;
   */
  venueId: bigint;

  /**
   * @generated from field: int64 stationId = 2;
   */
  stationId: bigint;

  /**
   * @generated from field: bool use_new_service = 3;
   */
  useNewService: boolean;
};

/**
 * Describes the message qb.smg.InitialCommandConnectorRequest.
 * Use `create(InitialCommandConnectorRequestSchema)` to create a new message.
 */
export const InitialCommandConnectorRequestSchema: GenMessage<InitialCommandConnectorRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 59);

/**
 * @generated from message qb.smg.InitialCommandConnectorResponse
 */
export type InitialCommandConnectorResponse = Message<"qb.smg.InitialCommandConnectorResponse"> & {
};

/**
 * Describes the message qb.smg.InitialCommandConnectorResponse.
 * Use `create(InitialCommandConnectorResponseSchema)` to create a new message.
 */
export const InitialCommandConnectorResponseSchema: GenMessage<InitialCommandConnectorResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 60);

/**
 * @generated from message qb.smg.CommandExecutorFRSPayload
 */
export type CommandExecutorFRSPayload = Message<"qb.smg.CommandExecutorFRSPayload"> & {
  /**
   * @generated from oneof qb.smg.CommandExecutorFRSPayload.payload
   */
  payload: {
    /**
     * @generated from field: qb.smg.InitialCommandConnectorRequest initialCommandConnectorRequest = 1;
     */
    value: InitialCommandConnectorRequest;
    case: "initialCommandConnectorRequest";
  } | {
    /**
     * @generated from field: qb.smg.SetFaceResponse setFaceResponse = 2;
     */
    value: SetFaceResponse;
    case: "setFaceResponse";
  } | {
    /**
     * @generated from field: qb.smg.CompareImagesResponse compareImagesResponse = 3;
     */
    value: CompareImagesResponse;
    case: "compareImagesResponse";
  } | {
    /**
     * @generated from field: qb.smg.ListFacesResponse listFacesResponse = 4;
     */
    value: ListFacesResponse;
    case: "listFacesResponse";
  } | {
    /**
     * @generated from field: qb.smg.DeleteUserImageResponse deleteUserImageResponse = 5;
     */
    value: DeleteUserImageResponse;
    case: "deleteUserImageResponse";
  } | {
    /**
     * @generated from field: qb.smg.HeartbeatResponse heartbeatResponse = 6;
     */
    value: HeartbeatResponse;
    case: "heartbeatResponse";
  } | {
    /**
     * @generated from field: qb.smg.DeleteLastActiveBeforeDateResponse deleteLastActiveBeforeDateResponse = 7;
     */
    value: DeleteLastActiveBeforeDateResponse;
    case: "deleteLastActiveBeforeDateResponse";
  } | {
    /**
     * @generated from field: qb.smg.RecognizeFaceResponse recognizeFaceResponse = 8;
     */
    value: RecognizeFaceResponse;
    case: "recognizeFaceResponse";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: string token = 9;
   */
  token: string;
};

/**
 * Describes the message qb.smg.CommandExecutorFRSPayload.
 * Use `create(CommandExecutorFRSPayloadSchema)` to create a new message.
 */
export const CommandExecutorFRSPayloadSchema: GenMessage<CommandExecutorFRSPayload> = /*@__PURE__*/
  messageDesc(file_smg_service, 61);

/**
 * @generated from message qb.smg.CommandExecutorSMGPayload
 */
export type CommandExecutorSMGPayload = Message<"qb.smg.CommandExecutorSMGPayload"> & {
  /**
   * @generated from oneof qb.smg.CommandExecutorSMGPayload.payload
   */
  payload: {
    /**
     * @generated from field: qb.smg.SetFaceRequest setFaceRequest = 2;
     */
    value: SetFaceRequest;
    case: "setFaceRequest";
  } | {
    /**
     * @generated from field: qb.smg.CompareImagesRequest compareImagesRequest = 3;
     */
    value: CompareImagesRequest;
    case: "compareImagesRequest";
  } | {
    /**
     * @generated from field: qb.smg.ListFacesRequest listFacesRequest = 4;
     */
    value: ListFacesRequest;
    case: "listFacesRequest";
  } | {
    /**
     * @generated from field: qb.smg.DeleteUserImageRequest deleteUserImageRequest = 5;
     */
    value: DeleteUserImageRequest;
    case: "deleteUserImageRequest";
  } | {
    /**
     * @generated from field: qb.smg.FrsHeartbeatRequest heartbeatRequest = 6;
     */
    value: FrsHeartbeatRequest;
    case: "heartbeatRequest";
  } | {
    /**
     * @generated from field: qb.smg.DeleteLastActiveBeforeDateRequest deleteLastActiveBeforeDateRequest = 7;
     */
    value: DeleteLastActiveBeforeDateRequest;
    case: "deleteLastActiveBeforeDateRequest";
  } | {
    /**
     * @generated from field: qb.smg.RecognizeFaceRequest recognizeFaceRequest = 8;
     */
    value: RecognizeFaceRequest;
    case: "recognizeFaceRequest";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message qb.smg.CommandExecutorSMGPayload.
 * Use `create(CommandExecutorSMGPayloadSchema)` to create a new message.
 */
export const CommandExecutorSMGPayloadSchema: GenMessage<CommandExecutorSMGPayload> = /*@__PURE__*/
  messageDesc(file_smg_service, 62);

/**
 * @generated from message qb.smg.GenerateS3ArchiveVideoUploadUrlRequest
 */
export type GenerateS3ArchiveVideoUploadUrlRequest = Message<"qb.smg.GenerateS3ArchiveVideoUploadUrlRequest"> & {
  /**
   * @generated from field: int64 venueId = 1;
   */
  venueId: bigint;

  /**
   * @generated from field: int64 stationId = 2;
   */
  stationId: bigint;

  /**
   * @generated from field: int64 cameraId = 3;
   */
  cameraId: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp captureTime = 4;
   */
  captureTime?: Timestamp;

  /**
   * @generated from field: string token = 5;
   */
  token: string;
};

/**
 * Describes the message qb.smg.GenerateS3ArchiveVideoUploadUrlRequest.
 * Use `create(GenerateS3ArchiveVideoUploadUrlRequestSchema)` to create a new message.
 */
export const GenerateS3ArchiveVideoUploadUrlRequestSchema: GenMessage<GenerateS3ArchiveVideoUploadUrlRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 63);

/**
 * @generated from message qb.smg.GenerateS3ArchiveVideoUploadUrlResponse
 */
export type GenerateS3ArchiveVideoUploadUrlResponse = Message<"qb.smg.GenerateS3ArchiveVideoUploadUrlResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: string uploadUrl = 3;
   */
  uploadUrl: string;
};

/**
 * Describes the message qb.smg.GenerateS3ArchiveVideoUploadUrlResponse.
 * Use `create(GenerateS3ArchiveVideoUploadUrlResponseSchema)` to create a new message.
 */
export const GenerateS3ArchiveVideoUploadUrlResponseSchema: GenMessage<GenerateS3ArchiveVideoUploadUrlResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 64);

/**
 * @generated from message qb.smg.StationWebcamUpdate
 */
export type StationWebcamUpdate = Message<"qb.smg.StationWebcamUpdate"> & {
  /**
   * @generated from field: int64 stationId = 1;
   */
  stationId: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp sendTime = 2;
   */
  sendTime?: Timestamp;

  /**
   * @generated from field: string frsIdentificationKey = 6;
   */
  frsIdentificationKey: string;

  /**
   * @generated from field: repeated qb.smg.StationWebcamUpdate.WebcamState webcamState = 3;
   */
  webcamState: StationWebcamUpdate_WebcamState[];

  /**
   * @generated from field: string token = 4;
   */
  token: string;

  /**
   * @generated from field: string frsTrackId = 5;
   */
  frsTrackId: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;

  /**
   * @generated from field: map<string, string> additional_parameters = 103;
   */
  additionalParameters: { [key: string]: string };
};

/**
 * Describes the message qb.smg.StationWebcamUpdate.
 * Use `create(StationWebcamUpdateSchema)` to create a new message.
 */
export const StationWebcamUpdateSchema: GenMessage<StationWebcamUpdate> = /*@__PURE__*/
  messageDesc(file_smg_service, 65);

/**
 * @generated from message qb.smg.StationWebcamUpdate.WebcamState
 */
export type StationWebcamUpdate_WebcamState = Message<"qb.smg.StationWebcamUpdate.WebcamState"> & {
  /**
   * @generated from field: string webcamId = 1;
   */
  webcamId: string;

  /**
   * @generated from field: google.protobuf.Timestamp captureTime = 2;
   */
  captureTime?: Timestamp;

  /**
   * @generated from field: bool face_detected = 3;
   */
  faceDetected: boolean;

  /**
   * @generated from field: int64 userId = 4;
   */
  userId: bigint;

  /**
   * @generated from field: float probability = 5;
   */
  probability: number;

  /**
   * @generated from field: bool multiple_human_detected = 6;
   */
  multipleHumanDetected: boolean;

  /**
   * @generated from field: int32 number_of_human_detected = 7;
   */
  numberOfHumanDetected: number;

  /**
   * @generated from field: qb.smg.StationWebcamUpdate.WebcamState.Side side = 8;
   */
  side: StationWebcamUpdate_WebcamState_Side;

  /**
   * @generated from field: int32 number_of_human_in_detectable_area = 9;
   */
  numberOfHumanInDetectableArea: number;

  /**
   * @generated from field: int64 userId_in_detectable_area = 10;
   */
  userIdInDetectableArea: bigint;

  /**
   * @generated from field: bool face_detected_in_detectable_area = 11;
   */
  faceDetectedInDetectableArea: boolean;
};

/**
 * Describes the message qb.smg.StationWebcamUpdate.WebcamState.
 * Use `create(StationWebcamUpdate_WebcamStateSchema)` to create a new message.
 */
export const StationWebcamUpdate_WebcamStateSchema: GenMessage<StationWebcamUpdate_WebcamState> = /*@__PURE__*/
  messageDesc(file_smg_service, 65, 0);

/**
 * @generated from enum qb.smg.StationWebcamUpdate.WebcamState.Side
 */
export enum StationWebcamUpdate_WebcamState_Side {
  /**
   * @generated from enum value: LEFT = 0;
   */
  LEFT = 0,

  /**
   * @generated from enum value: RIGHT = 1;
   */
  RIGHT = 1,
}

/**
 * Describes the enum qb.smg.StationWebcamUpdate.WebcamState.Side.
 */
export const StationWebcamUpdate_WebcamState_SideSchema: GenEnum<StationWebcamUpdate_WebcamState_Side> = /*@__PURE__*/
  enumDesc(file_smg_service, 65, 0, 0);

/**
 * @generated from message qb.smg.PushStationWebcamUpdatesResponse
 */
export type PushStationWebcamUpdatesResponse = Message<"qb.smg.PushStationWebcamUpdatesResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.PushStationWebcamUpdatesResponse.
 * Use `create(PushStationWebcamUpdatesResponseSchema)` to create a new message.
 */
export const PushStationWebcamUpdatesResponseSchema: GenMessage<PushStationWebcamUpdatesResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 66);

/**
 * @generated from message qb.smg.UploadImageRequest
 */
export type UploadImageRequest = Message<"qb.smg.UploadImageRequest"> & {
  /**
   * Data of the images.
   *
   * @generated from field: bytes image = 1;
   */
  image: Uint8Array;
};

/**
 * Describes the message qb.smg.UploadImageRequest.
 * Use `create(UploadImageRequestSchema)` to create a new message.
 */
export const UploadImageRequestSchema: GenMessage<UploadImageRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 67);

/**
 * @generated from message qb.smg.UploadImageReply
 */
export type UploadImageReply = Message<"qb.smg.UploadImageReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * The unique id for this image.
   *
   * @generated from field: int64 file_id = 3;
   */
  fileId: bigint;
};

/**
 * Describes the message qb.smg.UploadImageReply.
 * Use `create(UploadImageReplySchema)` to create a new message.
 */
export const UploadImageReplySchema: GenMessage<UploadImageReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 68);

/**
 * @generated from message qb.smg.RequestResetPinRequest
 */
export type RequestResetPinRequest = Message<"qb.smg.RequestResetPinRequest"> & {
  /**
   * @generated from field: string email_address = 1;
   */
  emailAddress: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.RequestResetPinRequest.
 * Use `create(RequestResetPinRequestSchema)` to create a new message.
 */
export const RequestResetPinRequestSchema: GenMessage<RequestResetPinRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 69);

/**
 * @generated from message qb.smg.RequestResetPinReply
 */
export type RequestResetPinReply = Message<"qb.smg.RequestResetPinReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.RequestResetPinReply.
 * Use `create(RequestResetPinReplySchema)` to create a new message.
 */
export const RequestResetPinReplySchema: GenMessage<RequestResetPinReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 70);

/**
 * @generated from message qb.smg.ResendEmailConfirmationRequest
 */
export type ResendEmailConfirmationRequest = Message<"qb.smg.ResendEmailConfirmationRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.ResendEmailConfirmationRequest.
 * Use `create(ResendEmailConfirmationRequestSchema)` to create a new message.
 */
export const ResendEmailConfirmationRequestSchema: GenMessage<ResendEmailConfirmationRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 71);

/**
 * @generated from message qb.smg.ResendEmailConfirmationReply
 */
export type ResendEmailConfirmationReply = Message<"qb.smg.ResendEmailConfirmationReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.ResendEmailConfirmationReply.
 * Use `create(ResendEmailConfirmationReplySchema)` to create a new message.
 */
export const ResendEmailConfirmationReplySchema: GenMessage<ResendEmailConfirmationReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 72);

/**
 * @generated from message qb.smg.ConfirmEmailRequest
 */
export type ConfirmEmailRequest = Message<"qb.smg.ConfirmEmailRequest"> & {
  /**
   * @generated from field: string confirmationToken = 1;
   */
  confirmationToken: string;
};

/**
 * Describes the message qb.smg.ConfirmEmailRequest.
 * Use `create(ConfirmEmailRequestSchema)` to create a new message.
 */
export const ConfirmEmailRequestSchema: GenMessage<ConfirmEmailRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 73);

/**
 * @generated from message qb.smg.ConfirmEmailReply
 */
export type ConfirmEmailReply = Message<"qb.smg.ConfirmEmailReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: qb.smg.Session session = 3;
   */
  session?: Session;

  /**
   * @generated from field: qb.smg.User user = 4;
   */
  user?: User;
};

/**
 * Describes the message qb.smg.ConfirmEmailReply.
 * Use `create(ConfirmEmailReplySchema)` to create a new message.
 */
export const ConfirmEmailReplySchema: GenMessage<ConfirmEmailReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 74);

/**
 * @generated from message qb.smg.DoResetPinRequest
 */
export type DoResetPinRequest = Message<"qb.smg.DoResetPinRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string new_pin = 2;
   */
  newPin: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.DoResetPinRequest.
 * Use `create(DoResetPinRequestSchema)` to create a new message.
 */
export const DoResetPinRequestSchema: GenMessage<DoResetPinRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 75);

/**
 * @generated from message qb.smg.DoResetPinReply
 */
export type DoResetPinReply = Message<"qb.smg.DoResetPinReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.DoResetPinReply.
 * Use `create(DoResetPinReplySchema)` to create a new message.
 */
export const DoResetPinReplySchema: GenMessage<DoResetPinReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 76);

/**
 * @generated from message qb.smg.RegisterUserRequest
 */
export type RegisterUserRequest = Message<"qb.smg.RegisterUserRequest"> & {
  /**
   * Login information (when not being identified by images).
   *
   * @generated from field: string email_address = 1;
   */
  emailAddress: string;

  /**
   * Login information (when being identified by email or images).
   *
   * @generated from field: string otpCode = 2;
   */
  otpCode: string;

  /**
   * Display name for this user.
   *
   * @generated from field: string username = 3;
   */
  username: string;

  /**
   * Whether the user is right- or left-handed.
   *
   * @generated from field: string handedness = 5;
   */
  handedness: string;

  /**
   * @generated from field: string phoneNumber = 6;
   */
  phoneNumber: string;

  /**
   * @generated from field: string firstname = 7;
   */
  firstname: string;

  /**
   * @generated from field: string middlename = 8;
   */
  middlename: string;

  /**
   * @generated from field: string lastname = 9;
   */
  lastname: string;

  /**
   * @generated from field: string address = 10;
   */
  address: string;

  /**
   * @generated from field: string country = 11;
   */
  country: string;

  /**
   * @generated from field: string state = 12;
   */
  state: string;

  /**
   * @generated from field: string city = 13;
   */
  city: string;

  /**
   * @generated from field: string zipcode = 14;
   */
  zipcode: string;

  /**
   * @generated from field: string handicap = 15;
   */
  handicap: string;

  /**
   * YYYY-MM-DD
   *
   * @generated from field: string date_of_birth = 16;
   */
  dateOfBirth: string;

  /**
   * @generated from field: qb.smg.OtpMethod preferredOtpMethod = 17;
   */
  preferredOtpMethod: OtpMethod;

  /**
   * @generated from field: qb.smg.Gender gender = 18;
   */
  gender: Gender;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.RegisterUserRequest.
 * Use `create(RegisterUserRequestSchema)` to create a new message.
 */
export const RegisterUserRequestSchema: GenMessage<RegisterUserRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 77);

/**
 * @generated from message qb.smg.RegisterUserReply
 */
export type RegisterUserReply = Message<"qb.smg.RegisterUserReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * Details of this session (including UserId).
   *
   * @generated from field: qb.smg.Session session = 3;
   */
  session?: Session;
};

/**
 * Describes the message qb.smg.RegisterUserReply.
 * Use `create(RegisterUserReplySchema)` to create a new message.
 */
export const RegisterUserReplySchema: GenMessage<RegisterUserReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 78);

/**
 * @generated from message qb.smg.LocateVenueRequest
 */
export type LocateVenueRequest = Message<"qb.smg.LocateVenueRequest"> & {
  /**
   * @generated from field: qb.smg.Location location = 1;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 2;
   */
  venueId: number;

  /**
   * @generated from field: string token = 3;
   */
  token: string;
};

/**
 * Describes the message qb.smg.LocateVenueRequest.
 * Use `create(LocateVenueRequestSchema)` to create a new message.
 */
export const LocateVenueRequestSchema: GenMessage<LocateVenueRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 79);

/**
 * @generated from message qb.smg.LocateVenueReply
 */
export type LocateVenueReply = Message<"qb.smg.LocateVenueReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: qb.smg.VenueConfig venueConfig = 3;
   */
  venueConfig?: VenueConfig;
};

/**
 * Describes the message qb.smg.LocateVenueReply.
 * Use `create(LocateVenueReplySchema)` to create a new message.
 */
export const LocateVenueReplySchema: GenMessage<LocateVenueReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 80);

/**
 * @generated from message qb.smg.CheckUserEmailExistsRequest
 */
export type CheckUserEmailExistsRequest = Message<"qb.smg.CheckUserEmailExistsRequest"> & {
  /**
   * @generated from field: string email_address = 1;
   */
  emailAddress: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.CheckUserEmailExistsRequest.
 * Use `create(CheckUserEmailExistsRequestSchema)` to create a new message.
 */
export const CheckUserEmailExistsRequestSchema: GenMessage<CheckUserEmailExistsRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 81);

/**
 * @generated from message qb.smg.CheckUserEmailExistsReply
 */
export type CheckUserEmailExistsReply = Message<"qb.smg.CheckUserEmailExistsReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: bool exists = 3;
   */
  exists: boolean;
};

/**
 * Describes the message qb.smg.CheckUserEmailExistsReply.
 * Use `create(CheckUserEmailExistsReplySchema)` to create a new message.
 */
export const CheckUserEmailExistsReplySchema: GenMessage<CheckUserEmailExistsReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 82);

/**
 * @generated from message qb.smg.ReplacePhotoRequest
 */
export type ReplacePhotoRequest = Message<"qb.smg.ReplacePhotoRequest"> & {
  /**
   * @generated from field: int64 request_id = 1;
   */
  requestId: bigint;

  /**
   * @generated from field: int64 player_id = 2;
   */
  playerId: bigint;

  /**
   * @generated from field: int64 date_of_request = 4;
   */
  dateOfRequest: bigint;

  /**
   * @generated from field: bytes photo = 5;
   */
  photo: Uint8Array;

  /**
   * @generated from field: string reason_for_request = 6;
   */
  reasonForRequest: string;

  /**
   * @generated from field: qb.smg.ReplacePhotoStatus status = 7;
   */
  status: ReplacePhotoStatus;

  /**
   * @generated from field: string csr_comment = 8;
   */
  csrComment: string;

  /**
   * @generated from field: int64 csr_id = 9;
   */
  csrId: bigint;

  /**
   * @generated from field: int64 date_of_the_decision = 10;
   */
  dateOfTheDecision: bigint;
};

/**
 * Describes the message qb.smg.ReplacePhotoRequest.
 * Use `create(ReplacePhotoRequestSchema)` to create a new message.
 */
export const ReplacePhotoRequestSchema: GenMessage<ReplacePhotoRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 83);

/**
 * @generated from message qb.smg.RequestChangePhotoRequest
 */
export type RequestChangePhotoRequest = Message<"qb.smg.RequestChangePhotoRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: bytes photo = 2;
   */
  photo: Uint8Array;

  /**
   * @generated from field: string reason_for_request = 3;
   */
  reasonForRequest: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.RequestChangePhotoRequest.
 * Use `create(RequestChangePhotoRequestSchema)` to create a new message.
 */
export const RequestChangePhotoRequestSchema: GenMessage<RequestChangePhotoRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 84);

/**
 * @generated from message qb.smg.RequestChangePhotoReply
 */
export type RequestChangePhotoReply = Message<"qb.smg.RequestChangePhotoReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: qb.smg.ReplacePhotoRequest replacePhotoRequest = 3;
   */
  replacePhotoRequest?: ReplacePhotoRequest;
};

/**
 * Describes the message qb.smg.RequestChangePhotoReply.
 * Use `create(RequestChangePhotoReplySchema)` to create a new message.
 */
export const RequestChangePhotoReplySchema: GenMessage<RequestChangePhotoReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 85);

/**
 * @generated from message qb.smg.GetChangePhotoRequestsRequest
 */
export type GetChangePhotoRequestsRequest = Message<"qb.smg.GetChangePhotoRequestsRequest"> & {
  /**
   * @generated from field: int64 request_id = 1;
   */
  requestId: bigint;

  /**
   * @generated from field: int64 player_id = 2;
   */
  playerId: bigint;

  /**
   * @generated from field: int64 date_start = 3;
   */
  dateStart: bigint;

  /**
   * @generated from field: int64 date_end = 4;
   */
  dateEnd: bigint;

  /**
   * @generated from field: qb.smg.ReplacePhotoStatus status = 5;
   */
  status: ReplacePhotoStatus;

  /**
   * @generated from field: string token = 6;
   */
  token: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.GetChangePhotoRequestsRequest.
 * Use `create(GetChangePhotoRequestsRequestSchema)` to create a new message.
 */
export const GetChangePhotoRequestsRequestSchema: GenMessage<GetChangePhotoRequestsRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 86);

/**
 * @generated from message qb.smg.GetChangePhotoRequestsReply
 */
export type GetChangePhotoRequestsReply = Message<"qb.smg.GetChangePhotoRequestsReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated qb.smg.ReplacePhotoRequest replace_photo_requests = 3;
   */
  replacePhotoRequests: ReplacePhotoRequest[];
};

/**
 * Describes the message qb.smg.GetChangePhotoRequestsReply.
 * Use `create(GetChangePhotoRequestsReplySchema)` to create a new message.
 */
export const GetChangePhotoRequestsReplySchema: GenMessage<GetChangePhotoRequestsReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 87);

/**
 * @generated from message qb.smg.ApproveChangePhotoRequestRequest
 */
export type ApproveChangePhotoRequestRequest = Message<"qb.smg.ApproveChangePhotoRequestRequest"> & {
  /**
   * @generated from field: int64 request_id = 1;
   */
  requestId: bigint;

  /**
   * @generated from field: int64 csr_id = 2;
   */
  csrId: bigint;

  /**
   * @generated from field: string comment_from_csr = 3;
   */
  commentFromCsr: string;

  /**
   * @generated from field: bool approved = 4;
   */
  approved: boolean;

  /**
   * @generated from field: string token = 5;
   */
  token: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.ApproveChangePhotoRequestRequest.
 * Use `create(ApproveChangePhotoRequestRequestSchema)` to create a new message.
 */
export const ApproveChangePhotoRequestRequestSchema: GenMessage<ApproveChangePhotoRequestRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 88);

/**
 * @generated from message qb.smg.ApproveChangePhotoRequestReply
 */
export type ApproveChangePhotoRequestReply = Message<"qb.smg.ApproveChangePhotoRequestReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: qb.smg.ReplacePhotoRequest replacePhotoRequest = 3;
   */
  replacePhotoRequest?: ReplacePhotoRequest;
};

/**
 * Describes the message qb.smg.ApproveChangePhotoRequestReply.
 * Use `create(ApproveChangePhotoRequestReplySchema)` to create a new message.
 */
export const ApproveChangePhotoRequestReplySchema: GenMessage<ApproveChangePhotoRequestReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 89);

/**
 * @generated from message qb.smg.GetTncRequest
 */
export type GetTncRequest = Message<"qb.smg.GetTncRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * optional parameter, if not provided, will return latest version
   *
   * @generated from field: string version = 2;
   */
  version: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.GetTncRequest.
 * Use `create(GetTncRequestSchema)` to create a new message.
 */
export const GetTncRequestSchema: GenMessage<GetTncRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 90);

/**
 * @generated from message qb.smg.GetTncReply
 */
export type GetTncReply = Message<"qb.smg.GetTncReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: string version = 3;
   */
  version: string;

  /**
   * @generated from field: string content = 4;
   */
  content: string;
};

/**
 * Describes the message qb.smg.GetTncReply.
 * Use `create(GetTncReplySchema)` to create a new message.
 */
export const GetTncReplySchema: GenMessage<GetTncReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 91);

/**
 * @generated from message qb.smg.AcceptTncRequest
 */
export type AcceptTncRequest = Message<"qb.smg.AcceptTncRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.AcceptTncRequest.
 * Use `create(AcceptTncRequestSchema)` to create a new message.
 */
export const AcceptTncRequestSchema: GenMessage<AcceptTncRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 92);

/**
 * @generated from message qb.smg.AcceptTncReply
 */
export type AcceptTncReply = Message<"qb.smg.AcceptTncReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.AcceptTncReply.
 * Use `create(AcceptTncReplySchema)` to create a new message.
 */
export const AcceptTncReplySchema: GenMessage<AcceptTncReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 93);

/**
 * @generated from message qb.smg.OcrResult
 */
export type OcrResult = Message<"qb.smg.OcrResult"> & {
  /**
   * @generated from field: string first_name = 1;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 2;
   */
  lastName: string;

  /**
   * @generated from field: string country = 3;
   */
  country: string;

  /**
   * @generated from field: string state = 4;
   */
  state: string;

  /**
   * @generated from field: string city = 5;
   */
  city: string;

  /**
   * @generated from field: string street = 6;
   */
  street: string;
};

/**
 * Describes the message qb.smg.OcrResult.
 * Use `create(OcrResultSchema)` to create a new message.
 */
export const OcrResultSchema: GenMessage<OcrResult> = /*@__PURE__*/
  messageDesc(file_smg_service, 94);

/**
 * @generated from message qb.smg.DriverLicenseFrontExtractedData
 */
export type DriverLicenseFrontExtractedData = Message<"qb.smg.DriverLicenseFrontExtractedData"> & {
  /**
   * @generated from field: string first_name = 1;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 2;
   */
  lastName: string;

  /**
   * @generated from field: string country = 3;
   */
  country: string;

  /**
   * @generated from field: string state = 4;
   */
  state: string;

  /**
   * @generated from field: string city = 5;
   */
  city: string;

  /**
   * @generated from field: string street = 6;
   */
  street: string;
};

/**
 * Describes the message qb.smg.DriverLicenseFrontExtractedData.
 * Use `create(DriverLicenseFrontExtractedDataSchema)` to create a new message.
 */
export const DriverLicenseFrontExtractedDataSchema: GenMessage<DriverLicenseFrontExtractedData> = /*@__PURE__*/
  messageDesc(file_smg_service, 95);

/**
 * @generated from message qb.smg.DriverLicenseBackExtractedData
 */
export type DriverLicenseBackExtractedData = Message<"qb.smg.DriverLicenseBackExtractedData"> & {
  /**
   * @generated from field: string first_name = 1;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 2;
   */
  lastName: string;

  /**
   * @generated from field: string address = 3;
   */
  address: string;

  /**
   * @generated from field: string city = 4;
   */
  city: string;

  /**
   * @generated from field: string state = 5;
   */
  state: string;

  /**
   * @generated from field: string country = 6;
   */
  country: string;
};

/**
 * Describes the message qb.smg.DriverLicenseBackExtractedData.
 * Use `create(DriverLicenseBackExtractedDataSchema)` to create a new message.
 */
export const DriverLicenseBackExtractedDataSchema: GenMessage<DriverLicenseBackExtractedData> = /*@__PURE__*/
  messageDesc(file_smg_service, 96);

/**
 * @generated from message qb.smg.StartVeriffKycVerificationRequest
 */
export type StartVeriffKycVerificationRequest = Message<"qb.smg.StartVeriffKycVerificationRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.StartVeriffKycVerificationRequest.
 * Use `create(StartVeriffKycVerificationRequestSchema)` to create a new message.
 */
export const StartVeriffKycVerificationRequestSchema: GenMessage<StartVeriffKycVerificationRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 97);

/**
 * @generated from message qb.smg.StartVeriffKycVerificationResponse
 */
export type StartVeriffKycVerificationResponse = Message<"qb.smg.StartVeriffKycVerificationResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: string veriffUrl = 3;
   */
  veriffUrl: string;
};

/**
 * Describes the message qb.smg.StartVeriffKycVerificationResponse.
 * Use `create(StartVeriffKycVerificationResponseSchema)` to create a new message.
 */
export const StartVeriffKycVerificationResponseSchema: GenMessage<StartVeriffKycVerificationResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 98);

/**
 * @generated from message qb.smg.SubmitPhotoRequest
 */
export type SubmitPhotoRequest = Message<"qb.smg.SubmitPhotoRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: bytes image = 2;
   */
  image: Uint8Array;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.SubmitPhotoRequest.
 * Use `create(SubmitPhotoRequestSchema)` to create a new message.
 */
export const SubmitPhotoRequestSchema: GenMessage<SubmitPhotoRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 99);

/**
 * @generated from message qb.smg.SubmitPhotoReply
 */
export type SubmitPhotoReply = Message<"qb.smg.SubmitPhotoReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: bool is_recognized = 3;
   */
  isRecognized: boolean;

  /**
   * @generated from field: bool submission_allowed = 4;
   */
  submissionAllowed: boolean;
};

/**
 * Describes the message qb.smg.SubmitPhotoReply.
 * Use `create(SubmitPhotoReplySchema)` to create a new message.
 */
export const SubmitPhotoReplySchema: GenMessage<SubmitPhotoReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 100);

/**
 * @generated from message qb.smg.ContactCsrRequest
 */
export type ContactCsrRequest = Message<"qb.smg.ContactCsrRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string request = 2;
   */
  request: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.ContactCsrRequest.
 * Use `create(ContactCsrRequestSchema)` to create a new message.
 */
export const ContactCsrRequestSchema: GenMessage<ContactCsrRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 101);

/**
 * @generated from message qb.smg.ContactCsrReply
 */
export type ContactCsrReply = Message<"qb.smg.ContactCsrReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.ContactCsrReply.
 * Use `create(ContactCsrReplySchema)` to create a new message.
 */
export const ContactCsrReplySchema: GenMessage<ContactCsrReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 102);

/**
 * @generated from message qb.smg.UpdateUserRequest
 */
export type UpdateUserRequest = Message<"qb.smg.UpdateUserRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string first_name = 2;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 3;
   */
  lastName: string;

  /**
   * Display name for this user.
   *
   * @generated from field: string username = 4;
   */
  username: string;

  /**
   * @generated from field: google.protobuf.Timestamp date_of_birth = 5;
   */
  dateOfBirth?: Timestamp;

  /**
   * Whether the user is right- or left-handed.
   *
   * @generated from field: string handedness = 6;
   */
  handedness: string;

  /**
   * @generated from field: string handicap = 16;
   */
  handicap: string;

  /**
   * @generated from field: qb.smg.Gender gender = 20;
   */
  gender: Gender;

  /**
   * default true [set upon registration]
   *
   * @generated from field: bool allow_text_notifications = 17;
   */
  allowTextNotifications: boolean;

  /**
   * default true
   *
   * @generated from field: bool allow_email_notifications = 18;
   */
  allowEmailNotifications: boolean;

  /**
   * default true
   *
   * @generated from field: bool allow_partner_promos = 19;
   */
  allowPartnerPromos: boolean;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.UpdateUserRequest.
 * Use `create(UpdateUserRequestSchema)` to create a new message.
 */
export const UpdateUserRequestSchema: GenMessage<UpdateUserRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 103);

/**
 * @generated from message qb.smg.UpdateUserReply
 */
export type UpdateUserReply = Message<"qb.smg.UpdateUserReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * Details of this session (including UserId).
   *
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.UpdateUserReply.
 * Use `create(UpdateUserReplySchema)` to create a new message.
 */
export const UpdateUserReplySchema: GenMessage<UpdateUserReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 104);

/**
 * @generated from message qb.smg.EmailLoginRequest
 */
export type EmailLoginRequest = Message<"qb.smg.EmailLoginRequest"> & {
  /**
   * Login information.
   *
   * @generated from field: string email_address = 1;
   */
  emailAddress: string;

  /**
   * Same password is used for both email login and image login.
   *
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.EmailLoginRequest.
 * Use `create(EmailLoginRequestSchema)` to create a new message.
 */
export const EmailLoginRequestSchema: GenMessage<EmailLoginRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 105);

/**
 * @generated from message qb.smg.EmailLoginReply
 */
export type EmailLoginReply = Message<"qb.smg.EmailLoginReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * Details of this session (including UserId).
   *
   * @generated from field: qb.smg.Session session = 3;
   */
  session?: Session;

  /**
   * @generated from field: qb.smg.User user = 4;
   */
  user?: User;
};

/**
 * Describes the message qb.smg.EmailLoginReply.
 * Use `create(EmailLoginReplySchema)` to create a new message.
 */
export const EmailLoginReplySchema: GenMessage<EmailLoginReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 106);

/**
 * @generated from message qb.smg.ImageLoginRequest
 */
export type ImageLoginRequest = Message<"qb.smg.ImageLoginRequest"> & {
  /**
   * @generated from field: bytes image = 2;
   */
  image: Uint8Array;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.ImageLoginRequest.
 * Use `create(ImageLoginRequestSchema)` to create a new message.
 */
export const ImageLoginRequestSchema: GenMessage<ImageLoginRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 107);

/**
 * @generated from message qb.smg.ImageLoginReply
 */
export type ImageLoginReply = Message<"qb.smg.ImageLoginReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * Details of this session (including UserId).
   *
   * @generated from field: qb.smg.Session session = 3;
   */
  session?: Session;

  /**
   * @generated from field: qb.smg.User user = 4;
   */
  user?: User;
};

/**
 * Describes the message qb.smg.ImageLoginReply.
 * Use `create(ImageLoginReplySchema)` to create a new message.
 */
export const ImageLoginReplySchema: GenMessage<ImageLoginReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 108);

/**
 * @generated from message qb.smg.RequestOtpCodeRequest
 */
export type RequestOtpCodeRequest = Message<"qb.smg.RequestOtpCodeRequest"> & {
  /**
   * Login information.
   *
   * @generated from field: string email_address = 1;
   */
  emailAddress: string;

  /**
   * Login information.
   *
   * @generated from field: string phone_number = 2;
   */
  phoneNumber: string;

  /**
   * @generated from field: qb.smg.OtpMethod preferredOtpMethod = 3;
   */
  preferredOtpMethod: OtpMethod;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.RequestOtpCodeRequest.
 * Use `create(RequestOtpCodeRequestSchema)` to create a new message.
 */
export const RequestOtpCodeRequestSchema: GenMessage<RequestOtpCodeRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 109);

/**
 * @generated from message qb.smg.RequestOtpCodeReply
 */
export type RequestOtpCodeReply = Message<"qb.smg.RequestOtpCodeReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * The channel the code was actually delivered on (resolved server-side from
   * the account's PreferredOtpMethod). Lets callers that don't know the user's
   * contact details render "sent to your phone" vs "sent to your email".
   *
   * @generated from field: qb.smg.OtpMethod delivery_method = 3;
   */
  deliveryMethod: OtpMethod;

  /**
   * Destination with all but the last identifying characters masked
   * (e.g. "•••-•••-3318" for SMS, "j•••@example.com" for email). Safe to show
   * in UI; never carries the full phone/email.
   *
   * @generated from field: string masked_destination = 4;
   */
  maskedDestination: string;
};

/**
 * Describes the message qb.smg.RequestOtpCodeReply.
 * Use `create(RequestOtpCodeReplySchema)` to create a new message.
 */
export const RequestOtpCodeReplySchema: GenMessage<RequestOtpCodeReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 110);

/**
 * @generated from message qb.smg.RetrieveCodeForAdminRequest
 */
export type RetrieveCodeForAdminRequest = Message<"qb.smg.RetrieveCodeForAdminRequest"> & {
  /**
   * Login information.
   *
   * @generated from field: string email_address = 1;
   */
  emailAddress: string;

  /**
   * Login information.
   *
   * @generated from field: string phone_number = 2;
   */
  phoneNumber: string;

  /**
   * @generated from field: qb.smg.OtpMethod preferredOtpMethod = 3;
   */
  preferredOtpMethod: OtpMethod;

  /**
   * @generated from field: string wipe_key = 4;
   */
  wipeKey: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.RetrieveCodeForAdminRequest.
 * Use `create(RetrieveCodeForAdminRequestSchema)` to create a new message.
 */
export const RetrieveCodeForAdminRequestSchema: GenMessage<RetrieveCodeForAdminRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 111);

/**
 * @generated from message qb.smg.RetrieveCodeForAdminReply
 */
export type RetrieveCodeForAdminReply = Message<"qb.smg.RetrieveCodeForAdminReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: string code = 3;
   */
  code: string;
};

/**
 * Describes the message qb.smg.RetrieveCodeForAdminReply.
 * Use `create(RetrieveCodeForAdminReplySchema)` to create a new message.
 */
export const RetrieveCodeForAdminReplySchema: GenMessage<RetrieveCodeForAdminReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 112);

/**
 * @generated from message qb.smg.EnableSelfLimitationRequest
 */
export type EnableSelfLimitationRequest = Message<"qb.smg.EnableSelfLimitationRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: qb.smg.EnableSelfLimitationRequest.TimeFrame time_frame = 2;
   */
  timeFrame: EnableSelfLimitationRequest_TimeFrame;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.EnableSelfLimitationRequest.
 * Use `create(EnableSelfLimitationRequestSchema)` to create a new message.
 */
export const EnableSelfLimitationRequestSchema: GenMessage<EnableSelfLimitationRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 113);

/**
 * @generated from enum qb.smg.EnableSelfLimitationRequest.TimeFrame
 */
export enum EnableSelfLimitationRequest_TimeFrame {
  /**
   * @generated from enum value: SIX_MONTH = 0;
   */
  SIX_MONTH = 0,

  /**
   * @generated from enum value: ONE_YEAR = 1;
   */
  ONE_YEAR = 1,

  /**
   * @generated from enum value: TWO_YEAR = 2;
   */
  TWO_YEAR = 2,

  /**
   * @generated from enum value: FOREVER = 3;
   */
  FOREVER = 3,
}

/**
 * Describes the enum qb.smg.EnableSelfLimitationRequest.TimeFrame.
 */
export const EnableSelfLimitationRequest_TimeFrameSchema: GenEnum<EnableSelfLimitationRequest_TimeFrame> = /*@__PURE__*/
  enumDesc(file_smg_service, 113, 0);

/**
 * @generated from message qb.smg.EnableSelfLimitationReply
 */
export type EnableSelfLimitationReply = Message<"qb.smg.EnableSelfLimitationReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.EnableSelfLimitationReply.
 * Use `create(EnableSelfLimitationReplySchema)` to create a new message.
 */
export const EnableSelfLimitationReplySchema: GenMessage<EnableSelfLimitationReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 114);

/**
 * @generated from message qb.smg.OtpLoginRequest
 */
export type OtpLoginRequest = Message<"qb.smg.OtpLoginRequest"> & {
  /**
   * Login information.
   *
   * @generated from field: string email_address = 1;
   */
  emailAddress: string;

  /**
   * @generated from field: string otp_code = 2;
   */
  otpCode: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.OtpLoginRequest.
 * Use `create(OtpLoginRequestSchema)` to create a new message.
 */
export const OtpLoginRequestSchema: GenMessage<OtpLoginRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 115);

/**
 * @generated from message qb.smg.OtpLoginReply
 */
export type OtpLoginReply = Message<"qb.smg.OtpLoginReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * Details of this session (including UserId).
   *
   * @generated from field: qb.smg.Session session = 3;
   */
  session?: Session;

  /**
   * @generated from field: qb.smg.User user = 4;
   */
  user?: User;
};

/**
 * Describes the message qb.smg.OtpLoginReply.
 * Use `create(OtpLoginReplySchema)` to create a new message.
 */
export const OtpLoginReplySchema: GenMessage<OtpLoginReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 116);

/**
 * @generated from message qb.smg.VerifyOtpCodeRequest
 */
export type VerifyOtpCodeRequest = Message<"qb.smg.VerifyOtpCodeRequest"> & {
  /**
   * Login information.
   *
   * @generated from field: string email_address = 1;
   */
  emailAddress: string;

  /**
   * Login information.
   *
   * @generated from field: string phone_number = 2;
   */
  phoneNumber: string;

  /**
   * @generated from field: string otp_code = 3;
   */
  otpCode: string;
};

/**
 * Describes the message qb.smg.VerifyOtpCodeRequest.
 * Use `create(VerifyOtpCodeRequestSchema)` to create a new message.
 */
export const VerifyOtpCodeRequestSchema: GenMessage<VerifyOtpCodeRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 117);

/**
 * @generated from message qb.smg.VerifyOtpCodeReply
 */
export type VerifyOtpCodeReply = Message<"qb.smg.VerifyOtpCodeReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: bool codeIsCorrect = 3;
   */
  codeIsCorrect: boolean;
};

/**
 * Describes the message qb.smg.VerifyOtpCodeReply.
 * Use `create(VerifyOtpCodeReplySchema)` to create a new message.
 */
export const VerifyOtpCodeReplySchema: GenMessage<VerifyOtpCodeReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 118);

/**
 * @generated from message qb.smg.LoginWithIdTokenRequest
 */
export type LoginWithIdTokenRequest = Message<"qb.smg.LoginWithIdTokenRequest"> & {
  /**
   * @generated from field: string id_token = 2;
   */
  idToken: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.LoginWithIdTokenRequest.
 * Use `create(LoginWithIdTokenRequestSchema)` to create a new message.
 */
export const LoginWithIdTokenRequestSchema: GenMessage<LoginWithIdTokenRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 119);

/**
 * @generated from message qb.smg.LoginWithIdTokenReply
 */
export type LoginWithIdTokenReply = Message<"qb.smg.LoginWithIdTokenReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * Details of this session (including UserId).
   *
   * @generated from field: qb.smg.Session session = 3;
   */
  session?: Session;

  /**
   * @generated from field: qb.smg.User user = 4;
   */
  user?: User;
};

/**
 * Describes the message qb.smg.LoginWithIdTokenReply.
 * Use `create(LoginWithIdTokenReplySchema)` to create a new message.
 */
export const LoginWithIdTokenReplySchema: GenMessage<LoginWithIdTokenReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 120);

/**
 * @generated from message qb.smg.GetUserRequest
 */
export type GetUserRequest = Message<"qb.smg.GetUserRequest"> & {
  /**
   * The token of this session.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.GetUserRequest.
 * Use `create(GetUserRequestSchema)` to create a new message.
 */
export const GetUserRequestSchema: GenMessage<GetUserRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 121);

/**
 * @generated from message qb.smg.GetUserReply
 */
export type GetUserReply = Message<"qb.smg.GetUserReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * The details of this user.
   *
   * @generated from field: qb.smg.User user = 3;
   */
  user?: User;

  /**
   * @generated from field: int32 maxShotAmount = 25;
   */
  maxShotAmount: number;

  /**
   * @generated from field: bool hasActiveTournament = 26;
   */
  hasActiveTournament: boolean;

  /**
   * @generated from field: bool isNewPlayer = 27;
   */
  isNewPlayer: boolean;

  /**
   * @generated from field: int32 freeShotCount = 28;
   */
  freeShotCount: number;

  /**
   * @generated from field: int32 freeShotNumber = 29;
   */
  freeShotNumber: number;

  /**
   * @generated from field: bool hasNewBonus = 30;
   */
  hasNewBonus: boolean;

  /**
   * the amount of auto play for tournament, if 0 then bets will be played with 0 amount, if -3 then autoplay is disabled due to insufficient balance
   *
   * @generated from field: int32 tournament_auto_play_amount = 31;
   */
  tournamentAutoPlayAmount: number;

  /**
   * Total points accumulated by the user
   *
   * @generated from field: int64 total_points = 32;
   */
  totalPoints: bigint;

  /**
   * Points accumulated in the current year
   *
   * @generated from field: int64 current_year_points = 33;
   */
  currentYearPoints: bigint;

  /**
   * @generated from field: string current_tier = 34;
   */
  currentTier: string;

  /**
   * @generated from field: int64 amount_won_current_year = 35;
   */
  amountWonCurrentYear: bigint;

  /**
   * @generated from field: int64 skill_index = 36;
   */
  skillIndex: bigint;

  /**
   * @generated from field: string status_tier = 37;
   */
  statusTier: string;
};

/**
 * Describes the message qb.smg.GetUserReply.
 * Use `create(GetUserReplySchema)` to create a new message.
 */
export const GetUserReplySchema: GenMessage<GetUserReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 122);

/**
 * @generated from message qb.smg.GetBalanceRequest
 */
export type GetBalanceRequest = Message<"qb.smg.GetBalanceRequest"> & {
  /**
   * The token of this session.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.GetBalanceRequest.
 * Use `create(GetBalanceRequestSchema)` to create a new message.
 */
export const GetBalanceRequestSchema: GenMessage<GetBalanceRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 123);

/**
 * @generated from message qb.smg.GetBalanceReply
 */
export type GetBalanceReply = Message<"qb.smg.GetBalanceReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * The player's current balance.
   *
   * @generated from field: int64 balance = 3;
   */
  balance: bigint;

  /**
   * The player's current available bonuses balance.
   *
   * @generated from field: int64 total_bonuses_balance = 4;
   */
  totalBonusesBalance: bigint;

  /**
   * @generated from field: repeated qb.smg.WalletBonus wallet_bonuses = 5;
   */
  walletBonuses: WalletBonus[];
};

/**
 * Describes the message qb.smg.GetBalanceReply.
 * Use `create(GetBalanceReplySchema)` to create a new message.
 */
export const GetBalanceReplySchema: GenMessage<GetBalanceReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 124);

/**
 * @generated from message qb.smg.WalletBonus
 */
export type WalletBonus = Message<"qb.smg.WalletBonus"> & {
  /**
   * @generated from field: uint64 bonus_id = 1;
   */
  bonusId: bigint;

  /**
   * @generated from field: int64 bonus_amount = 2;
   */
  bonusAmount: bigint;

  /**
   * @generated from field: int64 turnover_amount = 3;
   */
  turnoverAmount: bigint;

  /**
   * @generated from field: int64 turnover_current = 4;
   */
  turnoverCurrent: bigint;
};

/**
 * Describes the message qb.smg.WalletBonus.
 * Use `create(WalletBonusSchema)` to create a new message.
 */
export const WalletBonusSchema: GenMessage<WalletBonus> = /*@__PURE__*/
  messageDesc(file_smg_service, 125);

/**
 * @generated from message qb.smg.BetResolutionRequest
 */
export type BetResolutionRequest = Message<"qb.smg.BetResolutionRequest"> & {
  /**
   * The token of this session.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 bet_id = 2;
   */
  betId: bigint;

  /**
   * Client-supplied key used by Core to dedupe refund/cancel requests.
   * Required on admin-path RPCs (RefundBetByAdmin / CancelBetByAdmin),
   * accepted but tolerant on user-path RPCs (RefundBet / CancelBet).
   * Reusing a key with a different payload (bet_id, actor_id, reason)
   * is rejected.
   *
   * @generated from field: string idempotency_key = 3;
   */
  idempotencyKey: string;

  /**
   * Identifier of the human/system initiating the action. On admin-path
   * RPCs, populated by Backoffice from the admin's authenticated user
   * ID. On user-path RPCs, leave empty — Core derives it from the
   * session. Free-form string; opaque to Core.
   *
   * @generated from field: string actor_id = 4;
   */
  actorId: string;

  /**
   * Operator-supplied reason for the refund/cancel (e.g. "duplicate
   * charge"). Set by Backoffice on admin-path RPCs; empty on user-path
   * RPCs where no reason is captured at the UI.
   *
   * @generated from field: string reason = 5;
   */
  reason: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.BetResolutionRequest.
 * Use `create(BetResolutionRequestSchema)` to create a new message.
 */
export const BetResolutionRequestSchema: GenMessage<BetResolutionRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 126);

/**
 * @generated from message qb.smg.BetResolutionReply
 */
export type BetResolutionReply = Message<"qb.smg.BetResolutionReply"> & {
  /**
   * @generated from field: bool resolved = 1;
   */
  resolved: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.BetResolutionReply.
 * Use `create(BetResolutionReplySchema)` to create a new message.
 */
export const BetResolutionReplySchema: GenMessage<BetResolutionReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 127);

/**
 * @generated from message qb.smg.GetBetsRequest
 */
export type GetBetsRequest = Message<"qb.smg.GetBetsRequest"> & {
  /**
   * The token of this session.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * The specific criteria for the bets being asked for.
   *
   * @generated from field: string bet_state = 2;
   */
  betState: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.GetBetsRequest.
 * Use `create(GetBetsRequestSchema)` to create a new message.
 */
export const GetBetsRequestSchema: GenMessage<GetBetsRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 128);

/**
 * @generated from message qb.smg.GetBetsReply
 */
export type GetBetsReply = Message<"qb.smg.GetBetsReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * Bets matching the criteria.
   *
   * @generated from field: repeated qb.smg.Bet bets = 3;
   */
  bets: Bet[];
};

/**
 * Describes the message qb.smg.GetBetsReply.
 * Use `create(GetBetsReplySchema)` to create a new message.
 */
export const GetBetsReplySchema: GenMessage<GetBetsReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 129);

/**
 * @generated from message qb.smg.GetUpcomingBetsForSimulatorRequest
 */
export type GetUpcomingBetsForSimulatorRequest = Message<"qb.smg.GetUpcomingBetsForSimulatorRequest"> & {
  /**
   * The token of this session.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 user_id = 3;
   */
  userId: bigint;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.GetUpcomingBetsForSimulatorRequest.
 * Use `create(GetUpcomingBetsForSimulatorRequestSchema)` to create a new message.
 */
export const GetUpcomingBetsForSimulatorRequestSchema: GenMessage<GetUpcomingBetsForSimulatorRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 130);

/**
 * @generated from message qb.smg.GetUpcomingBetsForSimulatorReply
 */
export type GetUpcomingBetsForSimulatorReply = Message<"qb.smg.GetUpcomingBetsForSimulatorReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * Bets matching the criteria.
   *
   * @generated from field: repeated qb.smg.Bet bets = 3;
   */
  bets: Bet[];
};

/**
 * Describes the message qb.smg.GetUpcomingBetsForSimulatorReply.
 * Use `create(GetUpcomingBetsForSimulatorReplySchema)` to create a new message.
 */
export const GetUpcomingBetsForSimulatorReplySchema: GenMessage<GetUpcomingBetsForSimulatorReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 131);

/**
 * @generated from message qb.smg.GetPayoutRequest
 */
export type GetPayoutRequest = Message<"qb.smg.GetPayoutRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 bet_id = 2;
   */
  betId: bigint;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.GetPayoutRequest.
 * Use `create(GetPayoutRequestSchema)` to create a new message.
 */
export const GetPayoutRequestSchema: GenMessage<GetPayoutRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 132);

/**
 * @generated from message qb.smg.GetPayoutReply
 */
export type GetPayoutReply = Message<"qb.smg.GetPayoutReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated qb.smg.Payout payouts = 3;
   */
  payouts: Payout[];
};

/**
 * Describes the message qb.smg.GetPayoutReply.
 * Use `create(GetPayoutReplySchema)` to create a new message.
 */
export const GetPayoutReplySchema: GenMessage<GetPayoutReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 133);

/**
 * @generated from message qb.smg.StreamBetsRequest
 */
export type StreamBetsRequest = Message<"qb.smg.StreamBetsRequest"> & {
  /**
   * The token of this session.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * If only a single reply then close.
   *
   * @generated from field: bool close_after_send = 2;
   */
  closeAfterSend: boolean;

  /**
   * The last hash returned. If empty then a balance is returned immediately.
   *
   * @generated from field: string last_seen_hash = 3;
   */
  lastSeenHash: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.StreamBetsRequest.
 * Use `create(StreamBetsRequestSchema)` to create a new message.
 */
export const StreamBetsRequestSchema: GenMessage<StreamBetsRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 134);

/**
 * @generated from message qb.smg.StreamBetsReply
 */
export type StreamBetsReply = Message<"qb.smg.StreamBetsReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * All the bets around this player.
   *
   * @generated from field: repeated qb.smg.Bet bets = 3;
   */
  bets: Bet[];

  /**
   * A hash that describes this state.
   *
   * @generated from field: string hash = 4;
   */
  hash: string;
};

/**
 * Describes the message qb.smg.StreamBetsReply.
 * Use `create(StreamBetsReplySchema)` to create a new message.
 */
export const StreamBetsReplySchema: GenMessage<StreamBetsReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 135);

/**
 * @generated from message qb.smg.GetBetRequest
 */
export type GetBetRequest = Message<"qb.smg.GetBetRequest"> & {
  /**
   * The token of this session.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * The bet of interest.
   *
   * @generated from field: int64 bet_id = 2;
   */
  betId: bigint;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.GetBetRequest.
 * Use `create(GetBetRequestSchema)` to create a new message.
 */
export const GetBetRequestSchema: GenMessage<GetBetRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 136);

/**
 * @generated from message qb.smg.GetBetReply
 */
export type GetBetReply = Message<"qb.smg.GetBetReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * Details of the bet.
   *
   * @generated from field: qb.smg.Bet bet = 3;
   */
  bet?: Bet;
};

/**
 * Describes the message qb.smg.GetBetReply.
 * Use `create(GetBetReplySchema)` to create a new message.
 */
export const GetBetReplySchema: GenMessage<GetBetReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 137);

/**
 * @generated from message qb.smg.GetBetNoTokenRequest
 */
export type GetBetNoTokenRequest = Message<"qb.smg.GetBetNoTokenRequest"> & {
  /**
   * The bet of interest.
   *
   * @generated from field: int64 bet_id = 1;
   */
  betId: bigint;

  /**
   * @generated from field: string token = 2;
   */
  token: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.GetBetNoTokenRequest.
 * Use `create(GetBetNoTokenRequestSchema)` to create a new message.
 */
export const GetBetNoTokenRequestSchema: GenMessage<GetBetNoTokenRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 138);

/**
 * @generated from message qb.smg.GetBetNoTokenReply
 */
export type GetBetNoTokenReply = Message<"qb.smg.GetBetNoTokenReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * Details of the bet.
   *
   * @generated from field: qb.smg.Bet bet = 3;
   */
  bet?: Bet;

  /**
   * @generated from field: bool isTournamentEntryComplete = 4;
   */
  isTournamentEntryComplete: boolean;

  /**
   * @generated from field: int32 playerTournamentScore = 5;
   */
  playerTournamentScore: number;

  /**
   * @generated from field: bool isTournamentBet = 6;
   */
  isTournamentBet: boolean;

  /**
   * @generated from field: int32 totalWonFreePlayAmount = 7;
   */
  totalWonFreePlayAmount: number;

  /**
   * Tournament has ended and player has not played any other shot besides tournament
   *
   * @generated from field: bool onlyPlayedTournamentBets = 8;
   */
  onlyPlayedTournamentBets: boolean;

  /**
   * @generated from field: bool isAdditionalFreePlayAmountAdded = 9;
   */
  isAdditionalFreePlayAmountAdded: boolean;
};

/**
 * Describes the message qb.smg.GetBetNoTokenReply.
 * Use `create(GetBetNoTokenReplySchema)` to create a new message.
 */
export const GetBetNoTokenReplySchema: GenMessage<GetBetNoTokenReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 139);

/**
 * @generated from message qb.smg.AcceptBetRequest
 */
export type AcceptBetRequest = Message<"qb.smg.AcceptBetRequest"> & {
  /**
   * The token of this session.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * The bet of interest.
   *
   * @generated from field: int64 bet_id = 2;
   */
  betId: bigint;

  /**
   * The bet amount specifed by user
   *
   * @generated from field: int64 betAmount = 3;
   */
  betAmount: bigint;

  /**
   * @generated from field: int64 challenge_id = 4;
   */
  challengeId: bigint;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.AcceptBetRequest.
 * Use `create(AcceptBetRequestSchema)` to create a new message.
 */
export const AcceptBetRequestSchema: GenMessage<AcceptBetRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 140);

/**
 * @generated from message qb.smg.AcceptBetReply
 */
export type AcceptBetReply = Message<"qb.smg.AcceptBetReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.AcceptBetReply.
 * Use `create(AcceptBetReplySchema)` to create a new message.
 */
export const AcceptBetReplySchema: GenMessage<AcceptBetReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 141);

/**
 * @generated from message qb.smg.AdjustBetRequest
 */
export type AdjustBetRequest = Message<"qb.smg.AdjustBetRequest"> & {
  /**
   * The token of this session.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * The bet of interest.
   *
   * @generated from field: int64 bet_id = 2;
   */
  betId: bigint;

  /**
   * The bet amount specifed by user
   *
   * @generated from field: int64 betAmount = 3;
   */
  betAmount: bigint;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.AdjustBetRequest.
 * Use `create(AdjustBetRequestSchema)` to create a new message.
 */
export const AdjustBetRequestSchema: GenMessage<AdjustBetRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 142);

/**
 * @generated from message qb.smg.AdjustBetReply
 */
export type AdjustBetReply = Message<"qb.smg.AdjustBetReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: int64 bet_id = 2;
   */
  betId: bigint;

  /**
   * @generated from field: qb.smg.Error error = 3;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.AdjustBetReply.
 * Use `create(AdjustBetReplySchema)` to create a new message.
 */
export const AdjustBetReplySchema: GenMessage<AdjustBetReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 143);

/**
 * @generated from message qb.smg.Hit
 */
export type Hit = Message<"qb.smg.Hit"> & {
  /**
   * @generated from field: string token = 101;
   */
  token: string;

  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: double carry_distance = 2;
   */
  carryDistance: number;

  /**
   * @generated from field: double total_distance = 3;
   */
  totalDistance: number;

  /**
   * @generated from field: double head_speed_mph = 4;
   */
  headSpeedMph: number;

  /**
   * @generated from field: double ball_speed_mph = 5;
   */
  ballSpeedMph: number;

  /**
   * @generated from field: double path_angle = 6;
   */
  pathAngle: number;

  /**
   * @generated from field: double face_open_closed_angle = 7;
   */
  faceOpenClosedAngle: number;

  /**
   * @generated from field: double smash_factor = 8;
   */
  smashFactor: number;

  /**
   * @generated from field: double launch_angle = 9;
   */
  launchAngle: number;

  /**
   * @generated from field: double back_spin = 10;
   */
  backSpin: number;

  /**
   * @generated from field: double side_spin = 11;
   */
  sideSpin: number;

  /**
   * @generated from field: double distance_to_target = 12;
   */
  distanceToTarget: number;

  /**
   * @generated from field: double apex = 13;
   */
  apex: number;

  /**
   * @generated from field: int64 unix_time_stamp = 14;
   */
  unixTimeStamp: bigint;

  /**
   * @generated from field: int64 station_id = 15;
   */
  stationId: bigint;
};

/**
 * Describes the message qb.smg.Hit.
 * Use `create(HitSchema)` to create a new message.
 */
export const HitSchema: GenMessage<Hit> = /*@__PURE__*/
  messageDesc(file_smg_service, 144);

/**
 * @generated from message qb.smg.StartHitRequest
 */
export type StartHitRequest = Message<"qb.smg.StartHitRequest"> & {
  /**
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;

  /**
   * @generated from field: int64 accepted_bet_id = 2;
   */
  acceptedBetId: bigint;

  /**
   * @generated from field: string token = 3;
   */
  token: string;

  /**
   * @generated from field: string hmac_signature = 4;
   */
  hmacSignature: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.StartHitRequest.
 * Use `create(StartHitRequestSchema)` to create a new message.
 */
export const StartHitRequestSchema: GenMessage<StartHitRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 145);

/**
 * @generated from message qb.smg.StartHitReply
 */
export type StartHitReply = Message<"qb.smg.StartHitReply"> & {
  /**
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * @generated from field: int64 hit_id = 3;
   */
  hitId: bigint;
};

/**
 * Describes the message qb.smg.StartHitReply.
 * Use `create(StartHitReplySchema)` to create a new message.
 */
export const StartHitReplySchema: GenMessage<StartHitReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 146);

/**
 * @generated from message qb.smg.HitRequest
 */
export type HitRequest = Message<"qb.smg.HitRequest"> & {
  /**
   * @generated from field: int64 hit_id = 2;
   */
  hitId: bigint;

  /**
   * @generated from field: qb.smg.Hit hit = 3;
   */
  hit?: Hit;

  /**
   * @generated from field: bool hole_in_one = 16;
   */
  holeInOne: boolean;

  /**
   * @generated from field: string token = 4;
   */
  token: string;

  /**
   * @generated from field: string hmac_signature = 17;
   */
  hmacSignature: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.HitRequest.
 * Use `create(HitRequestSchema)` to create a new message.
 */
export const HitRequestSchema: GenMessage<HitRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 147);

/**
 * @generated from message qb.smg.HitReply
 */
export type HitReply = Message<"qb.smg.HitReply"> & {
  /**
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.HitReply.
 * Use `create(HitReplySchema)` to create a new message.
 */
export const HitReplySchema: GenMessage<HitReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 148);

/**
 * @generated from message qb.smg.HitStreamReply
 */
export type HitStreamReply = Message<"qb.smg.HitStreamReply"> & {
  /**
   * @generated from field: int64 something = 1;
   */
  something: bigint;
};

/**
 * Describes the message qb.smg.HitStreamReply.
 * Use `create(HitStreamReplySchema)` to create a new message.
 */
export const HitStreamReplySchema: GenMessage<HitStreamReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 149);

/**
 * @generated from message qb.smg.AddFaceRequest
 */
export type AddFaceRequest = Message<"qb.smg.AddFaceRequest"> & {
  /**
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;

  /**
   * @generated from field: int64 face_id = 2;
   */
  faceId: bigint;

  /**
   * @generated from field: bool is_recognized = 3;
   */
  isRecognized: boolean;

  /**
   * @generated from field: bool is_detected = 4;
   */
  isDetected: boolean;
};

/**
 * Describes the message qb.smg.AddFaceRequest.
 * Use `create(AddFaceRequestSchema)` to create a new message.
 */
export const AddFaceRequestSchema: GenMessage<AddFaceRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 150);

/**
 * @generated from message qb.smg.AddFaceReply
 */
export type AddFaceReply = Message<"qb.smg.AddFaceReply"> & {
  /**
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.AddFaceReply.
 * Use `create(AddFaceReplySchema)` to create a new message.
 */
export const AddFaceReplySchema: GenMessage<AddFaceReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 151);

/**
 * @generated from message qb.smg.GetGameStateRequest
 */
export type GetGameStateRequest = Message<"qb.smg.GetGameStateRequest"> & {
  /**
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;

  /**
   * @generated from field: string token = 2;
   */
  token: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.GetGameStateRequest.
 * Use `create(GetGameStateRequestSchema)` to create a new message.
 */
export const GetGameStateRequestSchema: GenMessage<GetGameStateRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 152);

/**
 * @generated from message qb.smg.HoleInOneConfig
 */
export type HoleInOneConfig = Message<"qb.smg.HoleInOneConfig"> & {
  /**
   * @generated from field: int32 bonusAmount = 1;
   */
  bonusAmount: number;
};

/**
 * Describes the message qb.smg.HoleInOneConfig.
 * Use `create(HoleInOneConfigSchema)` to create a new message.
 */
export const HoleInOneConfigSchema: GenMessage<HoleInOneConfig> = /*@__PURE__*/
  messageDesc(file_smg_service, 153);

/**
 * @generated from message qb.smg.GetGameStateReply
 */
export type GetGameStateReply = Message<"qb.smg.GetGameStateReply"> & {
  /**
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * player is detected for FRS and SMG systems
   *
   * @generated from field: bool user_detected = 3;
   */
  userDetected: boolean;

  /**
   * a person is detected, and it is not a player (not recognized)
   *
   * @generated from field: bool face_detected = 10;
   */
  faceDetected: boolean;

  /**
   * @generated from field: bool multi_face_detected = 12;
   */
  multiFaceDetected: boolean;

  /**
   * <- new added bool variable
   *
   * @generated from field: bool user_in_wrong_camera_side = 13;
   */
  userInWrongCameraSide: boolean;

  /**
   * @generated from field: int64 user_id = 4;
   */
  userId: bigint;

  /**
   * The balance of the user's wallet.
   *
   * @generated from field: int64 user_balance = 11;
   */
  userBalance: bigint;

  /**
   * @generated from field: string username = 5;
   */
  username: string;

  /**
   * @generated from field: qb.smg.Bet active_bet = 6;
   */
  activeBet?: Bet;

  /**
   * @generated from field: qb.smg.Bet closed_bet = 7;
   */
  closedBet?: Bet;

  /**
   * @generated from field: repeated qb.smg.Bet available_bets = 8;
   */
  availableBets: Bet[];

  /**
   * @generated from field: string PlayerHandedness = 14;
   */
  PlayerHandedness: string;

  /**
   * @generated from field: bool show_multi_player_error = 15;
   */
  showMultiPlayerError: boolean;

  /**
   * @generated from field: bool show_player_not_in_game_play_area_error = 16;
   */
  showPlayerNotInGamePlayAreaError: boolean;

  /**
   * @generated from field: int32 shot_sequence = 17;
   */
  shotSequence: number;

  /**
   * @generated from field: bool auto_accept_bets = 18;
   */
  autoAcceptBets: boolean;

  /**
   * User has joined a tournament which is not finished yet
   *
   * @generated from field: bool hasActiveTournament = 19;
   */
  hasActiveTournament: boolean;

  /**
   * @generated from field: int32 maxShotAmount = 25;
   */
  maxShotAmount: number;

  /**
   * @generated from field: bool show_wallet = 26;
   */
  showWallet: boolean;

  /**
   * If contest fee is less than minimum threshold, then this will be 0
   *
   * @generated from field: int32 hole_in_one_bonus_amount = 27;
   */
  holeInOneBonusAmount: number;

  /**
   * User current bet is tournament bet
   *
   * @generated from field: bool isTournamentBetActivated = 28;
   */
  isTournamentBetActivated: boolean;

  /**
   * @generated from field: int32 playedTournamentShotCount = 29;
   */
  playedTournamentShotCount: number;

  /**
   * @generated from field: int32 totalTournamentShotCount = 30;
   */
  totalTournamentShotCount: number;

  /**
   * @generated from field: bool isFreeShot = 31;
   */
  isFreeShot: boolean;

  /**
   * @generated from field: int32 freeShotCount = 32;
   */
  freeShotCount: number;

  /**
   * @generated from field: int32 freeShotNumber = 33;
   */
  freeShotNumber: number;

  /**
   * @generated from field: int32 totalWonFreePlayAmount = 34;
   */
  totalWonFreePlayAmount: number;

  /**
   * @generated from field: int32 totalTournamentScore = 35;
   */
  totalTournamentScore: number;

  /**
   * Tournament is public or private
   *
   * @generated from field: bool isTournamentPublic = 36;
   */
  isTournamentPublic: boolean;

  /**
   * @generated from field: string tournamentSponsorshipLogo = 37;
   */
  tournamentSponsorshipLogo: string;

  /**
   * Current tournament means tournament for current bet
   *
   * @generated from field: int32 currentTournamentId = 38;
   */
  currentTournamentId: number;

  /**
   * @generated from field: string currentTournamentName = 40;
   */
  currentTournamentName: string;

  /**
   * @generated from field: string frsTrackId = 39;
   */
  frsTrackId: string;

  /**
   * @generated from field: int64 skill_index = 41;
   */
  skillIndex: bigint;

  /**
   * @generated from field: string status_tier = 42;
   */
  statusTier: string;

  /**
   * @generated from field: int32 skill_index_shot_sequence = 43;
   */
  skillIndexShotSequence: number;

  /**
   * @generated from field: bool show_skill_index_message = 44;
   */
  showSkillIndexMessage: boolean;

  /**
   * Partner User identifier
   *
   * @generated from field: qb.smg.PartnerUserIdentifier partner_user_identifier = 45;
   */
  partnerUserIdentifier?: PartnerUserIdentifier;

  /**
   * @generated from field: int32 remainingFreeShotsToUnlockTournament = 46;
   */
  remainingFreeShotsToUnlockTournament: number;

  /**
   * @generated from field: qb.smg.AutoPlayBalanceStatus auto_play_balance_status = 47;
   */
  autoPlayBalanceStatus: AutoPlayBalanceStatus;

  /**
   * Mirrors RoundRobinStatus.confirm_before_each_turn for the rotation's
   * CURRENT player (the one whose turn it is). NOTE: this is independent
   * of user_id on this reply — during the post-rotation, pre-confirm
   * window the station's active user trails the rotation pointer by up
   * to 60s, and the simulator polls GetGameState specifically to learn
   * "the next-up player has CBT enabled, pause for their confirm".
   * Reporting the current-rotation-player's CBT (rather than gating on
   * active_user_id == current_player_id) is what the simulator team
   * needs.
   *
   * Lets simulator clients drive the per-turn confirmation modal off the
   * polled GetGameState response without race-joining the partner-service
   * FullSwingSessionParticipationDetailsStream. False (proto3 default)
   * in the no-active-user, user-not-found, round-robin-disabled, and
   * empty-rotation paths. See SMG-2728 (introduced) and SMG-2734
   * (semantic clarified — dropped the active-user gate).
   *
   * @generated from field: bool active_player_confirm_before_each_turn = 48;
   */
  activePlayerConfirmBeforeEachTurn: boolean;

  /**
   * True only during the rotation-confirm window — the rotation pointer
   * has advanced to a player whose CBT is on, but partner-service has
   * not yet called SetActiveUser for them (still waiting on the Start
   * Playing tap or the 60s timeout). Mirrors
   * RoundRobinStatus.awaiting_confirmation for the rotation's current
   * player. Pairs with active_player_confirm_before_each_turn to
   * disambiguate the simulator's two CBT-on states without joining the
   * partner-service FullSwingSessionParticipationDetailsStream:
   *
   *   CBT=true,  awaiting=true  → modal up, hold StartHit
   *   CBT=true,  awaiting=false → confirmed (or never required), accept StartHit
   *   CBT=false, awaiting=*     → no modal involvement
   *
   * False (proto3 default) when round-robin is disabled, the rotation has
   * no current player, or SSC has cleared awaiting_confirmation (i.e. the
   * rotation's current player has confirmed via MarkRotationConfirmed, has
   * confirmation bypass on, or the 60s timeout has fired). See SMG-2750.
   *
   * @generated from field: bool awaiting_player_confirmation = 49;
   */
  awaitingPlayerConfirmation: boolean;

  /**
   * True when the active player's in-flight bet requires per-shot
   * confirmation (their ConfirmationSettings.on_shot is on AND the
   * station has an active bet). Mirrors active_player_confirm_before_each_turn
   * for the per-shot gate. False (proto3 default) when there is no active
   * player, no active bet, the active player's on_shot is off/unset, or
   * bay-session is unreachable.
   *
   * @generated from field: bool active_player_shot_confirmation_required = 50;
   */
  activePlayerShotConfirmationRequired: boolean;

  /**
   * True only while the per-shot handshake is still pending — the active
   * player's bet requires per-shot confirmation AND the shot has not yet
   * been armed (shot_armed_bet_id != active_bet_id). Pairs with
   * active_player_shot_confirmation_required so the simulator can
   * disambiguate the two required states from a single response:
   *
   *   required=true,  awaiting=true  → shot needs arming — hold StartHit/ProcessShot
   *   required=true,  awaiting=false → armed — accept the shot
   *   required=false, awaiting=*     → no per-shot modal (autoplay)
   *
   * False (proto3 default) when per-shot confirmation is not required, the
   * shot is already armed for the active bet, or bay-session is
   * unreachable. See SMG-3355 and docs/bay-session/confirmation-and-arming.md §8.1.
   *
   * @generated from field: bool awaiting_shot_confirmation = 51;
   */
  awaitingShotConfirmation: boolean;
};

/**
 * Describes the message qb.smg.GetGameStateReply.
 * Use `create(GetGameStateReplySchema)` to create a new message.
 */
export const GetGameStateReplySchema: GenMessage<GetGameStateReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 154);

/**
 * @generated from message qb.smg.StreamStationStateRequest
 */
export type StreamStationStateRequest = Message<"qb.smg.StreamStationStateRequest"> & {
  /**
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;

  /**
   * @generated from field: string token = 2;
   */
  token: string;

  /**
   * @generated from field: bool use_new_service = 3;
   */
  useNewService: boolean;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.StreamStationStateRequest.
 * Use `create(StreamStationStateRequestSchema)` to create a new message.
 */
export const StreamStationStateRequestSchema: GenMessage<StreamStationStateRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 155);

/**
 * @generated from message qb.smg.FrsHeartbeatRequest
 */
export type FrsHeartbeatRequest = Message<"qb.smg.FrsHeartbeatRequest"> & {
};

/**
 * Describes the message qb.smg.FrsHeartbeatRequest.
 * Use `create(FrsHeartbeatRequestSchema)` to create a new message.
 */
export const FrsHeartbeatRequestSchema: GenMessage<FrsHeartbeatRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 156);

/**
 * @generated from message qb.smg.StationState
 */
export type StationState = Message<"qb.smg.StationState"> & {
  /**
   * @generated from field: int64 activeUserId = 1;
   */
  activeUserId: bigint;

  /**
   * @generated from field: uint64 activeBetId = 2;
   */
  activeBetId: bigint;

  /**
   * player is detected for FRS and SMG systems
   *
   * @generated from field: bool user_detected = 3;
   */
  userDetected: boolean;

  /**
   * a person is detected, and it is not a player (not recognized)
   *
   * @generated from field: bool face_detected = 4;
   */
  faceDetected: boolean;

  /**
   * @generated from field: bool multi_face_detected = 6;
   */
  multiFaceDetected: boolean;

  /**
   * @generated from field: qb.smg.StationPlayerState currentState = 5;
   */
  currentState: StationPlayerState;

  /**
   * @generated from field: bool user_in_wrong_camera_side = 7;
   */
  userInWrongCameraSide: boolean;

  /**
   * @generated from field: bool show_multiplayer_error = 8;
   */
  showMultiplayerError: boolean;

  /**
   * @generated from field: bool show_player_not_in_game_play_area_error = 9;
   */
  showPlayerNotInGamePlayAreaError: boolean;

  /**
   * @generated from field: bool hole_in_one_detected = 10;
   */
  holeInOneDetected: boolean;

  /**
   * @generated from field: int64 betAmount = 11;
   */
  betAmount: bigint;

  /**
   * @generated from field: string frsTrackId = 12;
   */
  frsTrackId: string;

  /**
   * DEPRECATED: read round-robin state from FullSwingSessionParticipationDetailsStream.RoundRobinState;
   * this field is a vestigial mirror pending removal (see SMG-2463 follow-up).
   *
   * @generated from field: qb.smg.RoundRobinStatus round_robin = 15;
   */
  roundRobin?: RoundRobinStatus;

  /**
   * True when the station is holding an active user without deferring to the
   * facial-recognition subsystem. Surfaced so callers (e.g. partner-service's
   * round-robin orchestration) can enforce the RR ⊕ FRS mutual-exclusion
   * invariant. See SMG-2463.
   *
   * @generated from field: bool ignore_frs_mode_enabled = 16;
   */
  ignoreFrsModeEnabled: boolean;
};

/**
 * Describes the message qb.smg.StationState.
 * Use `create(StationStateSchema)` to create a new message.
 */
export const StationStateSchema: GenMessage<StationState> = /*@__PURE__*/
  messageDesc(file_smg_service, 157);

/**
 * @generated from message qb.smg.RoundRobinStatus
 */
export type RoundRobinStatus = Message<"qb.smg.RoundRobinStatus"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: int32 shots_per_player = 2;
   */
  shotsPerPlayer: number;

  /**
   * @generated from field: int64 current_player_id = 3;
   */
  currentPlayerId: bigint;

  /**
   * @generated from field: int32 shots_taken_this_turn = 4;
   */
  shotsTakenThisTurn: number;

  /**
   * @generated from field: int32 shots_remaining = 5;
   */
  shotsRemaining: number;

  /**
   * @generated from field: repeated int64 player_order = 6;
   */
  playerOrder: bigint[];

  /**
   * turn_complete is a transient event flag and is structurally always false
   * on snapshot reads from GetRoundRobinStatus. Reason: every cursor-advance
   * path (RecordShot, Enable's cap-reduction branch when a shots-per-turn
   * reduction forces the current player past the new effective cap)
   * atomically advances currentIndex and resets shotsTaken=0 under the
   * per-station mutex, so by the time any subsequent snapshot observes the
   * state the rotation has already moved past the "just crossed the
   * threshold" instant — there is no persisted bit that says "the previous
   * shot completed a turn".
   *
   * Consumers wanting a reliable turn-complete signal must read
   * RecordRoundRobinShotResponse.turn_complete, which is derived from
   * RecordShot's immediate return value (the in-flow RPC response path)
   * rather than from a subsequent snapshot read. On that RPC response,
   * turn_complete is always meaningful; next_player_id is meaningful only
   * when turn_complete=true (mid-turn shots that don't cross the threshold
   * return turn_complete=false AND next_player_id=0). A consumer reading
   * resp.NextPlayerId without first checking resp.TurnComplete will
   * silently see 0 mid-turn — see round_robin_shot_consumer.go for the
   * correct `resp.TurnComplete && resp.NextPlayerId > 0` gate pattern.
   *
   * Asymmetric with next_player_id (field 8), which IS a stable property
   * of the rotation cursor and is meaningful on every snapshot (for
   * rotations with ≥ 2 players; see field 8's contract for the 1-player
   * and disabled/empty branches). See SMG-2773 for the analysis.
   *
   * @generated from field: bool turn_complete = 7;
   */
  turnComplete: boolean;

  /**
   * @generated from field: int64 next_player_id = 8;
   */
  nextPlayerId: bigint;

  /**
   * @generated from field: bool awaiting_confirmation = 9;
   */
  awaitingConfirmation: boolean;

  /**
   * @generated from field: int32 timeout_seconds = 10;
   */
  timeoutSeconds: number;

  /**
   * @generated from field: bool turn_timed_out = 11;
   */
  turnTimedOut: boolean;

  /**
   * Per-current-turn "Confirm Before Each Turn" flag for the player at
   * current_player_id. Required-positive: true means "show the per-turn
   * confirmation modal"; false means "auto-activate without modal".
   * Mirrors FullSwingSessionParticipant.confirm_before_each_turn
   * (partner_service.proto field 16) and the
   * fs_station_session_participant.round_robin_confirmation_required DB
   * column. Zero (false) when round-robin is disabled or the rotation has
   * no current player. See SMG-2728.
   *
   * @generated from field: bool confirm_before_each_turn = 12;
   */
  confirmBeforeEachTurn: boolean;

  /**
   * player_targets carries the known target distance for EVERY player in the
   * rotation (one entry per player_order user_id), not just the current/next
   * player, so the group UI can preview upcoming targets for the whole
   * rotation. Populated from each player's most-recent ACCEPTED bet at
   * challenge-accept time (not only at bet resolution) — station-state-computer
   * consumes the existing user-updates RabbitMQ event (fired by the engine on
   * AcceptBetInternal) and refreshes the per-player target map, then
   * re-broadcasts StationState immediately. A player with no known target yet
   * is emitted with has_active_challenge=false / target_distance=0. See
   * SMG-2252.
   *
   * @generated from field: repeated qb.smg.PlayerTargetInfo player_targets = 13;
   */
  playerTargets: PlayerTargetInfo[];
};

/**
 * Describes the message qb.smg.RoundRobinStatus.
 * Use `create(RoundRobinStatusSchema)` to create a new message.
 */
export const RoundRobinStatusSchema: GenMessage<RoundRobinStatus> = /*@__PURE__*/
  messageDesc(file_smg_service, 158);

/**
 * PlayerTargetInfo is the per-player target-distance projection carried on
 * RoundRobinStatus.player_targets. target_distance is the configured
 * distance-from-pin (yards) of the player's most-recent ACCEPTED bet;
 * has_active_challenge is false (and target_distance 0) when the player has
 * no accepted challenge currently known to station-state-computer. See
 * SMG-2252.
 *
 * @generated from message qb.smg.PlayerTargetInfo
 */
export type PlayerTargetInfo = Message<"qb.smg.PlayerTargetInfo"> & {
  /**
   * @generated from field: uint64 user_id = 1;
   */
  userId: bigint;

  /**
   * @generated from field: double target_distance = 2;
   */
  targetDistance: number;

  /**
   * @generated from field: bool has_active_challenge = 3;
   */
  hasActiveChallenge: boolean;
};

/**
 * Describes the message qb.smg.PlayerTargetInfo.
 * Use `create(PlayerTargetInfoSchema)` to create a new message.
 */
export const PlayerTargetInfoSchema: GenMessage<PlayerTargetInfo> = /*@__PURE__*/
  messageDesc(file_smg_service, 159);

/**
 * @generated from message qb.smg.HeartbeatRequest
 */
export type HeartbeatRequest = Message<"qb.smg.HeartbeatRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.HeartbeatRequest.
 * Use `create(HeartbeatRequestSchema)` to create a new message.
 */
export const HeartbeatRequestSchema: GenMessage<HeartbeatRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 160);

/**
 * @generated from message qb.smg.HeartbeatResponse
 */
export type HeartbeatResponse = Message<"qb.smg.HeartbeatResponse"> & {
};

/**
 * Describes the message qb.smg.HeartbeatResponse.
 * Use `create(HeartbeatResponseSchema)` to create a new message.
 */
export const HeartbeatResponseSchema: GenMessage<HeartbeatResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 161);

/**
 * @generated from message qb.smg.ConnectStationSimpleRequest
 */
export type ConnectStationSimpleRequest = Message<"qb.smg.ConnectStationSimpleRequest"> & {
  /**
   * @generated from field: int32 station_id = 1;
   */
  stationId: number;

  /**
   * @generated from field: string token = 2;
   */
  token: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.ConnectStationSimpleRequest.
 * Use `create(ConnectStationSimpleRequestSchema)` to create a new message.
 */
export const ConnectStationSimpleRequestSchema: GenMessage<ConnectStationSimpleRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 162);

/**
 * @generated from message qb.smg.ConnectStationSimpleReply
 */
export type ConnectStationSimpleReply = Message<"qb.smg.ConnectStationSimpleReply"> & {
  /**
   * @generated from field: bool connected = 1;
   */
  connected: boolean;
};

/**
 * Describes the message qb.smg.ConnectStationSimpleReply.
 * Use `create(ConnectStationSimpleReplySchema)` to create a new message.
 */
export const ConnectStationSimpleReplySchema: GenMessage<ConnectStationSimpleReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 163);

/**
 * @generated from message qb.smg.StationMessage
 */
export type StationMessage = Message<"qb.smg.StationMessage"> & {
  /**
   * @generated from field: int64 message_id = 1;
   */
  messageId: bigint;

  /**
   * @generated from field: qb.smg.SettingsUpdate settings_update = 2;
   */
  settingsUpdate?: SettingsUpdate;

  /**
   * @generated from field: qb.smg.DisplayMessage display_message = 3;
   */
  displayMessage?: DisplayMessage;
};

/**
 * Describes the message qb.smg.StationMessage.
 * Use `create(StationMessageSchema)` to create a new message.
 */
export const StationMessageSchema: GenMessage<StationMessage> = /*@__PURE__*/
  messageDesc(file_smg_service, 164);

/**
 * @generated from message qb.smg.DisplayMessage
 */
export type DisplayMessage = Message<"qb.smg.DisplayMessage"> & {
  /**
   * @generated from field: string line1 = 1;
   */
  line1: string;

  /**
   * @generated from field: string line2 = 2;
   */
  line2: string;

  /**
   * @generated from field: string line3 = 3;
   */
  line3: string;

  /**
   * @generated from field: int64 display_time = 4;
   */
  displayTime: bigint;
};

/**
 * Describes the message qb.smg.DisplayMessage.
 * Use `create(DisplayMessageSchema)` to create a new message.
 */
export const DisplayMessageSchema: GenMessage<DisplayMessage> = /*@__PURE__*/
  messageDesc(file_smg_service, 165);

/**
 * @generated from message qb.smg.SettingsUpdateStreamRequest
 */
export type SettingsUpdateStreamRequest = Message<"qb.smg.SettingsUpdateStreamRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.SettingsUpdateStreamRequest.
 * Use `create(SettingsUpdateStreamRequestSchema)` to create a new message.
 */
export const SettingsUpdateStreamRequestSchema: GenMessage<SettingsUpdateStreamRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 166);

/**
 * @generated from message qb.smg.SettingsUpdate
 */
export type SettingsUpdate = Message<"qb.smg.SettingsUpdate"> & {
  /**
   * @generated from field: int64 LastChangeTimestamp = 1;
   */
  LastChangeTimestamp: bigint;

  /**
   * @generated from field: string Handedness = 2;
   */
  Handedness: string;

  /**
   * @generated from field: int64 Distance = 3;
   */
  Distance: bigint;

  /**
   * @generated from field: string TargetType = 4;
   */
  TargetType: string;
};

/**
 * Describes the message qb.smg.SettingsUpdate.
 * Use `create(SettingsUpdateSchema)` to create a new message.
 */
export const SettingsUpdateSchema: GenMessage<SettingsUpdate> = /*@__PURE__*/
  messageDesc(file_smg_service, 167);

/**
 * @generated from message qb.smg.DeleteUserImageRequest
 */
export type DeleteUserImageRequest = Message<"qb.smg.DeleteUserImageRequest"> & {
  /**
   * @generated from field: int64 user_id = 1;
   */
  userId: bigint;

  /**
   * @generated from field: int32 venue_id = 2;
   */
  venueId: number;

  /**
   * @generated from field: string token = 3;
   */
  token: string;
};

/**
 * Describes the message qb.smg.DeleteUserImageRequest.
 * Use `create(DeleteUserImageRequestSchema)` to create a new message.
 */
export const DeleteUserImageRequestSchema: GenMessage<DeleteUserImageRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 168);

/**
 * @generated from message qb.smg.DeleteUserImageResponse
 */
export type DeleteUserImageResponse = Message<"qb.smg.DeleteUserImageResponse"> & {
  /**
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.DeleteUserImageResponse.
 * Use `create(DeleteUserImageResponseSchema)` to create a new message.
 */
export const DeleteUserImageResponseSchema: GenMessage<DeleteUserImageResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 169);

/**
 * @generated from message qb.smg.DeleteUserImagesBeforeDateRequest
 */
export type DeleteUserImagesBeforeDateRequest = Message<"qb.smg.DeleteUserImagesBeforeDateRequest"> & {
  /**
   * @generated from field: google.protobuf.Timestamp Date = 1;
   */
  Date?: Timestamp;

  /**
   * @generated from field: int32 venue_id = 2;
   */
  venueId: number;

  /**
   * @generated from field: string token = 3;
   */
  token: string;
};

/**
 * Describes the message qb.smg.DeleteUserImagesBeforeDateRequest.
 * Use `create(DeleteUserImagesBeforeDateRequestSchema)` to create a new message.
 */
export const DeleteUserImagesBeforeDateRequestSchema: GenMessage<DeleteUserImagesBeforeDateRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 170);

/**
 * @generated from message qb.smg.DeleteUserImagesBeforeDateResponse
 */
export type DeleteUserImagesBeforeDateResponse = Message<"qb.smg.DeleteUserImagesBeforeDateResponse"> & {
  /**
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.DeleteUserImagesBeforeDateResponse.
 * Use `create(DeleteUserImagesBeforeDateResponseSchema)` to create a new message.
 */
export const DeleteUserImagesBeforeDateResponseSchema: GenMessage<DeleteUserImagesBeforeDateResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 171);

/**
 * @generated from message qb.smg.DeleteLastActiveBeforeDateRequest
 */
export type DeleteLastActiveBeforeDateRequest = Message<"qb.smg.DeleteLastActiveBeforeDateRequest"> & {
  /**
   * @generated from field: google.protobuf.Timestamp date = 1;
   */
  date?: Timestamp;
};

/**
 * Describes the message qb.smg.DeleteLastActiveBeforeDateRequest.
 * Use `create(DeleteLastActiveBeforeDateRequestSchema)` to create a new message.
 */
export const DeleteLastActiveBeforeDateRequestSchema: GenMessage<DeleteLastActiveBeforeDateRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 172);

/**
 * @generated from message qb.smg.DeleteLastActiveBeforeDateResponse
 */
export type DeleteLastActiveBeforeDateResponse = Message<"qb.smg.DeleteLastActiveBeforeDateResponse"> & {
  /**
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.DeleteLastActiveBeforeDateResponse.
 * Use `create(DeleteLastActiveBeforeDateResponseSchema)` to create a new message.
 */
export const DeleteLastActiveBeforeDateResponseSchema: GenMessage<DeleteLastActiveBeforeDateResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 173);

/**
 * @generated from message qb.smg.IgnoreFrsRequest
 */
export type IgnoreFrsRequest = Message<"qb.smg.IgnoreFrsRequest"> & {
  /**
   * @generated from field: bool enable = 1;
   */
  enable: boolean;

  /**
   * @generated from field: int64 forced_user_id = 2;
   */
  forcedUserId: bigint;

  /**
   * @generated from field: string token = 3;
   */
  token: string;

  /**
   * @generated from field: int32 station_id = 4;
   */
  stationId: number;
};

/**
 * Describes the message qb.smg.IgnoreFrsRequest.
 * Use `create(IgnoreFrsRequestSchema)` to create a new message.
 */
export const IgnoreFrsRequestSchema: GenMessage<IgnoreFrsRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 174);

/**
 * @generated from message qb.smg.IgnoreFrsResponse
 */
export type IgnoreFrsResponse = Message<"qb.smg.IgnoreFrsResponse"> & {
  /**
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * @generated from field: repeated qb.smg.User availableUsers = 3;
   */
  availableUsers: User[];
};

/**
 * Describes the message qb.smg.IgnoreFrsResponse.
 * Use `create(IgnoreFrsResponseSchema)` to create a new message.
 */
export const IgnoreFrsResponseSchema: GenMessage<IgnoreFrsResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 175);

/**
 * @generated from message qb.smg.ResetShotCountRequest
 */
export type ResetShotCountRequest = Message<"qb.smg.ResetShotCountRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 user_id = 2;
   */
  userId: bigint;
};

/**
 * Describes the message qb.smg.ResetShotCountRequest.
 * Use `create(ResetShotCountRequestSchema)` to create a new message.
 */
export const ResetShotCountRequestSchema: GenMessage<ResetShotCountRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 176);

/**
 * @generated from message qb.smg.ResetShotCountResponse
 */
export type ResetShotCountResponse = Message<"qb.smg.ResetShotCountResponse"> & {
  /**
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.ResetShotCountResponse.
 * Use `create(ResetShotCountResponseSchema)` to create a new message.
 */
export const ResetShotCountResponseSchema: GenMessage<ResetShotCountResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 177);

/**
 * @generated from message qb.smg.GetTransactionHistoryRequest
 */
export type GetTransactionHistoryRequest = Message<"qb.smg.GetTransactionHistoryRequest"> & {
  /**
   * Deprecated (SMG-3881): the server derives the user from `token` and
   * ignores this field. Kept only for wire compatibility with old clients;
   * a mismatch with the session user is logged and the session user wins.
   *
   * @generated from field: uint64 user_id = 1;
   */
  userId: bigint;

  /**
   * The token of this session. Server derives the user from this; user_id is ignored.
   *
   * @generated from field: string token = 2;
   */
  token: string;
};

/**
 * Describes the message qb.smg.GetTransactionHistoryRequest.
 * Use `create(GetTransactionHistoryRequestSchema)` to create a new message.
 */
export const GetTransactionHistoryRequestSchema: GenMessage<GetTransactionHistoryRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 178);

/**
 * @generated from message qb.smg.GetTransactionHistoryReply
 */
export type GetTransactionHistoryReply = Message<"qb.smg.GetTransactionHistoryReply"> & {
  /**
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * @generated from field: repeated qb.smg.TransactionHistory history = 3;
   */
  history: TransactionHistory[];
};

/**
 * Describes the message qb.smg.GetTransactionHistoryReply.
 * Use `create(GetTransactionHistoryReplySchema)` to create a new message.
 */
export const GetTransactionHistoryReplySchema: GenMessage<GetTransactionHistoryReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 179);

/**
 * @generated from message qb.smg.EnableAutoPlayRequest
 */
export type EnableAutoPlayRequest = Message<"qb.smg.EnableAutoPlayRequest"> & {
  /**
   * The token of this session.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * true to enable, false to disable
   *
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * amount of bet (contest fee), if -1 provided, then it will use the last amount, -f -2 provided, it will use max available amount for user.
   *
   * @generated from field: int32 betAmount = 3;
   */
  betAmount: number;

  /**
   * @generated from field: qb.smg.Location location = 101;
   */
  location?: Location;

  /**
   * @generated from field: int32 venue_id = 102;
   */
  venueId: number;
};

/**
 * Describes the message qb.smg.EnableAutoPlayRequest.
 * Use `create(EnableAutoPlayRequestSchema)` to create a new message.
 */
export const EnableAutoPlayRequestSchema: GenMessage<EnableAutoPlayRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 180);

/**
 * @generated from message qb.smg.EnableAutoPlayResponse
 */
export type EnableAutoPlayResponse = Message<"qb.smg.EnableAutoPlayResponse"> & {
  /**
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.EnableAutoPlayResponse.
 * Use `create(EnableAutoPlayResponseSchema)` to create a new message.
 */
export const EnableAutoPlayResponseSchema: GenMessage<EnableAutoPlayResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 181);

/**
 * Writes the stored preference only. Bets of an active tournament keep their
 * pinned amount; in-tournament players stay on EnableAutoPlay until the
 * tournament guard lands.
 *
 * @generated from message qb.smg.SetShotAmountPreferenceRequest
 */
export type SetShotAmountPreferenceRequest = Message<"qb.smg.SetShotAmountPreferenceRequest"> & {
  /**
   * The token of this session.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * -2 = always play max; otherwise positive cents. 0 and -1 are rejected.
   * -2 is recorded as an explicit use-max choice: send it only on a player
   * gesture, never as an echo of the displayed value.
   *
   * @generated from field: int32 amount = 2;
   */
  amount: number;

  /**
   * Case-insensitive; empty means USD. The player's next-wager token, e.g. USD,
   * TGPTS or FSPTS; an unrecognised token is rejected. USD is real money (the
   * exposure cap applies), points tokens are exempt. Selects the limits only;
   * the stored amount is currency-agnostic.
   *
   * @generated from field: string currency = 3;
   */
  currency: string;
};

/**
 * Describes the message qb.smg.SetShotAmountPreferenceRequest.
 * Use `create(SetShotAmountPreferenceRequestSchema)` to create a new message.
 */
export const SetShotAmountPreferenceRequestSchema: GenMessage<SetShotAmountPreferenceRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 182);

/**
 * @generated from message qb.smg.SetShotAmountPreferenceResponse
 */
export type SetShotAmountPreferenceResponse = Message<"qb.smg.SetShotAmountPreferenceResponse"> & {
  /**
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.SetShotAmountPreferenceResponse.
 * Use `create(SetShotAmountPreferenceResponseSchema)` to create a new message.
 */
export const SetShotAmountPreferenceResponseSchema: GenMessage<SetShotAmountPreferenceResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 183);

/**
 * @generated from message qb.smg.Challenge
 */
export type Challenge = Message<"qb.smg.Challenge"> & {
  /**
   * @generated from field: int64 challenge_id = 1;
   */
  challengeId: bigint;

  /**
   * @generated from field: int32 sequence = 2;
   */
  sequence: number;

  /**
   * @generated from field: string challenge_type = 3;
   */
  challengeType: string;

  /**
   * @generated from field: string challenge_sub_type = 4;
   */
  challengeSubType: string;

  /**
   * @generated from field: string challenge_state = 5;
   */
  challengeState: string;

  /**
   * @generated from field: string outcome = 6;
   */
  outcome: string;

  /**
   * @generated from field: int64 user_id = 7;
   */
  userId: bigint;

  /**
   * @generated from field: int64 hit_id = 8;
   */
  hitId: bigint;

  /**
   * @generated from field: int64 value1 = 9;
   */
  value1: bigint;

  /**
   * @generated from field: int64 value2 = 10;
   */
  value2: bigint;

  /**
   * @generated from field: int64 value3 = 11;
   */
  value3: bigint;

  /**
   * @generated from field: int32 total_attempts = 12;
   */
  totalAttempts: number;

  /**
   * @generated from field: int32 attempts_remaining = 13;
   */
  attemptsRemaining: number;

  /**
   * @generated from field: int64 created_on = 14;
   */
  createdOn: bigint;

  /**
   * @generated from field: int64 resolved_on = 15;
   */
  resolvedOn: bigint;

  /**
   * @generated from field: string odds = 16;
   */
  odds: string;

  /**
   * @generated from field: string distance = 17;
   */
  distance: string;

  /**
   * @generated from field: string validTill = 18;
   */
  validTill: string;

  /**
   * @generated from field: string description = 19;
   */
  description: string;

  /**
   * @generated from field: int64 accepted_on = 20;
   */
  acceptedOn: bigint;
};

/**
 * Describes the message qb.smg.Challenge.
 * Use `create(ChallengeSchema)` to create a new message.
 */
export const ChallengeSchema: GenMessage<Challenge> = /*@__PURE__*/
  messageDesc(file_smg_service, 184);

/**
 * *
 * Represents a bet placed by a user in the system.
 *
 * @generated from message qb.smg.Bet
 */
export type Bet = Message<"qb.smg.Bet"> & {
  /**
   * Unique identifier for the bet
   *
   * @generated from field: int64 bet_id = 1;
   */
  betId: bigint;

  /**
   * ID of the user who placed the bet
   *
   * @generated from field: int64 user_id = 2;
   */
  userId: bigint;

  /**
   * Type of bet
   *
   * @generated from field: string bet_type = 3;
   */
  betType: string;

  /**
   * Current state of the bet (e.g., "pending", "accepted", "resolved")
   *
   * @generated from field: string bet_state = 4;
   */
  betState: string;

  /**
   * Amount wagered
   *
   * @generated from field: int64 amount = 5;
   */
  amount: bigint;

  /**
   * Payout multiplier for the bet
   *
   * @generated from field: float multiplier = 6;
   */
  multiplier: number;

  /**
   * Outcome of the bet (e.g., "win", "loss")
   *
   * @generated from field: string outcome = 7;
   */
  outcome: string;

  /**
   * Timestamp when the bet was created
   *
   * @generated from field: int64 created_on = 8;
   */
  createdOn: bigint;

  /**
   * Timestamp when the bet was resolved
   *
   * @generated from field: int64 resolved_on = 9;
   */
  resolvedOn: bigint;

  /**
   * ID of the venue where the bet was placed
   *
   * @generated from field: int32 venue_id = 10;
   */
  venueId: number;

  /**
   * Challenges for the old game system
   *
   * @generated from field: repeated qb.smg.Challenge challenges = 11;
   */
  challenges: Challenge[];

  /**
   * Paylines for the old game system
   *
   * @generated from field: repeated qb.smg.Payline paylines = 13;
   */
  paylines: Payline[];

  /**
   * Timestamp when the bet was accepted
   *
   * @generated from field: int64 accepted_on = 14;
   */
  acceptedOn: bigint;

  /**
   * Whether a hole-in-one was achieved
   *
   * @generated from field: bool hole_in_one = 15;
   */
  holeInOne: boolean;

  /**
   * Bonus amount for a hole-in-one
   *
   * @generated from field: int32 hole_in_one_bonus_amount = 16;
   */
  holeInOneBonusAmount: number;

  /**
   * @generated from field: int64 min_accept_amount = 17;
   */
  minAcceptAmount: bigint;

  /**
   * @generated from field: bool free_bet = 19;
   */
  freeBet: boolean;

  /**
   * @generated from field: string category = 20;
   */
  category: string;

  /**
   * @generated from field: int64 configured_number_of_paylines = 21;
   */
  configuredNumberOfPaylines: bigint;

  /**
   * @generated from field: repeated int32 configured_multipliers = 22;
   */
  configuredMultipliers: number[];

  /**
   * @generated from field: int32 priority = 23;
   */
  priority: number;

  /**
   * @generated from field: int64 configured_distance_from_pin = 18;
   */
  configuredDistanceFromPin: bigint;

  /**
   * optional so a pinned $0 (free-tournament entry fee) has presence (SMG-3607)
   *
   * @generated from field: optional int64 configured_auto_play_amount = 24;
   */
  configuredAutoPlayAmount?: bigint;

  /**
   * Next challenge distance preview set after shot resolution; 0 = unavailable
   *
   * @generated from field: int64 next_shot_target_yards = 25;
   */
  nextShotTargetYards: bigint;
};

/**
 * Describes the message qb.smg.Bet.
 * Use `create(BetSchema)` to create a new message.
 */
export const BetSchema: GenMessage<Bet> = /*@__PURE__*/
  messageDesc(file_smg_service, 185);

/**
 * *
 * Represents a payout for a winning bet.
 *
 * @generated from message qb.smg.Payout
 */
export type Payout = Message<"qb.smg.Payout"> & {
  /**
   * Unique identifier for the payout
   *
   * @generated from field: int64 payout_id = 1;
   */
  payoutId: bigint;

  /**
   * Outcome that triggered the payout
   *
   * @generated from field: string outcome = 2;
   */
  outcome: string;

  /**
   * Odds applied to the payout
   *
   * @generated from field: string odds = 3;
   */
  odds: string;

  /**
   * Amount of the payout
   *
   * @generated from field: int64 amount = 4;
   */
  amount: bigint;

  /**
   * ID of the associated bet
   *
   * @generated from field: int64 betId = 5;
   */
  betId: bigint;
};

/**
 * Describes the message qb.smg.Payout.
 * Use `create(PayoutSchema)` to create a new message.
 */
export const PayoutSchema: GenMessage<Payout> = /*@__PURE__*/
  messageDesc(file_smg_service, 186);

/**
 * *
 * Represents a payline in the old game system.
 *
 * @generated from message qb.smg.Payline
 */
export type Payline = Message<"qb.smg.Payline"> & {
  /**
   * Unique identifier for the payline
   *
   * @generated from field: int64 payline_id = 1;
   */
  paylineId: bigint;

  /**
   * ID of the associated bet
   *
   * @generated from field: int64 bet_id = 2;
   */
  betId: bigint;

  /**
   * ID of the associated challenge
   *
   * @generated from field: int64 challenge_id = 3;
   */
  challengeId: bigint;

  /**
   * Payout multiplier for the payline
   *
   * @generated from field: int64 multiplier = 4;
   */
  multiplier: bigint;

  /**
   * Priority of the payline
   *
   * @generated from field: int64 priority = 5;
   */
  priority: bigint;
};

/**
 * Describes the message qb.smg.Payline.
 * Use `create(PaylineSchema)` to create a new message.
 */
export const PaylineSchema: GenMessage<Payline> = /*@__PURE__*/
  messageDesc(file_smg_service, 187);

/**
 * *
 * Session describes the users current session, importantly the encrypted token that
 * identifies the user for the session.
 *
 * @generated from message qb.smg.Session
 */
export type Session = Message<"qb.smg.Session"> & {
  /**
   * The encrypted hash identifying this user (each session has a new token).
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * The user of this session (consistent across sessions).
   *
   * @generated from field: int64 user_id = 2;
   */
  userId: bigint;

  /**
   * The Unix timestamp this session started.
   *
   * @generated from field: int64 session_start = 3;
   */
  sessionStart: bigint;

  /**
   * The Unix timestamp this session ended.
   *
   * @generated from field: int64 session_end = 4;
   */
  sessionEnd: bigint;

  /**
   * A string that may be used by the client for A/B testing.
   *
   * @generated from field: string analytics_id = 5;
   */
  analyticsId: string;
};

/**
 * Describes the message qb.smg.Session.
 * Use `create(SessionSchema)` to create a new message.
 */
export const SessionSchema: GenMessage<Session> = /*@__PURE__*/
  messageDesc(file_smg_service, 188);

/**
 * @generated from message qb.smg.PartnerUserIdentifier
 */
export type PartnerUserIdentifier = Message<"qb.smg.PartnerUserIdentifier"> & {
  /**
   * Partner Id. 0 is for EvenPlay
   *
   * @generated from field: int64 partner_id = 34;
   */
  partnerId: bigint;

  /**
   * Partner Identifier. Partner Id and Partner User Identifier will be used to uniquely identify user.
   *
   * @generated from field: string partner_user_identifier = 35;
   */
  partnerUserIdentifier: string;
};

/**
 * Describes the message qb.smg.PartnerUserIdentifier.
 * Use `create(PartnerUserIdentifierSchema)` to create a new message.
 */
export const PartnerUserIdentifierSchema: GenMessage<PartnerUserIdentifier> = /*@__PURE__*/
  messageDesc(file_smg_service, 189);

/**
 * *
 * Comprehensive information about a user's profile.
 *
 * @generated from message qb.smg.User
 */
export type User = Message<"qb.smg.User"> & {
  /**
   * Unique identifier for the user
   *
   * @generated from field: int64 user_id = 1;
   */
  userId: bigint;

  /**
   * Partner User identifier
   *
   * @generated from field: qb.smg.PartnerUserIdentifier partner_user_identifier = 34;
   */
  partnerUserIdentifier?: PartnerUserIdentifier;

  /**
   * Display name shown in the application
   *
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * User's email address for communications
   *
   * @generated from field: string email_address = 3;
   */
  emailAddress: string;

  /**
   * Current balance in the user's wallet
   *
   * @generated from field: int64 balance = 4;
   */
  balance: bigint;

  /**
   * Whether the user is right or left handed
   *
   * @generated from field: string handedness = 5;
   */
  handedness: string;

  /**
   * User's contact phone number
   *
   * @generated from field: string phone_number = 6;
   */
  phoneNumber: string;

  /**
   * User's first name
   *
   * @generated from field: string firstname = 7;
   */
  firstname: string;

  /**
   * User's middle name
   *
   * @generated from field: string middle_name = 8;
   */
  middleName: string;

  /**
   * User's last name
   *
   * @generated from field: string lastname = 9;
   */
  lastname: string;

  /**
   * User's street address
   *
   * @generated from field: string address = 10;
   */
  address: string;

  /**
   * User's country of residence
   *
   * @generated from field: string country = 11;
   */
  country: string;

  /**
   * User's state or province
   *
   * @generated from field: string state = 12;
   */
  state: string;

  /**
   * User's city
   *
   * @generated from field: string city = 13;
   */
  city: string;

  /**
   * User's postal or ZIP code
   *
   * @generated from field: string zipcode = 14;
   */
  zipcode: string;

  /**
   * Whether user has accepted terms and conditions
   *
   * @generated from field: bool tnc_accepted = 15;
   */
  tncAccepted: boolean;

  /**
   * Timestamp when terms were accepted
   *
   * @generated from field: int64 tnc_accept_date = 16;
   */
  tncAcceptDate: bigint;

  /**
   * Version of terms that was accepted
   *
   * @generated from field: string tnc_accepted_version = 17;
   */
  tncAcceptedVersion: string;

  /**
   * Whether user's profile photo has been approved
   *
   * @generated from field: bool photo_accepted = 19;
   */
  photoAccepted: boolean;

  /**
   * KYC verification status (0=not attempted, 1=passed, 2=failed)
   *
   * @generated from field: int32 kyc_status = 20;
   */
  kycStatus: number;

  /**
   * User's date of birth in YYYY-MM-DD format
   *
   * @generated from field: string date_of_birth = 21;
   */
  dateOfBirth: string;

  /**
   * User's verified legal name
   *
   * @generated from field: string real_name = 22;
   */
  realName: string;

  /**
   * Whether user's email has been confirmed
   *
   * @generated from field: bool email_confirmed = 23;
   */
  emailConfirmed: boolean;

  /**
   * User's golf handicap
   *
   * @generated from field: string handicap = 24;
   */
  handicap: string;

  /**
   * Whether user allows text notifications
   *
   * @generated from field: bool allow_text_notifications = 25;
   */
  allowTextNotifications: boolean;

  /**
   * Whether user allows email notifications
   *
   * @generated from field: bool allow_email_notifications = 26;
   */
  allowEmailNotifications: boolean;

  /**
   * Whether user allows partner promotions
   *
   * @generated from field: bool allow_partner_promos = 27;
   */
  allowPartnerPromos: boolean;

  /**
   * Whether user has confirmed self-limitation
   *
   * @generated from field: bool self_limitation_confirmed = 28;
   */
  selfLimitationConfirmed: boolean;

  /**
   * Timestamp when self-limitation expires
   *
   * @generated from field: int64 self_limitation_expiration = 29;
   */
  selfLimitationExpiration: bigint;

  /**
   * Whether auto-play is enabled for this user
   *
   * @generated from field: bool auto_play_enabled = 30;
   */
  autoPlayEnabled: boolean;

  /**
   * Amount to bet when auto-play is enabled
   *
   * @generated from field: int32 auto_play_amount = 31;
   */
  autoPlayAmount: number;

  /**
   * Amount of last accepted bet outside of auto-play (-2 means max amount)
   *
   * @generated from field: int32 last_bet_amount = 32;
   */
  lastBetAmount: number;

  /**
   * @generated from field: qb.smg.Gender gender = 33;
   */
  gender: Gender;

  /**
   * User's autoplay balance status
   *
   * @generated from field: qb.smg.AutoPlayBalanceStatus auto_play_balance_status = 35;
   */
  autoPlayBalanceStatus: AutoPlayBalanceStatus;
};

/**
 * Describes the message qb.smg.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_smg_service, 190);

/**
 * @generated from message qb.smg.Location
 */
export type Location = Message<"qb.smg.Location"> & {
  /**
   * @generated from field: double latitude = 1;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 2;
   */
  longitude: number;
};

/**
 * Describes the message qb.smg.Location.
 * Use `create(LocationSchema)` to create a new message.
 */
export const LocationSchema: GenMessage<Location> = /*@__PURE__*/
  messageDesc(file_smg_service, 191);

/**
 * @generated from message qb.smg.VenueConfig
 */
export type VenueConfig = Message<"qb.smg.VenueConfig"> & {
  /**
   * @generated from field: string facial_recognition_server_address = 1;
   */
  facialRecognitionServerAddress: string;
};

/**
 * Describes the message qb.smg.VenueConfig.
 * Use `create(VenueConfigSchema)` to create a new message.
 */
export const VenueConfigSchema: GenMessage<VenueConfig> = /*@__PURE__*/
  messageDesc(file_smg_service, 192);

/**
 * *
 * Error is the information passed back from a microservice to indicate the state of a request.
 *
 * @generated from message qb.smg.Error
 */
export type Error = Message<"qb.smg.Error"> & {
  /**
   * The numeric code for this error.
   *
   * @generated from field: int64 code = 1;
   */
  code: bigint;

  /**
   * The informative message for this error.
   *
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message qb.smg.Error.
 * Use `create(ErrorSchema)` to create a new message.
 */
export const ErrorSchema: GenMessage<Error> = /*@__PURE__*/
  messageDesc(file_smg_service, 193);

/**
 * *
 * Record of a financial transaction in a user's account history.
 *
 * @generated from message qb.smg.TransactionHistory
 */
export type TransactionHistory = Message<"qb.smg.TransactionHistory"> & {
  /**
   * ID of the player associated with this transaction
   *
   * @generated from field: uint64 playerId = 1;
   */
  playerId: bigint;

  /**
   * Type of transaction (e.g., "bet", "win", "deposit", "withdrawal")
   *
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * Timestamp when the transaction occurred
   *
   * @generated from field: int64 time = 3;
   */
  time: bigint;

  /**
   * Amount of the transaction
   *
   * @generated from field: int64 amount = 4;
   */
  amount: bigint;

  /**
   * Current status of the transaction (e.g., "pending", "completed", "failed")
   *
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * Amount won (if applicable)
   *
   * @generated from field: int64 win_amount = 6;
   */
  winAmount: bigint;

  /**
   * Timestamp when the transaction was last updated
   *
   * @generated from field: int64 last_update_time = 7;
   */
  lastUpdateTime: bigint;
};

/**
 * Describes the message qb.smg.TransactionHistory.
 * Use `create(TransactionHistorySchema)` to create a new message.
 */
export const TransactionHistorySchema: GenMessage<TransactionHistory> = /*@__PURE__*/
  messageDesc(file_smg_service, 194);

/**
 * @generated from message qb.smg.SetWelcomeBonusRequest
 */
export type SetWelcomeBonusRequest = Message<"qb.smg.SetWelcomeBonusRequest"> & {
  /**
   * @generated from field: int64 bonus_id = 1;
   */
  bonusId: bigint;

  /**
   * @generated from field: int32 days_before_expire = 2;
   */
  daysBeforeExpire: number;

  /**
   * @generated from field: int64 amount = 3;
   */
  amount: bigint;

  /**
   * @generated from field: int64 turnover_amount = 4;
   */
  turnoverAmount: bigint;

  /**
   * @generated from field: bool enabled = 5;
   */
  enabled: boolean;
};

/**
 * Describes the message qb.smg.SetWelcomeBonusRequest.
 * Use `create(SetWelcomeBonusRequestSchema)` to create a new message.
 */
export const SetWelcomeBonusRequestSchema: GenMessage<SetWelcomeBonusRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 195);

/**
 * @generated from message qb.smg.SetWelcomeBonusResponse
 */
export type SetWelcomeBonusResponse = Message<"qb.smg.SetWelcomeBonusResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.SetWelcomeBonusResponse.
 * Use `create(SetWelcomeBonusResponseSchema)` to create a new message.
 */
export const SetWelcomeBonusResponseSchema: GenMessage<SetWelcomeBonusResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 196);

/**
 * @generated from message qb.smg.EnableShawWalletRequest
 */
export type EnableShawWalletRequest = Message<"qb.smg.EnableShawWalletRequest"> & {
  /**
   * @generated from field: int32 user_id = 1;
   */
  userId: number;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * @generated from field: string token = 3;
   */
  token: string;
};

/**
 * Describes the message qb.smg.EnableShawWalletRequest.
 * Use `create(EnableShawWalletRequestSchema)` to create a new message.
 */
export const EnableShawWalletRequestSchema: GenMessage<EnableShawWalletRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 197);

/**
 * @generated from message qb.smg.EnableShawWalletResponse
 */
export type EnableShawWalletResponse = Message<"qb.smg.EnableShawWalletResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.EnableShawWalletResponse.
 * Use `create(EnableShawWalletResponseSchema)` to create a new message.
 */
export const EnableShawWalletResponseSchema: GenMessage<EnableShawWalletResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 198);

/**
 * @generated from message qb.smg.ResetKycRequest
 */
export type ResetKycRequest = Message<"qb.smg.ResetKycRequest"> & {
  /**
   * @generated from field: int64 player_id = 1;
   */
  playerId: bigint;

  /**
   * @generated from field: string token = 2;
   */
  token: string;
};

/**
 * Describes the message qb.smg.ResetKycRequest.
 * Use `create(ResetKycRequestSchema)` to create a new message.
 */
export const ResetKycRequestSchema: GenMessage<ResetKycRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 199);

/**
 * @generated from message qb.smg.ResetKycReply
 */
export type ResetKycReply = Message<"qb.smg.ResetKycReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.ResetKycReply.
 * Use `create(ResetKycReplySchema)` to create a new message.
 */
export const ResetKycReplySchema: GenMessage<ResetKycReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 200);

/**
 * @generated from message qb.smg.GetPromosRequest
 */
export type GetPromosRequest = Message<"qb.smg.GetPromosRequest"> & {
  /**
   * @generated from field: int64 player_id = 1;
   */
  playerId: bigint;

  /**
   * @generated from field: string token = 2;
   */
  token: string;
};

/**
 * Describes the message qb.smg.GetPromosRequest.
 * Use `create(GetPromosRequestSchema)` to create a new message.
 */
export const GetPromosRequestSchema: GenMessage<GetPromosRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 201);

/**
 * @generated from message qb.smg.GetPromosResponse
 */
export type GetPromosResponse = Message<"qb.smg.GetPromosResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated qb.smg.Promo promos = 3;
   */
  promos: Promo[];
};

/**
 * Describes the message qb.smg.GetPromosResponse.
 * Use `create(GetPromosResponseSchema)` to create a new message.
 */
export const GetPromosResponseSchema: GenMessage<GetPromosResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 202);

/**
 * *
 * Information about a promotional offer.
 *
 * @generated from message qb.smg.Promo
 */
export type Promo = Message<"qb.smg.Promo"> & {
  /**
   * Unique identifier for the promotion
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * Display name of the promotion
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Type of promotion (e.g., "bonus", "free play", "cashback")
   *
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * Amount of the promotion
   *
   * @generated from field: int64 amount = 4;
   */
  amount: bigint;

  /**
   * Amount that must be wagered before promotion funds can be withdrawn
   *
   * @generated from field: int64 turnover_amount = 5;
   */
  turnoverAmount: bigint;

  /**
   * Current status of the promotion (e.g., "active", "expired", "redeemed")
   *
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * Timestamp when the promotion expires
   *
   * @generated from field: int64 expiration_date = 7;
   */
  expirationDate: bigint;

  /**
   * @generated from field: int64 bonus_id = 8;
   */
  bonusId: bigint;
};

/**
 * Describes the message qb.smg.Promo.
 * Use `create(PromoSchema)` to create a new message.
 */
export const PromoSchema: GenMessage<Promo> = /*@__PURE__*/
  messageDesc(file_smg_service, 203);

/**
 * @generated from message qb.smg.ActivatePromoRequest
 */
export type ActivatePromoRequest = Message<"qb.smg.ActivatePromoRequest"> & {
  /**
   * @generated from field: string promoCode = 1;
   */
  promoCode: string;

  /**
   * @generated from field: string token = 2;
   */
  token: string;
};

/**
 * Describes the message qb.smg.ActivatePromoRequest.
 * Use `create(ActivatePromoRequestSchema)` to create a new message.
 */
export const ActivatePromoRequestSchema: GenMessage<ActivatePromoRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 204);

/**
 * @generated from message qb.smg.ActivatePromoResponse
 */
export type ActivatePromoResponse = Message<"qb.smg.ActivatePromoResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: qb.smg.Promo activatedPromo = 3;
   */
  activatedPromo?: Promo;
};

/**
 * Describes the message qb.smg.ActivatePromoResponse.
 * Use `create(ActivatePromoResponseSchema)` to create a new message.
 */
export const ActivatePromoResponseSchema: GenMessage<ActivatePromoResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 205);

/**
 * @generated from message qb.smg.ListActiveTournamentsRequest
 */
export type ListActiveTournamentsRequest = Message<"qb.smg.ListActiveTournamentsRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message qb.smg.ListActiveTournamentsRequest.
 * Use `create(ListActiveTournamentsRequestSchema)` to create a new message.
 */
export const ListActiveTournamentsRequestSchema: GenMessage<ListActiveTournamentsRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 206);

/**
 * @generated from message qb.smg.ListActiveTournamentsReply
 */
export type ListActiveTournamentsReply = Message<"qb.smg.ListActiveTournamentsReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated qb.smg.Tournament tournaments = 3;
   */
  tournaments: Tournament[];
};

/**
 * Describes the message qb.smg.ListActiveTournamentsReply.
 * Use `create(ListActiveTournamentsReplySchema)` to create a new message.
 */
export const ListActiveTournamentsReplySchema: GenMessage<ListActiveTournamentsReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 207);

/**
 * @generated from message qb.smg.GetTournamentForSimulatorRequest
 */
export type GetTournamentForSimulatorRequest = Message<"qb.smg.GetTournamentForSimulatorRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 station_id = 2;
   */
  stationId: bigint;

  /**
   * @generated from field: int64 tournament_id = 3;
   */
  tournamentId: bigint;
};

/**
 * Describes the message qb.smg.GetTournamentForSimulatorRequest.
 * Use `create(GetTournamentForSimulatorRequestSchema)` to create a new message.
 */
export const GetTournamentForSimulatorRequestSchema: GenMessage<GetTournamentForSimulatorRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 208);

/**
 * @generated from message qb.smg.GetTournamentForSimulatorReply
 */
export type GetTournamentForSimulatorReply = Message<"qb.smg.GetTournamentForSimulatorReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: qb.smg.Tournament tournament = 3;
   */
  tournament?: Tournament;
};

/**
 * Describes the message qb.smg.GetTournamentForSimulatorReply.
 * Use `create(GetTournamentForSimulatorReplySchema)` to create a new message.
 */
export const GetTournamentForSimulatorReplySchema: GenMessage<GetTournamentForSimulatorReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 209);

/**
 * @generated from message qb.smg.GetTournamentScheduleRequest
 */
export type GetTournamentScheduleRequest = Message<"qb.smg.GetTournamentScheduleRequest"> & {
  /**
   * Authentication token
   *
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message qb.smg.GetTournamentScheduleRequest.
 * Use `create(GetTournamentScheduleRequestSchema)` to create a new message.
 */
export const GetTournamentScheduleRequestSchema: GenMessage<GetTournamentScheduleRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 210);

/**
 * @generated from message qb.smg.GetTournamentScheduleReply
 */
export type GetTournamentScheduleReply = Message<"qb.smg.GetTournamentScheduleReply"> & {
  /**
   * Whether the request was successful
   *
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * Error details if request failed
   *
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: repeated qb.smg.LevelTournamentList levels = 3;
   */
  levels: LevelTournamentList[];
};

/**
 * Describes the message qb.smg.GetTournamentScheduleReply.
 * Use `create(GetTournamentScheduleReplySchema)` to create a new message.
 */
export const GetTournamentScheduleReplySchema: GenMessage<GetTournamentScheduleReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 211);

/**
 * @generated from message qb.smg.GetTournamentPrizeDistributionRequest
 */
export type GetTournamentPrizeDistributionRequest = Message<"qb.smg.GetTournamentPrizeDistributionRequest"> & {
  /**
   * Authentication token
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * ID of the tournament to retrieve
   *
   * @generated from field: int32 tournament_id = 2;
   */
  tournamentId: number;
};

/**
 * Describes the message qb.smg.GetTournamentPrizeDistributionRequest.
 * Use `create(GetTournamentPrizeDistributionRequestSchema)` to create a new message.
 */
export const GetTournamentPrizeDistributionRequestSchema: GenMessage<GetTournamentPrizeDistributionRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 212);

/**
 * @generated from message qb.smg.GetTournamentPrizeDistributionReply
 */
export type GetTournamentPrizeDistributionReply = Message<"qb.smg.GetTournamentPrizeDistributionReply"> & {
  /**
   * Whether the request was successful
   *
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * Error details if request failed
   *
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * @generated from field: qb.smg.TournamentPrizeDistribution tournament_prize_distribution = 3;
   */
  tournamentPrizeDistribution?: TournamentPrizeDistribution;
};

/**
 * Describes the message qb.smg.GetTournamentPrizeDistributionReply.
 * Use `create(GetTournamentPrizeDistributionReplySchema)` to create a new message.
 */
export const GetTournamentPrizeDistributionReplySchema: GenMessage<GetTournamentPrizeDistributionReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 213);

/**
 * @generated from message qb.smg.PinTournamentRequest
 */
export type PinTournamentRequest = Message<"qb.smg.PinTournamentRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 station_id = 3;
   */
  stationId: bigint;

  /**
   * @generated from field: int64 tournament_id = 4;
   */
  tournamentId: bigint;

  /**
   * @generated from field: int64 player_id = 5;
   */
  playerId: bigint;
};

/**
 * Describes the message qb.smg.PinTournamentRequest.
 * Use `create(PinTournamentRequestSchema)` to create a new message.
 */
export const PinTournamentRequestSchema: GenMessage<PinTournamentRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 214);

/**
 * @generated from message qb.smg.PinTournamentReply
 */
export type PinTournamentReply = Message<"qb.smg.PinTournamentReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.PinTournamentReply.
 * Use `create(PinTournamentReplySchema)` to create a new message.
 */
export const PinTournamentReplySchema: GenMessage<PinTournamentReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 215);

/**
 * @generated from message qb.smg.UnPinTournamentRequest
 */
export type UnPinTournamentRequest = Message<"qb.smg.UnPinTournamentRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 station_id = 3;
   */
  stationId: bigint;

  /**
   * @generated from field: int64 tournament_id = 4;
   */
  tournamentId: bigint;
};

/**
 * Describes the message qb.smg.UnPinTournamentRequest.
 * Use `create(UnPinTournamentRequestSchema)` to create a new message.
 */
export const UnPinTournamentRequestSchema: GenMessage<UnPinTournamentRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 216);

/**
 * @generated from message qb.smg.UnPinTournamentReply
 */
export type UnPinTournamentReply = Message<"qb.smg.UnPinTournamentReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.UnPinTournamentReply.
 * Use `create(UnPinTournamentReplySchema)` to create a new message.
 */
export const UnPinTournamentReplySchema: GenMessage<UnPinTournamentReply> = /*@__PURE__*/
  messageDesc(file_smg_service, 217);

/**
 * @generated from message qb.smg.GetWinLostStatementEmailRequest
 */
export type GetWinLostStatementEmailRequest = Message<"qb.smg.GetWinLostStatementEmailRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int32 year = 2;
   */
  year: number;
};

/**
 * Describes the message qb.smg.GetWinLostStatementEmailRequest.
 * Use `create(GetWinLostStatementEmailRequestSchema)` to create a new message.
 */
export const GetWinLostStatementEmailRequestSchema: GenMessage<GetWinLostStatementEmailRequest> = /*@__PURE__*/
  messageDesc(file_smg_service, 218);

/**
 * @generated from message qb.smg.GetWinLostStatementEmailResponse
 */
export type GetWinLostStatementEmailResponse = Message<"qb.smg.GetWinLostStatementEmailResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.GetWinLostStatementEmailResponse.
 * Use `create(GetWinLostStatementEmailResponseSchema)` to create a new message.
 */
export const GetWinLostStatementEmailResponseSchema: GenMessage<GetWinLostStatementEmailResponse> = /*@__PURE__*/
  messageDesc(file_smg_service, 219);

/**
 * *
 * Represents the possible states of a tournament.
 *
 * @generated from enum qb.smg.TournamentState
 */
export enum TournamentState {
  /**
   * Tournament is created but not yet started
   *
   * @generated from enum value: PENDING = 0;
   */
  PENDING = 0,

  /**
   * Tournament is published and visible to users
   *
   * @generated from enum value: PUBLISHED = 1;
   */
  PUBLISHED = 1,

  /**
   * Tournament is currently in progress
   *
   * @generated from enum value: PLAYING = 2;
   */
  PLAYING = 2,

  /**
   * Tournament has completed
   *
   * @generated from enum value: FINISHED = 3;
   */
  FINISHED = 3,

  /**
   * Tournament was cancelled before completion
   *
   * @generated from enum value: CANCELLED = 4;
   */
  CANCELLED = 4,

  /**
   * Tournament was voided (results invalidated)
   *
   * @generated from enum value: VOIDED = 5;
   */
  VOIDED = 5,
}

/**
 * Describes the enum qb.smg.TournamentState.
 */
export const TournamentStateSchema: GenEnum<TournamentState> = /*@__PURE__*/
  enumDesc(file_smg_service, 0);

/**
 * @generated from enum qb.smg.TournamentJoinOptions
 */
export enum TournamentJoinOptions {
  /**
   * Player can join only with money
   *
   * @generated from enum value: ONLY_MONEY = 0;
   */
  ONLY_MONEY = 0,

  /**
   * Player can join only with ticket
   *
   * @generated from enum value: ONLY_TICKET = 1;
   */
  ONLY_TICKET = 1,

  /**
   * Player needs to have a ticket and pay entree fee to join (both at the same time)
   *
   * @generated from enum value: MONEY_AND_TICKET = 2;
   */
  MONEY_AND_TICKET = 2,

  /**
   * Player needs either have a ticket or pay entree fee to join
   *
   * @generated from enum value: MONEY_OR_TICKET = 3;
   */
  MONEY_OR_TICKET = 3,
}

/**
 * Describes the enum qb.smg.TournamentJoinOptions.
 */
export const TournamentJoinOptionsSchema: GenEnum<TournamentJoinOptions> = /*@__PURE__*/
  enumDesc(file_smg_service, 1);

/**
 * @generated from enum qb.smg.TournamentSurveyQuestionType
 */
export enum TournamentSurveyQuestionType {
  /**
   * @generated from enum value: TEXT_ENTRY = 0;
   */
  TEXT_ENTRY = 0,

  /**
   * @generated from enum value: DROPDOWN = 1;
   */
  DROPDOWN = 1,

  /**
   * @generated from enum value: MULTI_CHOICE = 2;
   */
  MULTI_CHOICE = 2,
}

/**
 * Describes the enum qb.smg.TournamentSurveyQuestionType.
 */
export const TournamentSurveyQuestionTypeSchema: GenEnum<TournamentSurveyQuestionType> = /*@__PURE__*/
  enumDesc(file_smg_service, 2);

/**
 * @generated from enum qb.smg.ChangeType
 */
export enum ChangeType {
  /**
   * @generated from enum value: ADDRESS = 0;
   */
  ADDRESS = 0,

  /**
   * @generated from enum value: PHOTO = 1;
   */
  PHOTO = 1,
}

/**
 * Describes the enum qb.smg.ChangeType.
 */
export const ChangeTypeSchema: GenEnum<ChangeType> = /*@__PURE__*/
  enumDesc(file_smg_service, 3);

/**
 * @generated from enum qb.smg.OtpMethod
 */
export enum OtpMethod {
  /**
   * @generated from enum value: EMAIL = 0;
   */
  EMAIL = 0,

  /**
   * @generated from enum value: SMS = 1;
   */
  SMS = 1,
}

/**
 * Describes the enum qb.smg.OtpMethod.
 */
export const OtpMethodSchema: GenEnum<OtpMethod> = /*@__PURE__*/
  enumDesc(file_smg_service, 4);

/**
 * @generated from enum qb.smg.Gender
 */
export enum Gender {
  /**
   * @generated from enum value: UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MALE = 1;
   */
  MALE = 1,

  /**
   * @generated from enum value: FEMALE = 2;
   */
  FEMALE = 2,
}

/**
 * Describes the enum qb.smg.Gender.
 */
export const GenderSchema: GenEnum<Gender> = /*@__PURE__*/
  enumDesc(file_smg_service, 5);

/**
 * @generated from enum qb.smg.ReplacePhotoStatus
 */
export enum ReplacePhotoStatus {
  /**
   * @generated from enum value: Open = 0;
   */
  Open = 0,

  /**
   * @generated from enum value: Approved = 1;
   */
  Approved = 1,

  /**
   * @generated from enum value: Declined = 2;
   */
  Declined = 2,
}

/**
 * Describes the enum qb.smg.ReplacePhotoStatus.
 */
export const ReplacePhotoStatusSchema: GenEnum<ReplacePhotoStatus> = /*@__PURE__*/
  enumDesc(file_smg_service, 6);

/**
 * @generated from enum qb.smg.StationPlayerState
 */
export enum StationPlayerState {
  /**
   * @generated from enum value: NO_PLAYER = 0;
   */
  NO_PLAYER = 0,

  /**
   * @generated from enum value: GUEST = 1;
   */
  GUEST = 1,

  /**
   * @generated from enum value: PLAYER = 2;
   */
  PLAYER = 2,

  /**
   * @generated from enum value: PLAYER_DELAY = 3;
   */
  PLAYER_DELAY = 3,

  /**
   * @generated from enum value: MULTI_PLAYER = 4;
   */
  MULTI_PLAYER = 4,

  /**
   * @generated from enum value: PLAYER_NOT_IN_GAMEPLAY_AREA = 5;
   */
  PLAYER_NOT_IN_GAMEPLAY_AREA = 5,
}

/**
 * Describes the enum qb.smg.StationPlayerState.
 */
export const StationPlayerStateSchema: GenEnum<StationPlayerState> = /*@__PURE__*/
  enumDesc(file_smg_service, 7);

/**
 * @generated from enum qb.smg.AutoPlayBalanceStatus
 */
export enum AutoPlayBalanceStatus {
  /**
   * Balance is sufficient for configured bet amount
   *
   * @generated from enum value: BALANCE_OK = 0;
   */
  BALANCE_OK = 0,

  /**
   * Bet amount was reduced due to insufficient balance
   *
   * @generated from enum value: BALANCE_DOWNSHIFTED = 1;
   */
  BALANCE_DOWNSHIFTED = 1,

  /**
   * Balance is below minimum bet tier; autoplay disabled
   *
   * @generated from enum value: BALANCE_INSUFFICIENT = 2;
   */
  BALANCE_INSUFFICIENT = 2,
}

/**
 * Describes the enum qb.smg.AutoPlayBalanceStatus.
 */
export const AutoPlayBalanceStatusSchema: GenEnum<AutoPlayBalanceStatus> = /*@__PURE__*/
  enumDesc(file_smg_service, 8);

/**
 * *
 * The smg service for kiosk and simulator operations.
 *
 * @generated from service qb.smg.SmgService
 */
export const SmgService: GenService<{
  /**
   * *
   * Register a new user in the system.
   *
   * @generated from rpc qb.smg.SmgService.RegisterUser
   */
  registerUser: {
    methodKind: "unary";
    input: typeof RegisterUserRequestSchema;
    output: typeof RegisterUserReplySchema;
  },
  /**
   * *
   * Initiates the process to reset a user's PIN.
   *
   * @generated from rpc qb.smg.SmgService.RequestResetPin
   */
  requestResetPin: {
    methodKind: "unary";
    input: typeof RequestResetPinRequestSchema;
    output: typeof RequestResetPinReplySchema;
  },
  /**
   * *
   * Resends the email confirmation to a user's email address.
   *
   * @generated from rpc qb.smg.SmgService.ResendEmailConfirmation
   */
  resendEmailConfirmation: {
    methodKind: "unary";
    input: typeof ResendEmailConfirmationRequestSchema;
    output: typeof ResendEmailConfirmationReplySchema;
  },
  /**
   * *
   * Confirms a user's email address using a verification code.
   *
   * @generated from rpc qb.smg.SmgService.ConfirmEmail
   */
  confirmEmail: {
    methodKind: "unary";
    input: typeof ConfirmEmailRequestSchema;
    output: typeof ConfirmEmailReplySchema;
  },
  /**
   * *
   * Completes the PIN reset process with a verification code.
   *
   * @generated from rpc qb.smg.SmgService.DoResetPin
   */
  doResetPin: {
    methodKind: "unary";
    input: typeof DoResetPinRequestSchema;
    output: typeof DoResetPinReplySchema;
  },
  /**
   * *
   * Locates venues based on specified criteria.
   *
   * @generated from rpc qb.smg.SmgService.LocateVenue
   */
  locateVenue: {
    methodKind: "unary";
    input: typeof LocateVenueRequestSchema;
    output: typeof LocateVenueReplySchema;
  },
  /**
   * *
   * Checks if an email address is already registered in the system.
   *
   * @generated from rpc qb.smg.SmgService.CheckUserEmailExists
   */
  checkUserEmailExists: {
    methodKind: "unary";
    input: typeof CheckUserEmailExistsRequestSchema;
    output: typeof CheckUserEmailExistsReplySchema;
  },
  /**
   * *
   * Creates a request to change a user's profile photo.
   *
   * @generated from rpc qb.smg.SmgService.RequestChangePhoto
   */
  requestChangePhoto: {
    methodKind: "unary";
    input: typeof RequestChangePhotoRequestSchema;
    output: typeof RequestChangePhotoReplySchema;
  },
  /**
   * *
   * Retrieves pending photo change requests.
   *
   * @generated from rpc qb.smg.SmgService.GetChangePhotoRequests
   */
  getChangePhotoRequests: {
    methodKind: "unary";
    input: typeof GetChangePhotoRequestsRequestSchema;
    output: typeof GetChangePhotoRequestsReplySchema;
  },
  /**
   * *
   * Approves a pending photo change request.
   *
   * @generated from rpc qb.smg.SmgService.ApproveChangePhotoRequest
   */
  approveChangePhotoRequest: {
    methodKind: "unary";
    input: typeof ApproveChangePhotoRequestRequestSchema;
    output: typeof ApproveChangePhotoRequestReplySchema;
  },
  /**
   * *
   * Retrieves the current Terms & Conditions.
   *
   * @generated from rpc qb.smg.SmgService.GetTnc
   */
  getTnc: {
    methodKind: "unary";
    input: typeof GetTncRequestSchema;
    output: typeof GetTncReplySchema;
  },
  /**
   * *
   * Records a user's acceptance of the Terms & Conditions.
   *
   * @generated from rpc qb.smg.SmgService.AcceptTnc
   */
  acceptTnc: {
    methodKind: "unary";
    input: typeof AcceptTncRequestSchema;
    output: typeof AcceptTncReplySchema;
  },
  /**
   * *
   * Initiates the Veriff KYC verification process.
   *
   * @generated from rpc qb.smg.SmgService.StartVeriffKycVerification
   */
  startVeriffKycVerification: {
    methodKind: "unary";
    input: typeof StartVeriffKycVerificationRequestSchema;
    output: typeof StartVeriffKycVerificationResponseSchema;
  },
  /**
   * *
   * Submits a photo for user verification (verification step 3).
   *
   * @generated from rpc qb.smg.SmgService.SubmitPhoto
   */
  submitPhoto: {
    methodKind: "unary";
    input: typeof SubmitPhotoRequestSchema;
    output: typeof SubmitPhotoReplySchema;
  },
  /**
   * *
   * Submits a contact request to customer service.
   *
   * @generated from rpc qb.smg.SmgService.ContactCsr
   */
  contactCsr: {
    methodKind: "unary";
    input: typeof ContactCsrRequestSchema;
    output: typeof ContactCsrReplySchema;
  },
  /**
   * *
   * Updates user profile information.
   *
   * @generated from rpc qb.smg.SmgService.UpdateUser
   */
  updateUser: {
    methodKind: "unary";
    input: typeof UpdateUserRequestSchema;
    output: typeof UpdateUserReplySchema;
  },
  /**
   * *
   * Authenticates a user using email and password.
   *
   * @generated from rpc qb.smg.SmgService.EmailLogin
   */
  emailLogin: {
    methodKind: "unary";
    input: typeof EmailLoginRequestSchema;
    output: typeof EmailLoginReplySchema;
  },
  /**
   * *
   * Authenticates a user using facial recognition.
   *
   * @generated from rpc qb.smg.SmgService.ImageLogin
   */
  imageLogin: {
    methodKind: "unary";
    input: typeof ImageLoginRequestSchema;
    output: typeof ImageLoginReplySchema;
  },
  /**
   * *
   * Requests a one-time password code for authentication.
   *
   * @generated from rpc qb.smg.SmgService.RequestOtpCode
   */
  requestOtpCode: {
    methodKind: "unary";
    input: typeof RequestOtpCodeRequestSchema;
    output: typeof RequestOtpCodeReplySchema;
  },
  /**
   * *
   * Retrieves a one-time password code for administrative purposes.
   *
   * @generated from rpc qb.smg.SmgService.RetrieveOtpCodeForAdmin
   */
  retrieveOtpCodeForAdmin: {
    methodKind: "unary";
    input: typeof RetrieveCodeForAdminRequestSchema;
    output: typeof RetrieveCodeForAdminReplySchema;
  },
  /**
   * *
   * Enables self-limitation, to prevent playing for particular time.
   *
   * @generated from rpc qb.smg.SmgService.EnableSelfLimitation
   */
  enableSelfLimitation: {
    methodKind: "unary";
    input: typeof EnableSelfLimitationRequestSchema;
    output: typeof EnableSelfLimitationReplySchema;
  },
  /**
   * *
   * Authenticates a user using a one-time password.
   *
   * @generated from rpc qb.smg.SmgService.OtpLogin
   */
  otpLogin: {
    methodKind: "unary";
    input: typeof OtpLoginRequestSchema;
    output: typeof OtpLoginReplySchema;
  },
  /**
   * *
   * Verifies a one-time password code.
   *
   * @generated from rpc qb.smg.SmgService.VerifyOtpCode
   */
  verifyOtpCode: {
    methodKind: "unary";
    input: typeof VerifyOtpCodeRequestSchema;
    output: typeof VerifyOtpCodeReplySchema;
  },
  /**
   * *
   * Authenticates a user using a JWT ID token.
   *
   * @generated from rpc qb.smg.SmgService.LoginWithIdToken
   */
  loginWithIdToken: {
    methodKind: "unary";
    input: typeof LoginWithIdTokenRequestSchema;
    output: typeof LoginWithIdTokenReplySchema;
  },
  /**
   * *
   * Retrieves user profile information.
   *
   * @generated from rpc qb.smg.SmgService.GetUser
   */
  getUser: {
    methodKind: "unary";
    input: typeof GetUserRequestSchema;
    output: typeof GetUserReplySchema;
  },
  /**
   * *
   * Retrieves the current balance for a user.
   *
   * @generated from rpc qb.smg.SmgService.GetBalance
   */
  getBalance: {
    methodKind: "unary";
    input: typeof GetBalanceRequestSchema;
    output: typeof GetBalanceReplySchema;
  },
  /**
   * *
   * Refunds a bet that hasn't been resolved yet.
   *
   * @generated from rpc qb.smg.SmgService.RefundBet
   */
  refundBet: {
    methodKind: "unary";
    input: typeof BetResolutionRequestSchema;
    output: typeof BetResolutionReplySchema;
  },
  /**
   * *
   * Cancels a bet that hasn't been resolved yet.
   *
   * @generated from rpc qb.smg.SmgService.CancelBet
   */
  cancelBet: {
    methodKind: "unary";
    input: typeof BetResolutionRequestSchema;
    output: typeof BetResolutionReplySchema;
  },
  /**
   * *
   * Allows an administrator to refund a bet.
   *
   * @generated from rpc qb.smg.SmgService.RefundBetByAdmin
   */
  refundBetByAdmin: {
    methodKind: "unary";
    input: typeof BetResolutionRequestSchema;
    output: typeof BetResolutionReplySchema;
  },
  /**
   * *
   * Allows an administrator to cancel a bet.
   *
   * @generated from rpc qb.smg.SmgService.CancelBetByAdmin
   */
  cancelBetByAdmin: {
    methodKind: "unary";
    input: typeof BetResolutionRequestSchema;
    output: typeof BetResolutionReplySchema;
  },
  /**
   * *
   * Retrieves all payouts for a user.
   *
   * @generated from rpc qb.smg.SmgService.GetPayouts
   */
  getPayouts: {
    methodKind: "unary";
    input: typeof GetPayoutRequestSchema;
    output: typeof GetPayoutReplySchema;
  },
  /**
   * *
   * Retrieves all bets available to a user based on criteria.
   *
   * @generated from rpc qb.smg.SmgService.GetBets
   */
  getBets: {
    methodKind: "unary";
    input: typeof GetBetsRequestSchema;
    output: typeof GetBetsReplySchema;
  },
  /**
   * *
   * Gets upcoming bets specifically for the simulator interface.
   *
   * @generated from rpc qb.smg.SmgService.GetUpcomingBetsForSimulator
   */
  getUpcomingBetsForSimulator: {
    methodKind: "unary";
    input: typeof GetUpcomingBetsForSimulatorRequestSchema;
    output: typeof GetUpcomingBetsForSimulatorReplySchema;
  },
  /**
   * *
   * Streams real-time updates to a user's bets.
   *
   * @generated from rpc qb.smg.SmgService.StreamBets
   */
  streamBets: {
    methodKind: "server_streaming";
    input: typeof StreamBetsRequestSchema;
    output: typeof StreamBetsReplySchema;
  },
  /**
   * *
   * Retrieves information about a specific bet.
   *
   * @generated from rpc qb.smg.SmgService.GetBet
   */
  getBet: {
    methodKind: "unary";
    input: typeof GetBetRequestSchema;
    output: typeof GetBetReplySchema;
  },
  /**
   * *
   * Retrieves a specific bet without requiring a user token.
   *
   * @generated from rpc qb.smg.SmgService.GetBetNoToken
   */
  getBetNoToken: {
    methodKind: "unary";
    input: typeof GetBetNoTokenRequestSchema;
    output: typeof GetBetNoTokenReplySchema;
  },
  /**
   * *
   * Processes a user's acceptance of a bet.
   *
   * @generated from rpc qb.smg.SmgService.AcceptBet
   */
  acceptBet: {
    methodKind: "unary";
    input: typeof AcceptBetRequestSchema;
    output: typeof AcceptBetReplySchema;
  },
  /**
   * *
   * Adjusts the amount of an existing bet.
   *
   * @generated from rpc qb.smg.SmgService.AdjustBet
   */
  adjustBet: {
    methodKind: "unary";
    input: typeof AdjustBetRequestSchema;
    output: typeof AdjustBetReplySchema;
  },
  /**
   * *
   * Initiates a new hit/shot in the simulator.
   *
   * @generated from rpc qb.smg.SmgService.StartHit
   */
  startHit: {
    methodKind: "unary";
    input: typeof StartHitRequestSchema;
    output: typeof StartHitReplySchema;
  },
  /**
   * *
   * Streams hit data in real-time.
   *
   * @generated from rpc qb.smg.SmgService.HitStream
   */
  hitStream: {
    methodKind: "client_streaming";
    input: typeof HitSchema;
    output: typeof HitStreamReplySchema;
  },
  /**
   * *
   * Records a single hit/shot with its metrics.
   *
   * @generated from rpc qb.smg.SmgService.HitSingle
   */
  hitSingle: {
    methodKind: "unary";
    input: typeof HitRequestSchema;
    output: typeof HitReplySchema;
  },
  /**
   * *
   * Streams settings updates to clients.
   *
   * @generated from rpc qb.smg.SmgService.SettingsUpdateStream
   */
  settingsUpdateStream: {
    methodKind: "server_streaming";
    input: typeof SettingsUpdateStreamRequestSchema;
    output: typeof SettingsUpdateSchema;
  },
  /**
   * *
   * Establishes a simple connection to a station.
   *
   * @generated from rpc qb.smg.SmgService.ConnectStationSimple
   */
  connectStationSimple: {
    methodKind: "unary";
    input: typeof ConnectStationSimpleRequestSchema;
    output: typeof ConnectStationSimpleReplySchema;
  },
  /**
   * *
   * Sends a heartbeat to maintain connection status.
   *
   * @generated from rpc qb.smg.SmgService.Heartbeat
   */
  heartbeat: {
    methodKind: "unary";
    input: typeof HeartbeatRequestSchema;
    output: typeof HeartbeatResponseSchema;
  },
  /**
   * *
   * Gets the current game state for a station.
   *
   * @generated from rpc qb.smg.SmgService.GetGameState
   */
  getGameState: {
    methodKind: "unary";
    input: typeof GetGameStateRequestSchema;
    output: typeof GetGameStateReplySchema;
  },
  /**
   * *
   * Streams real-time state updates from a station.
   *
   * @generated from rpc qb.smg.SmgService.StreamStationState
   */
  streamStationState: {
    methodKind: "server_streaming";
    input: typeof StreamStationStateRequestSchema;
    output: typeof StationStateSchema;
  },
  /**
   * *
   * Pushes webcam updates from a station.
   *
   * @generated from rpc qb.smg.SmgService.PushStationWebcamUpdates
   */
  pushStationWebcamUpdates: {
    methodKind: "client_streaming";
    input: typeof StationWebcamUpdateSchema;
    output: typeof PushStationWebcamUpdatesResponseSchema;
  },
  /**
   * *
   * Deletes a user's facial recognition image.
   *
   * @generated from rpc qb.smg.SmgService.DeleteUserImage
   */
  deleteUserImage: {
    methodKind: "unary";
    input: typeof DeleteUserImageRequestSchema;
    output: typeof DeleteUserImageResponseSchema;
  },
  /**
   * *
   * Deletes user images captured before a specified date.
   *
   * @generated from rpc qb.smg.SmgService.DeleteUserImagesBeforeDate
   */
  deleteUserImagesBeforeDate: {
    methodKind: "unary";
    input: typeof DeleteUserImagesBeforeDateRequestSchema;
    output: typeof DeleteUserImagesBeforeDateResponseSchema;
  },
  /**
   * *
   * Disables specified user accounts.
   *
   * @generated from rpc qb.smg.SmgService.DisableUsers
   */
  disableUsers: {
    methodKind: "unary";
    input: typeof DisableUsersRequestSchema;
    output: typeof DisableUsersResponseSchema;
  },
  /**
   * *
   * Toggles the facial recognition system for testing purposes.
   *
   * @generated from rpc qb.smg.SmgService.IgnoreFrs
   */
  ignoreFrs: {
    methodKind: "unary";
    input: typeof IgnoreFrsRequestSchema;
    output: typeof IgnoreFrsResponseSchema;
  },
  /**
   * *
   * Resets the shot counter for a user.
   *
   * @generated from rpc qb.smg.SmgService.ResetShotCount
   */
  resetShotCount: {
    methodKind: "unary";
    input: typeof ResetShotCountRequestSchema;
    output: typeof ResetShotCountResponseSchema;
  },
  /**
   * *
   * Generates a URL for uploading archive videos to S3.
   *
   * @generated from rpc qb.smg.SmgService.GenerateS3ArchiveVideoUploadUrl
   */
  generateS3ArchiveVideoUploadUrl: {
    methodKind: "unary";
    input: typeof GenerateS3ArchiveVideoUploadUrlRequestSchema;
    output: typeof GenerateS3ArchiveVideoUploadUrlResponseSchema;
  },
  /**
   * *
   * Executes commands between FRS and SMG systems.
   *
   * @generated from rpc qb.smg.SmgService.FrsCommandExecutor
   */
  frsCommandExecutor: {
    methodKind: "bidi_streaming";
    input: typeof CommandExecutorFRSPayloadSchema;
    output: typeof CommandExecutorSMGPayloadSchema;
  },
  /**
   * *
   * Retrieves transaction history for a user.
   *
   * @generated from rpc qb.smg.SmgService.GetTransactionHistory
   */
  getTransactionHistory: {
    methodKind: "unary";
    input: typeof GetTransactionHistoryRequestSchema;
    output: typeof GetTransactionHistoryReplySchema;
  },
  /**
   * *
   * Enables or disables auto-play functionality.
   *
   * @generated from rpc qb.smg.SmgService.EnableAutoPlay
   */
  enableAutoPlay: {
    methodKind: "unary";
    input: typeof EnableAutoPlayRequestSchema;
    output: typeof EnableAutoPlayResponseSchema;
  },
  /**
   * *
   * Sets the preferred shot amount without touching autoplay consent.
   * Deliberately no enabled field; no bet or tournament side effects.
   *
   * @generated from rpc qb.smg.SmgService.SetShotAmountPreference
   */
  setShotAmountPreference: {
    methodKind: "unary";
    input: typeof SetShotAmountPreferenceRequestSchema;
    output: typeof SetShotAmountPreferenceResponseSchema;
  },
  /**
   * *
   * Sets a welcome bonus for a user.
   *
   * @generated from rpc qb.smg.SmgService.SetWelcomeBonus
   */
  setWelcomeBonus: {
    methodKind: "unary";
    input: typeof SetWelcomeBonusRequestSchema;
    output: typeof SetWelcomeBonusResponseSchema;
  },
  /**
   * *
   * Enables or disables Shaw wallet integration.
   *
   * @generated from rpc qb.smg.SmgService.EnableShawWallet
   */
  enableShawWallet: {
    methodKind: "unary";
    input: typeof EnableShawWalletRequestSchema;
    output: typeof EnableShawWalletResponseSchema;
  },
  /**
   * *
   * Deactivates a user account.
   *
   * @generated from rpc qb.smg.SmgService.DeactivateAccount
   */
  deactivateAccount: {
    methodKind: "unary";
    input: typeof DeactivateAccountRequestSchema;
    output: typeof DeactivateAccountResponseSchema;
  },
  /**
   * *
   * Initiates the process to change a user's email address.
   *
   * @generated from rpc qb.smg.SmgService.RequestEmailChange
   */
  requestEmailChange: {
    methodKind: "unary";
    input: typeof RequestEmailChangeRequestSchema;
    output: typeof RequestEmailChangeResponseSchema;
  },
  /**
   * *
   * Confirms a previously requested email address change.
   *
   * @generated from rpc qb.smg.SmgService.ConfirmEmailChange
   */
  confirmEmailChange: {
    methodKind: "unary";
    input: typeof ConfirmEmailChangeRequestSchema;
    output: typeof ConfirmEmailChangeResponseSchema;
  },
  /**
   * *
   * Updates a user's phone number.
   *
   * @generated from rpc qb.smg.SmgService.UpdatePhoneNumber
   */
  updatePhoneNumber: {
    methodKind: "unary";
    input: typeof UpdatePhoneNumberRequestSchema;
    output: typeof UpdatePhoneNumberResponseSchema;
  },
  /**
   * *
   * Requests a change to user account information.
   *
   * @generated from rpc qb.smg.SmgService.RequestChange
   */
  requestChange: {
    methodKind: "unary";
    input: typeof RequestChangeRequestSchema;
    output: typeof RequestChangeResponseSchema;
  },
  /**
   * *
   * Generates a URL for uploading simulator videos to S3.
   *
   * @generated from rpc qb.smg.SmgService.GenerateS3SimulatorVideoUploadUrl
   */
  generateS3SimulatorVideoUploadUrl: {
    methodKind: "unary";
    input: typeof GenerateS3SimulatorVideoUploadUrlRequestSchema;
    output: typeof GenerateS3SimulatorVideoUploadUrlResponseSchema;
  },
  /**
   * *
   * Resets a user's KYC verification status.
   *
   * @generated from rpc qb.smg.SmgService.ResetKyc
   */
  resetKyc: {
    methodKind: "unary";
    input: typeof ResetKycRequestSchema;
    output: typeof ResetKycReplySchema;
  },
  /**
   * *
   * Lists available tournaments based on specified criteria.
   *
   * @generated from rpc qb.smg.SmgService.ListTournaments
   */
  listTournaments: {
    methodKind: "unary";
    input: typeof ListTournamentRequestSchema;
    output: typeof ListTournamentReplySchema;
  },
  /**
   * *
   * Lists default tournaments for quick access.
   *
   * @generated from rpc qb.smg.SmgService.ListDefaultTournaments
   */
  listDefaultTournaments: {
    methodKind: "unary";
    input: typeof ListDefaultTournamentRequestSchema;
    output: typeof ListDefaultTournamentReplySchema;
  },
  /**
   * *
   * Registers a user to participate in a tournament.
   *
   * @generated from rpc qb.smg.SmgService.JoinTournament
   */
  joinTournament: {
    methodKind: "unary";
    input: typeof JoinTournamentRequestSchema;
    output: typeof JoinTournamentReplySchema;
  },
  /**
   * *
   * Removes a user from a tournament they previously joined.
   *
   * @generated from rpc qb.smg.SmgService.LeaveTournament
   */
  leaveTournament: {
    methodKind: "unary";
    input: typeof LeaveTournamentRequestSchema;
    output: typeof LeaveTournamentReplySchema;
  },
  /**
   * *
   * Retrieves information about a specific tournament.
   *
   * @generated from rpc qb.smg.SmgService.GetTournament
   */
  getTournament: {
    methodKind: "unary";
    input: typeof GetTournamentRequestSchema;
    output: typeof GetTournamentReplySchema;
  },
  /**
   * *
   * Retrieves the immutable display metadata for a tournament (no player
   * details). Used by the simulator for per-shot lookups where the heavier
   * GetTournament payload is unnecessary. Simulator app-token auth.
   *
   * @generated from rpc qb.smg.SmgService.GetTournamentMetadata
   */
  getTournamentMetadata: {
    methodKind: "unary";
    input: typeof GetTournamentMetadataRequestSchema;
    output: typeof GetTournamentMetadataReplySchema;
  },
  /**
   * *
   * Retrieves the leaderboard for a tournament.
   *
   * @generated from rpc qb.smg.SmgService.GetTournamentLeaderBoard
   */
  getTournamentLeaderBoard: {
    methodKind: "unary";
    input: typeof GetTournamentLeaderBoardRequestSchema;
    output: typeof GetTournamentLeaderBoardReplySchema;
  },
  /**
   * *
   * Gets the list of players participating in a tournament.
   *
   * @generated from rpc qb.smg.SmgService.GetTournamentPlayers
   */
  getTournamentPlayers: {
    methodKind: "unary";
    input: typeof GetTournamentPlayersRequestSchema;
    output: typeof GetTournamentPlayersReplySchema;
  },
  /**
   * *
   * Resolves a single tournament shot so the tournament leaderboard moves.
   * Best-effort write surface used by the bay-session settle path; resolution
   * is idempotent on replay.
   *
   * @generated from rpc qb.smg.SmgService.ResolveTournamentShot
   */
  resolveTournamentShot: {
    methodKind: "unary";
    input: typeof ResolveTournamentShotRequestSchema;
    output: typeof ResolveTournamentShotReplySchema;
  },
  /**
   * *
   * Creates a new private tournament.
   *
   * @generated from rpc qb.smg.SmgService.CreatePrivateTournament
   */
  createPrivateTournament: {
    methodKind: "unary";
    input: typeof CreatePrivateTournamentRequestSchema;
    output: typeof CreatePrivateTournamentReplySchema;
  },
  /**
   * *
   * Registers a user to participate in a private tournament using a code.
   *
   * @generated from rpc qb.smg.SmgService.JoinPrivateTournament
   */
  joinPrivateTournament: {
    methodKind: "unary";
    input: typeof JoinPrivateTournamentRequestSchema;
    output: typeof JoinPrivateTournamentReplySchema;
  },
  /**
   * *
   * Verifies if a private tournament code is valid.
   *
   * @generated from rpc qb.smg.SmgService.VerifyPrivateTournamentCode
   */
  verifyPrivateTournamentCode: {
    methodKind: "unary";
    input: typeof VerifyPrivateTournamentCodeRequestSchema;
    output: typeof VerifyPrivateTournamentCodeReplySchema;
  },
  /**
   * *
   * Retrieves available promotions for a user.
   *
   * @generated from rpc qb.smg.SmgService.GetPromos
   */
  getPromos: {
    methodKind: "unary";
    input: typeof GetPromosRequestSchema;
    output: typeof GetPromosResponseSchema;
  },
  /**
   * *
   * Activates a promotion using a promo code.
   *
   * @generated from rpc qb.smg.SmgService.ActivatePromo
   */
  activatePromo: {
    methodKind: "unary";
    input: typeof ActivatePromoRequestSchema;
    output: typeof ActivatePromoResponseSchema;
  },
  /**
   * *
   * Lists active tournaments for a station.
   *
   * @generated from rpc qb.smg.SmgService.ListActiveTournaments
   */
  listActiveTournaments: {
    methodKind: "unary";
    input: typeof ListActiveTournamentsRequestSchema;
    output: typeof ListActiveTournamentsReplySchema;
  },
  /**
   * *
   * Gets tournament information specifically for the simulator interface.
   *
   * @generated from rpc qb.smg.SmgService.GetTournamentForSimulator
   */
  getTournamentForSimulator: {
    methodKind: "unary";
    input: typeof GetTournamentForSimulatorRequestSchema;
    output: typeof GetTournamentForSimulatorReplySchema;
  },
  /**
   * @generated from rpc qb.smg.SmgService.GetTournamentSchedule
   */
  getTournamentSchedule: {
    methodKind: "unary";
    input: typeof GetTournamentScheduleRequestSchema;
    output: typeof GetTournamentScheduleReplySchema;
  },
  /**
   * @generated from rpc qb.smg.SmgService.GetTournamentPrizeDistribution
   */
  getTournamentPrizeDistribution: {
    methodKind: "unary";
    input: typeof GetTournamentPrizeDistributionRequestSchema;
    output: typeof GetTournamentPrizeDistributionReplySchema;
  },
  /**
   * *
   * Pins a tournament to a station for quick access.
   *
   * @generated from rpc qb.smg.SmgService.PinTournament
   */
  pinTournament: {
    methodKind: "unary";
    input: typeof PinTournamentRequestSchema;
    output: typeof PinTournamentReplySchema;
  },
  /**
   * *
   * Removes a tournament from being pinned to a station.
   *
   * @generated from rpc qb.smg.SmgService.UnPinTournament
   */
  unPinTournament: {
    methodKind: "unary";
    input: typeof UnPinTournamentRequestSchema;
    output: typeof UnPinTournamentReplySchema;
  },
  /**
   * @generated from rpc qb.smg.SmgService.GetWinLostStatementEmail
   */
  getWinLostStatementEmail: {
    methodKind: "unary";
    input: typeof GetWinLostStatementEmailRequestSchema;
    output: typeof GetWinLostStatementEmailResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_smg_service, 0);

